import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  _text: string[];
  bigint: any;
  date: any;
  float8: any;
  name: any;
  numeric: number;
  timestamptz: string;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type IBoolean_Comparison_Exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type ICoachMultilangTranslation = {
  bio?: Maybe<Scalars['String']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IInt_Comparison_Exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type IRegisterCoachInput = {
  address_city: Scalars['String'];
  address_country: Scalars['String'];
  address_postal_code: Scalars['String'];
  address_street: Scalars['String'];
  coach_translations: Array<ICoachMultilangTranslation>;
  email: Scalars['String'];
  fiscal_id_number: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  platform_content_access: Scalars['Boolean'];
  platform_fee: Scalars['Float'];
  profile_picture?: Maybe<Scalars['String']>;
  public: Scalars['Boolean'];
  spoken_languages: Scalars['String'];
  sport_ids: Array<Scalars['String']>;
};

export type IRegisterInput = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  birthday: Scalars['Date'];
  coach_id?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  email_language: Scalars['String'];
  fiscal_id_number?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  max_heart_rate?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  rest_heart_rate?: Maybe<Scalars['Float']>;
  sport_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type IString_Comparison_Exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export type IValidateCoachInput = {
  id: Scalars['Int'];
  is_verified: Scalars['Boolean'];
  mail: Scalars['String'];
  message: Scalars['String'];
  user_id: Scalars['Int'];
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type I_Text_Comparison_Exp = {
  _eq?: Maybe<Scalars['_text']>;
  _gt?: Maybe<Scalars['_text']>;
  _gte?: Maybe<Scalars['_text']>;
  _in?: Maybe<Array<Scalars['_text']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['_text']>;
  _lte?: Maybe<Scalars['_text']>;
  _neq?: Maybe<Scalars['_text']>;
  _nin?: Maybe<Array<Scalars['_text']>>;
};

export type IAthlete_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete" */
export type IAthlete_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Max_Order_By>;
  min?: Maybe<IAthlete_Min_Order_By>;
  stddev?: Maybe<IAthlete_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete" */
export type IAthlete_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_On_Conflict>;
};

/** order by avg() on columns of table "athlete" */
export type IAthlete_Avg_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

export type IAthlete_Biometric_Data_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Biometric_Data_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Biometric_Data_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Biometric_Data_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Biometric_Data_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Biometric_Data_Max_Order_By>;
  min?: Maybe<IAthlete_Biometric_Data_Min_Order_By>;
  stddev?: Maybe<IAthlete_Biometric_Data_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Biometric_Data_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Biometric_Data_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Biometric_Data_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Biometric_Data_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Biometric_Data_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Biometric_Data_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Biometric_Data_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Biometric_Data_On_Conflict>;
};

/** order by avg() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Avg_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_biometric_data". All fields are combined with a logical 'AND'. */
export type IAthlete_Biometric_Data_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Biometric_Data_Bool_Exp>>;
  _not?: Maybe<IAthlete_Biometric_Data_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Biometric_Data_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  athlete_id?: Maybe<IInt_Comparison_Exp>;
  biometric_parameter?: Maybe<IBiometric_Parameter_Bool_Exp>;
  biometric_parameter_id?: Maybe<IString_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  file_url?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  value?: Maybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteBiometricDataPkey = 'athlete_biometric_data_pkey'
}

/** input type for incrementing numeric columns in table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Inc_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: Maybe<Scalars['Int']>;
  biometric_parameter?: Maybe<IBiometric_Parameter_Obj_Rel_Insert_Input>;
  biometric_parameter_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Max_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  biometric_parameter_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  file_url?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Min_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  biometric_parameter_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  file_url?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_On_Conflict = {
  constraint: IAthlete_Biometric_Data_Constraint;
  update_columns?: Array<IAthlete_Biometric_Data_Update_Column>;
  where?: Maybe<IAthlete_Biometric_Data_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_biometric_data". */
export type IAthlete_Biometric_Data_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  athlete_id?: Maybe<IOrder_By>;
  biometric_parameter?: Maybe<IBiometric_Parameter_Order_By>;
  biometric_parameter_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  file_url?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_biometric_data */
export type IAthlete_Biometric_Data_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  BiometricParameterId = 'biometric_parameter_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Set_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  biometric_parameter_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stddev_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Biometric_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Biometric_Data_Stream_Cursor_Value_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  biometric_parameter_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  file_url?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Sum_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_biometric_data" */
export enum IAthlete_Biometric_Data_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  BiometricParameterId = 'biometric_parameter_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value'
}

export type IAthlete_Biometric_Data_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Biometric_Data_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Biometric_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Biometric_Data_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Var_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Var_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_biometric_data" */
export type IAthlete_Biometric_Data_Variance_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
};

export type IAthlete_Block_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Block_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Block_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Block_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Block_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_block" */
export type IAthlete_Block_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Block_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Block_Max_Order_By>;
  min?: Maybe<IAthlete_Block_Min_Order_By>;
  stddev?: Maybe<IAthlete_Block_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Block_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Block_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Block_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Block_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Block_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Block_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_block" */
export type IAthlete_Block_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Block_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Block_On_Conflict>;
};

/** order by avg() on columns of table "athlete_block" */
export type IAthlete_Block_Avg_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_block". All fields are combined with a logical 'AND'. */
export type IAthlete_Block_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Block_Bool_Exp>>;
  _not?: Maybe<IAthlete_Block_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Block_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  athlete_id?: Maybe<IInt_Comparison_Exp>;
  athlete_weeks?: Maybe<IAthlete_Week_Bool_Exp>;
  athlete_weeks_aggregate?: Maybe<IAthlete_Week_Aggregate_Bool_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  end_date?: Maybe<IDate_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  start_date?: Maybe<IDate_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_block" */
export enum IAthlete_Block_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteBlockPkey = 'athlete_block_pkey'
}

/** input type for incrementing numeric columns in table "athlete_block" */
export type IAthlete_Block_Inc_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_block" */
export type IAthlete_Block_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: Maybe<Scalars['Int']>;
  athlete_weeks?: Maybe<IAthlete_Week_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "athlete_block" */
export type IAthlete_Block_Max_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_block" */
export type IAthlete_Block_Min_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_block" */
export type IAthlete_Block_Obj_Rel_Insert_Input = {
  data: IAthlete_Block_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Block_On_Conflict>;
};

/** on_conflict condition type for table "athlete_block" */
export type IAthlete_Block_On_Conflict = {
  constraint: IAthlete_Block_Constraint;
  update_columns?: Array<IAthlete_Block_Update_Column>;
  where?: Maybe<IAthlete_Block_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_block". */
export type IAthlete_Block_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  athlete_id?: Maybe<IOrder_By>;
  athlete_weeks_aggregate?: Maybe<IAthlete_Week_Aggregate_Order_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_block */
export type IAthlete_Block_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_block" */
export enum IAthlete_Block_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "athlete_block" */
export type IAthlete_Block_Set_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_block" */
export type IAthlete_Block_Stddev_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_block" */
export type IAthlete_Block_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Block_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Block_Stream_Cursor_Value_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "athlete_block" */
export type IAthlete_Block_Sum_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_block" */
export enum IAthlete_Block_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IAthlete_Block_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Block_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Block_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Block_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_block" */
export type IAthlete_Block_Var_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_block" */
export type IAthlete_Block_Var_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_block" */
export type IAthlete_Block_Variance_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete". All fields are combined with a logical 'AND'. */
export type IAthlete_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Bool_Exp>>;
  _not?: Maybe<IAthlete_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Bool_Exp>>;
  address_city?: Maybe<IString_Comparison_Exp>;
  address_country?: Maybe<IString_Comparison_Exp>;
  address_postal_code?: Maybe<IString_Comparison_Exp>;
  address_street?: Maybe<IString_Comparison_Exp>;
  athlete_biometric_data?: Maybe<IAthlete_Biometric_Data_Bool_Exp>;
  athlete_biometric_data_aggregate?: Maybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp>;
  athlete_blocks?: Maybe<IAthlete_Block_Bool_Exp>;
  athlete_blocks_aggregate?: Maybe<IAthlete_Block_Aggregate_Bool_Exp>;
  athlete_challenges?: Maybe<IAthlete_Challenge_Bool_Exp>;
  athlete_challenges_aggregate?: Maybe<IAthlete_Challenge_Aggregate_Bool_Exp>;
  athlete_profile?: Maybe<IAthlete_Profile_Bool_Exp>;
  athlete_profile_id?: Maybe<IInt_Comparison_Exp>;
  athlete_speeds?: Maybe<IAthlete_Speed_Bool_Exp>;
  athlete_speeds_aggregate?: Maybe<IAthlete_Speed_Aggregate_Bool_Exp>;
  avatar?: Maybe<IString_Comparison_Exp>;
  birthday?: Maybe<IDate_Comparison_Exp>;
  birthday_month_day?: Maybe<IInt_Comparison_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  email_language?: Maybe<IString_Comparison_Exp>;
  fiscal_id_number?: Maybe<IString_Comparison_Exp>;
  gender?: Maybe<IString_Comparison_Exp>;
  goal?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  phone?: Maybe<IString_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  status?: Maybe<IString_Comparison_Exp>;
  stripe_customer_id?: Maybe<IString_Comparison_Exp>;
  subscriptions?: Maybe<ISubscription_Bool_Exp>;
  subscriptions_aggregate?: Maybe<ISubscription_Aggregate_Bool_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  user?: Maybe<IUser_Bool_Exp>;
  user_id?: Maybe<IInt_Comparison_Exp>;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp = {
  bool_and?: Maybe<IAthlete_Challenge_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<IAthlete_Challenge_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<IAthlete_Challenge_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Challenge_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Challenge_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Challenge_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_challenge" */
export type IAthlete_Challenge_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Challenge_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Challenge_Max_Order_By>;
  min?: Maybe<IAthlete_Challenge_Min_Order_By>;
  stddev?: Maybe<IAthlete_Challenge_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Challenge_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Challenge_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Challenge_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Challenge_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Challenge_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Challenge_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_challenge" */
export type IAthlete_Challenge_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Challenge_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Challenge_On_Conflict>;
};

/** order by avg() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Avg_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_challenge". All fields are combined with a logical 'AND'. */
export type IAthlete_Challenge_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Challenge_Bool_Exp>>;
  _not?: Maybe<IAthlete_Challenge_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Challenge_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  athlete_id?: Maybe<IInt_Comparison_Exp>;
  completed_at?: Maybe<IDate_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  cumulated_univeness?: Maybe<IInt_Comparison_Exp>;
  date?: Maybe<IDate_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  distance?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_main?: Maybe<IBoolean_Comparison_Exp>;
  negative_univeness?: Maybe<IInt_Comparison_Exp>;
  notes?: Maybe<IString_Comparison_Exp>;
  positive_univeness?: Maybe<IInt_Comparison_Exp>;
  result?: Maybe<IString_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  time_done_hours?: Maybe<IInt_Comparison_Exp>;
  time_done_minutes?: Maybe<IInt_Comparison_Exp>;
  time_goal_hours?: Maybe<IInt_Comparison_Exp>;
  time_goal_minutes?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_challenge" */
export enum IAthlete_Challenge_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteChallengePkey = 'athlete_challenge_pkey'
}

/** input type for incrementing numeric columns in table "athlete_challenge" */
export type IAthlete_Challenge_Inc_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  cumulated_univeness?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  negative_univeness?: Maybe<Scalars['Int']>;
  positive_univeness?: Maybe<Scalars['Int']>;
  time_done_hours?: Maybe<Scalars['Int']>;
  time_done_minutes?: Maybe<Scalars['Int']>;
  time_goal_hours?: Maybe<Scalars['Int']>;
  time_goal_minutes?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_challenge" */
export type IAthlete_Challenge_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: Maybe<Scalars['Int']>;
  completed_at?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulated_univeness?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  negative_univeness?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  positive_univeness?: Maybe<Scalars['Int']>;
  result?: Maybe<Scalars['String']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  time_done_hours?: Maybe<Scalars['Int']>;
  time_done_minutes?: Maybe<Scalars['Int']>;
  time_goal_hours?: Maybe<Scalars['Int']>;
  time_goal_minutes?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Max_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  completed_at?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  distance?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  notes?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  result?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Min_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  completed_at?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  distance?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  notes?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  result?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_challenge" */
export type IAthlete_Challenge_On_Conflict = {
  constraint: IAthlete_Challenge_Constraint;
  update_columns?: Array<IAthlete_Challenge_Update_Column>;
  where?: Maybe<IAthlete_Challenge_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_challenge". */
export type IAthlete_Challenge_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  athlete_id?: Maybe<IOrder_By>;
  completed_at?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  distance?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_main?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  notes?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  result?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_challenge */
export type IAthlete_Challenge_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulatedUniveness = 'cumulated_univeness',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  NegativeUniveness = 'negative_univeness',
  /** column name */
  Notes = 'notes',
  /** column name */
  PositiveUniveness = 'positive_univeness',
  /** column name */
  Result = 'result',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  TimeDoneHours = 'time_done_hours',
  /** column name */
  TimeDoneMinutes = 'time_done_minutes',
  /** column name */
  TimeGoalHours = 'time_goal_hours',
  /** column name */
  TimeGoalMinutes = 'time_goal_minutes'
}

/** select "athlete_challenge_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "athlete_challenge_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Select_Column_Athlete_Challenge_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "athlete_challenge" */
export type IAthlete_Challenge_Set_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  completed_at?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulated_univeness?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  negative_univeness?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  positive_univeness?: Maybe<Scalars['Int']>;
  result?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  time_done_hours?: Maybe<Scalars['Int']>;
  time_done_minutes?: Maybe<Scalars['Int']>;
  time_goal_hours?: Maybe<Scalars['Int']>;
  time_goal_minutes?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Stddev_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_challenge" */
export type IAthlete_Challenge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Challenge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Challenge_Stream_Cursor_Value_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  completed_at?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulated_univeness?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  description?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  negative_univeness?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  positive_univeness?: Maybe<Scalars['Int']>;
  result?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  time_done_hours?: Maybe<Scalars['Int']>;
  time_done_minutes?: Maybe<Scalars['Int']>;
  time_goal_hours?: Maybe<Scalars['Int']>;
  time_goal_minutes?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Sum_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_challenge" */
export enum IAthlete_Challenge_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulatedUniveness = 'cumulated_univeness',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Distance = 'distance',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  NegativeUniveness = 'negative_univeness',
  /** column name */
  Notes = 'notes',
  /** column name */
  PositiveUniveness = 'positive_univeness',
  /** column name */
  Result = 'result',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  TimeDoneHours = 'time_done_hours',
  /** column name */
  TimeDoneMinutes = 'time_done_minutes',
  /** column name */
  TimeGoalHours = 'time_goal_hours',
  /** column name */
  TimeGoalMinutes = 'time_goal_minutes'
}

export type IAthlete_Challenge_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Challenge_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Challenge_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Challenge_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Var_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Var_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_challenge" */
export type IAthlete_Challenge_Variance_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  cumulated_univeness?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_univeness?: Maybe<IOrder_By>;
  positive_univeness?: Maybe<IOrder_By>;
  time_done_hours?: Maybe<IOrder_By>;
  time_done_minutes?: Maybe<IOrder_By>;
  time_goal_hours?: Maybe<IOrder_By>;
  time_goal_minutes?: Maybe<IOrder_By>;
};

/** unique or primary key constraints on table "athlete" */
export enum IAthlete_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthletePkey = 'athlete_pkey',
  /** unique or primary key constraint on columns "user_id" */
  AthleteUserIdKey = 'athlete_user_id_key'
}

/** input type for incrementing numeric columns in table "athlete" */
export type IAthlete_Inc_Input = {
  athlete_profile_id?: Maybe<Scalars['Int']>;
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete" */
export type IAthlete_Insert_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  athlete_biometric_data?: Maybe<IAthlete_Biometric_Data_Arr_Rel_Insert_Input>;
  athlete_blocks?: Maybe<IAthlete_Block_Arr_Rel_Insert_Input>;
  athlete_challenges?: Maybe<IAthlete_Challenge_Arr_Rel_Insert_Input>;
  athlete_profile?: Maybe<IAthlete_Profile_Obj_Rel_Insert_Input>;
  athlete_profile_id?: Maybe<Scalars['Int']>;
  athlete_speeds?: Maybe<IAthlete_Speed_Arr_Rel_Insert_Input>;
  avatar?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['date']>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_language?: Maybe<Scalars['String']>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<ISubscription_Arr_Rel_Insert_Input>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<IUser_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete" */
export type IAthlete_Max_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  athlete_profile_id?: Maybe<IOrder_By>;
  avatar?: Maybe<IOrder_By>;
  birthday?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  email_language?: Maybe<IOrder_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  gender?: Maybe<IOrder_By>;
  goal?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_customer_id?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete" */
export type IAthlete_Min_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  athlete_profile_id?: Maybe<IOrder_By>;
  avatar?: Maybe<IOrder_By>;
  birthday?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  email_language?: Maybe<IOrder_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  gender?: Maybe<IOrder_By>;
  goal?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_customer_id?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete" */
export type IAthlete_Obj_Rel_Insert_Input = {
  data: IAthlete_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_On_Conflict>;
};

/** on_conflict condition type for table "athlete" */
export type IAthlete_On_Conflict = {
  constraint: IAthlete_Constraint;
  update_columns?: Array<IAthlete_Update_Column>;
  where?: Maybe<IAthlete_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete". */
export type IAthlete_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  athlete_biometric_data_aggregate?: Maybe<IAthlete_Biometric_Data_Aggregate_Order_By>;
  athlete_blocks_aggregate?: Maybe<IAthlete_Block_Aggregate_Order_By>;
  athlete_challenges_aggregate?: Maybe<IAthlete_Challenge_Aggregate_Order_By>;
  athlete_profile?: Maybe<IAthlete_Profile_Order_By>;
  athlete_profile_id?: Maybe<IOrder_By>;
  athlete_speeds_aggregate?: Maybe<IAthlete_Speed_Aggregate_Order_By>;
  avatar?: Maybe<IOrder_By>;
  birthday?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  email_language?: Maybe<IOrder_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  gender?: Maybe<IOrder_By>;
  goal?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_customer_id?: Maybe<IOrder_By>;
  subscriptions_aggregate?: Maybe<ISubscription_Aggregate_Order_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  user?: Maybe<IUser_Order_By>;
  user_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete */
export type IAthlete_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Profile_Altimetry_Adjustment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Max_Order_By>;
  min?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Min_Order_By>;
  stddev?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Profile_Altimetry_Adjustment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Profile_Altimetry_Adjustment_On_Conflict>;
};

/** order by avg() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Avg_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_profile_altimetry_adjustment". All fields are combined with a logical 'AND'. */
export type IAthlete_Profile_Altimetry_Adjustment_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>>;
  _not?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>>;
  athlete_profile?: Maybe<IAthlete_Profile_Bool_Exp>;
  athlete_profile_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  value?: Maybe<INumeric_Comparison_Exp>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteProfileAltimetryAdjustmentPkey = 'athlete_profile_altimetry_adjustment_pkey'
}

/** input type for incrementing numeric columns in table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Inc_Input = {
  athlete_profile_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Insert_Input = {
  athlete_profile?: Maybe<IAthlete_Profile_Obj_Rel_Insert_Input>;
  athlete_profile_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Max_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Min_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_On_Conflict = {
  constraint: IAthlete_Profile_Altimetry_Adjustment_Constraint;
  update_columns?: Array<IAthlete_Profile_Altimetry_Adjustment_Update_Column>;
  where?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_profile_altimetry_adjustment". */
export type IAthlete_Profile_Altimetry_Adjustment_Order_By = {
  athlete_profile?: Maybe<IAthlete_Profile_Order_By>;
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_profile_altimetry_adjustment */
export type IAthlete_Profile_Altimetry_Adjustment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Select_Column {
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

/** input type for updating data in table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Set_Input = {
  athlete_profile_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Pop_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stddev_Samp_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Profile_Altimetry_Adjustment_Stream_Cursor_Value_Input = {
  athlete_profile_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Sum_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_profile_altimetry_adjustment" */
export enum IAthlete_Profile_Altimetry_Adjustment_Update_Column {
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

export type IAthlete_Profile_Altimetry_Adjustment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Profile_Altimetry_Adjustment_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Var_Pop_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Var_Samp_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_profile_altimetry_adjustment" */
export type IAthlete_Profile_Altimetry_Adjustment_Variance_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_profile". All fields are combined with a logical 'AND'. */
export type IAthlete_Profile_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Profile_Bool_Exp>>;
  _not?: Maybe<IAthlete_Profile_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Profile_Bool_Exp>>;
  athlete_profile_altimetry_adjustments?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  athlete_profile_altimetry_adjustments_aggregate?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp>;
  athletes?: Maybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Bool_Exp>;
  gender?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  level?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  param_calories?: Maybe<INumeric_Comparison_Exp>;
  param_distance_variation?: Maybe<INumeric_Comparison_Exp>;
  param_effort?: Maybe<INumeric_Comparison_Exp>;
  param_motivation?: Maybe<INumeric_Comparison_Exp>;
  param_ziut?: Maybe<INumeric_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_profile" */
export enum IAthlete_Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteProfilePkey = 'athlete_profile_pkey'
}

/** input type for incrementing numeric columns in table "athlete_profile" */
export type IAthlete_Profile_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  param_calories?: Maybe<Scalars['numeric']>;
  param_distance_variation?: Maybe<Scalars['numeric']>;
  param_effort?: Maybe<Scalars['numeric']>;
  param_motivation?: Maybe<Scalars['numeric']>;
  param_ziut?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_profile" */
export type IAthlete_Profile_Insert_Input = {
  athlete_profile_altimetry_adjustments?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input>;
  athletes?: Maybe<IAthlete_Arr_Rel_Insert_Input>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  param_calories?: Maybe<Scalars['numeric']>;
  param_distance_variation?: Maybe<Scalars['numeric']>;
  param_effort?: Maybe<Scalars['numeric']>;
  param_motivation?: Maybe<Scalars['numeric']>;
  param_ziut?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "athlete_profile" */
export type IAthlete_Profile_Obj_Rel_Insert_Input = {
  data: IAthlete_Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Profile_On_Conflict>;
};

/** on_conflict condition type for table "athlete_profile" */
export type IAthlete_Profile_On_Conflict = {
  constraint: IAthlete_Profile_Constraint;
  update_columns?: Array<IAthlete_Profile_Update_Column>;
  where?: Maybe<IAthlete_Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_profile". */
export type IAthlete_Profile_Order_By = {
  athlete_profile_altimetry_adjustments_aggregate?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Order_By>;
  gender?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  param_calories?: Maybe<IOrder_By>;
  param_distance_variation?: Maybe<IOrder_By>;
  param_effort?: Maybe<IOrder_By>;
  param_motivation?: Maybe<IOrder_By>;
  param_ziut?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_profile */
export type IAthlete_Profile_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_profile" */
export enum IAthlete_Profile_Select_Column {
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParamCalories = 'param_calories',
  /** column name */
  ParamDistanceVariation = 'param_distance_variation',
  /** column name */
  ParamEffort = 'param_effort',
  /** column name */
  ParamMotivation = 'param_motivation',
  /** column name */
  ParamZiut = 'param_ziut',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "athlete_profile" */
export type IAthlete_Profile_Set_Input = {
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  param_calories?: Maybe<Scalars['numeric']>;
  param_distance_variation?: Maybe<Scalars['numeric']>;
  param_effort?: Maybe<Scalars['numeric']>;
  param_motivation?: Maybe<Scalars['numeric']>;
  param_ziut?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "athlete_profile" */
export type IAthlete_Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Profile_Stream_Cursor_Value_Input = {
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  param_calories?: Maybe<Scalars['numeric']>;
  param_distance_variation?: Maybe<Scalars['numeric']>;
  param_effort?: Maybe<Scalars['numeric']>;
  param_motivation?: Maybe<Scalars['numeric']>;
  param_ziut?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** update columns of table "athlete_profile" */
export enum IAthlete_Profile_Update_Column {
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParamCalories = 'param_calories',
  /** column name */
  ParamDistanceVariation = 'param_distance_variation',
  /** column name */
  ParamEffort = 'param_effort',
  /** column name */
  ParamMotivation = 'param_motivation',
  /** column name */
  ParamZiut = 'param_ziut',
  /** column name */
  Type = 'type'
}

export type IAthlete_Profile_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Profile_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Profile_Bool_Exp;
};

/** select columns of table "athlete" */
export enum IAthlete_Select_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  BirthdayMonthDay = 'birthday_month_day',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailLanguage = 'email_language',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Gender = 'gender',
  /** column name */
  Goal = 'goal',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "athlete" */
export type IAthlete_Set_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  athlete_profile_id?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['date']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_language?: Maybe<Scalars['String']>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type IAthlete_Speed_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Speed_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Speed_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Speed_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Speed_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_speed" */
export type IAthlete_Speed_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Speed_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Speed_Max_Order_By>;
  min?: Maybe<IAthlete_Speed_Min_Order_By>;
  stddev?: Maybe<IAthlete_Speed_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Speed_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Speed_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Speed_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Speed_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Speed_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Speed_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_speed" */
export type IAthlete_Speed_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Speed_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Speed_On_Conflict>;
};

/** order by avg() on columns of table "athlete_speed" */
export type IAthlete_Speed_Avg_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_speed". All fields are combined with a logical 'AND'. */
export type IAthlete_Speed_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Speed_Bool_Exp>>;
  _not?: Maybe<IAthlete_Speed_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Speed_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  athlete_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  value?: Maybe<INumeric_Comparison_Exp>;
  workout_type?: Maybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_speed" */
export enum IAthlete_Speed_Constraint {
  /** unique or primary key constraint on columns "workout_type_id", "athlete_id" */
  AthleteSpeedAthleteIdWorkoutTypeIdKey = 'athlete_speed_athlete_id_workout_type_id_key',
  /** unique or primary key constraint on columns "id" */
  AthleteSpeedPkey = 'athlete_speed_pkey'
}

/** input type for incrementing numeric columns in table "athlete_speed" */
export type IAthlete_Speed_Inc_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_speed" */
export type IAthlete_Speed_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_type?: Maybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_speed" */
export type IAthlete_Speed_Max_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_speed" */
export type IAthlete_Speed_Min_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_speed" */
export type IAthlete_Speed_On_Conflict = {
  constraint: IAthlete_Speed_Constraint;
  update_columns?: Array<IAthlete_Speed_Update_Column>;
  where?: Maybe<IAthlete_Speed_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_speed". */
export type IAthlete_Speed_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type?: Maybe<IWorkout_Type_Order_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_speed */
export type IAthlete_Speed_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_speed" */
export enum IAthlete_Speed_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "athlete_speed" */
export type IAthlete_Speed_Set_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_speed" */
export type IAthlete_Speed_Stddev_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_speed" */
export type IAthlete_Speed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Speed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Speed_Stream_Cursor_Value_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['numeric']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_speed" */
export type IAthlete_Speed_Sum_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_speed" */
export enum IAthlete_Speed_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Value = 'value',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IAthlete_Speed_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Speed_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Speed_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Speed_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_speed" */
export type IAthlete_Speed_Var_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_speed" */
export type IAthlete_Speed_Var_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_speed" */
export type IAthlete_Speed_Variance_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  value?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev() on columns of table "athlete" */
export type IAthlete_Stddev_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete" */
export type IAthlete_Stddev_Pop_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete" */
export type IAthlete_Stddev_Samp_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete" */
export type IAthlete_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Stream_Cursor_Value_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  athlete_profile_id?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['date']>;
  birthday_month_day?: Maybe<Scalars['Int']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_language?: Maybe<Scalars['String']>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  goal?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete" */
export type IAthlete_Sum_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** update columns of table "athlete" */
export enum IAthlete_Update_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  AthleteProfileId = 'athlete_profile_id',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailLanguage = 'email_language',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Gender = 'gender',
  /** column name */
  Goal = 'goal',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Status = 'status',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type IAthlete_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete" */
export type IAthlete_Var_Pop_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete" */
export type IAthlete_Var_Samp_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete" */
export type IAthlete_Variance_Order_By = {
  athlete_profile_id?: Maybe<IOrder_By>;
  birthday_month_day?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

export type IAthlete_Week_Aggregate_Bool_Exp = {
  count?: Maybe<IAthlete_Week_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Week_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Week_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Week_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_week" */
export type IAthlete_Week_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Week_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Week_Max_Order_By>;
  min?: Maybe<IAthlete_Week_Min_Order_By>;
  stddev?: Maybe<IAthlete_Week_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Week_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Week_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Week_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Week_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Week_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Week_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_week" */
export type IAthlete_Week_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Week_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Week_On_Conflict>;
};

/** order by avg() on columns of table "athlete_week" */
export type IAthlete_Week_Avg_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_week". All fields are combined with a logical 'AND'. */
export type IAthlete_Week_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Week_Bool_Exp>>;
  _not?: Maybe<IAthlete_Week_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Week_Bool_Exp>>;
  athlete_block?: Maybe<IAthlete_Block_Bool_Exp>;
  athlete_block_id?: Maybe<IInt_Comparison_Exp>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  end_date?: Maybe<IDate_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  start_date?: Maybe<IDate_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_week" */
export enum IAthlete_Week_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWeekPkey = 'athlete_week_pkey'
}

/** input type for incrementing numeric columns in table "athlete_week" */
export type IAthlete_Week_Inc_Input = {
  athlete_block_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_week" */
export type IAthlete_Week_Insert_Input = {
  athlete_block?: Maybe<IAthlete_Block_Obj_Rel_Insert_Input>;
  athlete_block_id?: Maybe<Scalars['Int']>;
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "athlete_week" */
export type IAthlete_Week_Max_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_week" */
export type IAthlete_Week_Min_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_week" */
export type IAthlete_Week_Obj_Rel_Insert_Input = {
  data: IAthlete_Week_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Week_On_Conflict>;
};

/** on_conflict condition type for table "athlete_week" */
export type IAthlete_Week_On_Conflict = {
  constraint: IAthlete_Week_Constraint;
  update_columns?: Array<IAthlete_Week_Update_Column>;
  where?: Maybe<IAthlete_Week_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_week". */
export type IAthlete_Week_Order_By = {
  athlete_block?: Maybe<IAthlete_Block_Order_By>;
  athlete_block_id?: Maybe<IOrder_By>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  created_at?: Maybe<IOrder_By>;
  end_date?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  start_date?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_week */
export type IAthlete_Week_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_week" */
export enum IAthlete_Week_Select_Column {
  /** column name */
  AthleteBlockId = 'athlete_block_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "athlete_week" */
export type IAthlete_Week_Set_Input = {
  athlete_block_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Pop_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_week" */
export type IAthlete_Week_Stddev_Samp_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_week" */
export type IAthlete_Week_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Week_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Week_Stream_Cursor_Value_Input = {
  athlete_block_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "athlete_week" */
export type IAthlete_Week_Sum_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_week" */
export enum IAthlete_Week_Update_Column {
  /** column name */
  AthleteBlockId = 'athlete_block_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IAthlete_Week_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Week_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Week_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Week_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_week" */
export type IAthlete_Week_Var_Pop_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_week" */
export type IAthlete_Week_Var_Samp_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_week" */
export type IAthlete_Week_Variance_Order_By = {
  athlete_block_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

export type IAthlete_Workout_Aggregate_Bool_Exp = {
  bool_and?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Workout_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_workout" */
export type IAthlete_Workout_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Workout_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Workout_Max_Order_By>;
  min?: Maybe<IAthlete_Workout_Min_Order_By>;
  stddev?: Maybe<IAthlete_Workout_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Workout_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Workout_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Workout_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Workout_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Workout_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Workout_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_workout" */
export type IAthlete_Workout_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Workout_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Workout_On_Conflict>;
};

/** order by avg() on columns of table "athlete_workout" */
export type IAthlete_Workout_Avg_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_workout". All fields are combined with a logical 'AND'. */
export type IAthlete_Workout_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Workout_Bool_Exp>>;
  _not?: Maybe<IAthlete_Workout_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Workout_Bool_Exp>>;
  athlete_week?: Maybe<IAthlete_Week_Bool_Exp>;
  athlete_week_id?: Maybe<IInt_Comparison_Exp>;
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  calories?: Maybe<INumeric_Comparison_Exp>;
  comments?: Maybe<IString_Comparison_Exp>;
  completed_stretching_circuit?: Maybe<INumeric_Comparison_Exp>;
  completed_weight_circuit?: Maybe<INumeric_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  cumulative_elevation?: Maybe<IInt_Comparison_Exp>;
  date?: Maybe<IDate_Comparison_Exp>;
  day?: Maybe<IInt_Comparison_Exp>;
  effort?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_primary?: Maybe<IBoolean_Comparison_Exp>;
  measured_calories?: Maybe<INumeric_Comparison_Exp>;
  measured_cumulative_elevation?: Maybe<IInt_Comparison_Exp>;
  measured_negative_elevation?: Maybe<IInt_Comparison_Exp>;
  measured_positive_elevation?: Maybe<IInt_Comparison_Exp>;
  motivation?: Maybe<IInt_Comparison_Exp>;
  negative_elevation?: Maybe<IInt_Comparison_Exp>;
  positive_elevation?: Maybe<IInt_Comparison_Exp>;
  series?: Maybe<IString_Comparison_Exp>;
  strava_activity_id?: Maybe<IBigint_Comparison_Exp>;
  stretching_circuit?: Maybe<ICircuit_Bool_Exp>;
  stretching_circuit_id?: Maybe<IInt_Comparison_Exp>;
  stretching_circuit_repetitions?: Maybe<IInt_Comparison_Exp>;
  sum_elevation?: Maybe<IInt_Comparison_Exp>;
  sum_measured_elevation?: Maybe<IInt_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  weight_circuit?: Maybe<ICircuit_Bool_Exp>;
  weight_circuit_id?: Maybe<IInt_Comparison_Exp>;
  weight_circuit_repetitions?: Maybe<IInt_Comparison_Exp>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: Maybe<IInt_Comparison_Exp>;
  workout_template?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_template_id?: Maybe<IInt_Comparison_Exp>;
  workout_terrain?: Maybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: Maybe<IInt_Comparison_Exp>;
  workout_type?: Maybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: Maybe<IInt_Comparison_Exp>;
  workout_zone?: Maybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: Maybe<IInt_Comparison_Exp>;
  zuit?: Maybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_workout" */
export enum IAthlete_Workout_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWorkoutPkey = 'athlete_workout_pkey',
  /** unique or primary key constraint on columns "day", "athlete_week_id", "is_primary" */
  UniqueAthleteWorkoutPerWeekKey = 'unique_athlete_workout_per_week_key'
}

/** input type for incrementing numeric columns in table "athlete_workout" */
export type IAthlete_Workout_Inc_Input = {
  athlete_week_id?: Maybe<Scalars['Int']>;
  calories?: Maybe<Scalars['numeric']>;
  completed_stretching_circuit?: Maybe<Scalars['numeric']>;
  completed_weight_circuit?: Maybe<Scalars['numeric']>;
  cumulative_elevation?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['Int']>;
  effort?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  measured_calories?: Maybe<Scalars['numeric']>;
  measured_cumulative_elevation?: Maybe<Scalars['Int']>;
  measured_negative_elevation?: Maybe<Scalars['Int']>;
  measured_positive_elevation?: Maybe<Scalars['Int']>;
  motivation?: Maybe<Scalars['Int']>;
  negative_elevation?: Maybe<Scalars['Int']>;
  positive_elevation?: Maybe<Scalars['Int']>;
  strava_activity_id?: Maybe<Scalars['bigint']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
  zuit?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "athlete_workout" */
export type IAthlete_Workout_Insert_Input = {
  athlete_week?: Maybe<IAthlete_Week_Obj_Rel_Insert_Input>;
  athlete_week_id?: Maybe<Scalars['Int']>;
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  calories?: Maybe<Scalars['numeric']>;
  comments?: Maybe<Scalars['String']>;
  completed_stretching_circuit?: Maybe<Scalars['numeric']>;
  completed_weight_circuit?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  day?: Maybe<Scalars['Int']>;
  effort?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  measured_calories?: Maybe<Scalars['numeric']>;
  measured_cumulative_elevation?: Maybe<Scalars['Int']>;
  measured_negative_elevation?: Maybe<Scalars['Int']>;
  measured_positive_elevation?: Maybe<Scalars['Int']>;
  motivation?: Maybe<Scalars['Int']>;
  negative_elevation?: Maybe<Scalars['Int']>;
  positive_elevation?: Maybe<Scalars['Int']>;
  series?: Maybe<Scalars['String']>;
  strava_activity_id?: Maybe<Scalars['bigint']>;
  stretching_circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight_circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_template?: Maybe<IWorkout_Template_Obj_Rel_Insert_Input>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_terrain?: Maybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type?: Maybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone?: Maybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: Maybe<Scalars['Int']>;
  zuit?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "athlete_workout" */
export type IAthlete_Workout_Max_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  comments?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_workout" */
export type IAthlete_Workout_Min_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  comments?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "athlete_workout" */
export type IAthlete_Workout_Obj_Rel_Insert_Input = {
  data: IAthlete_Workout_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Workout_On_Conflict>;
};

/** on_conflict condition type for table "athlete_workout" */
export type IAthlete_Workout_On_Conflict = {
  constraint: IAthlete_Workout_Constraint;
  update_columns?: Array<IAthlete_Workout_Update_Column>;
  where?: Maybe<IAthlete_Workout_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_workout". */
export type IAthlete_Workout_Order_By = {
  athlete_week?: Maybe<IAthlete_Week_Order_By>;
  athlete_week_id?: Maybe<IOrder_By>;
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  calories?: Maybe<IOrder_By>;
  comments?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  date?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_primary?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit?: Maybe<ICircuit_Order_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  weight_circuit?: Maybe<ICircuit_Order_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template?: Maybe<IWorkout_Template_Order_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain?: Maybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type?: Maybe<IWorkout_Type_Order_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone?: Maybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_workout */
export type IAthlete_Workout_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp = {
  bool_and?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp_Count>;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_And = {
  arguments: IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IAthlete_Workout_Section_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IAthlete_Workout_Section_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Aggregate_Order_By = {
  avg?: Maybe<IAthlete_Workout_Section_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IAthlete_Workout_Section_Max_Order_By>;
  min?: Maybe<IAthlete_Workout_Section_Min_Order_By>;
  stddev?: Maybe<IAthlete_Workout_Section_Stddev_Order_By>;
  stddev_pop?: Maybe<IAthlete_Workout_Section_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IAthlete_Workout_Section_Stddev_Samp_Order_By>;
  sum?: Maybe<IAthlete_Workout_Section_Sum_Order_By>;
  var_pop?: Maybe<IAthlete_Workout_Section_Var_Pop_Order_By>;
  var_samp?: Maybe<IAthlete_Workout_Section_Var_Samp_Order_By>;
  variance?: Maybe<IAthlete_Workout_Section_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "athlete_workout_section" */
export type IAthlete_Workout_Section_Arr_Rel_Insert_Input = {
  data: Array<IAthlete_Workout_Section_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IAthlete_Workout_Section_On_Conflict>;
};

/** order by avg() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Avg_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "athlete_workout_section". All fields are combined with a logical 'AND'. */
export type IAthlete_Workout_Section_Bool_Exp = {
  _and?: Maybe<Array<IAthlete_Workout_Section_Bool_Exp>>;
  _not?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  _or?: Maybe<Array<IAthlete_Workout_Section_Bool_Exp>>;
  athlete_workout?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workout_id?: Maybe<IInt_Comparison_Exp>;
  average_heart_rate?: Maybe<INumeric_Comparison_Exp>;
  average_heart_rate_percentage?: Maybe<INumeric_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  duration?: Maybe<INumeric_Comparison_Exp>;
  executed_stress_score?: Maybe<INumeric_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_main?: Maybe<IBoolean_Comparison_Exp>;
  max_heart_rate?: Maybe<INumeric_Comparison_Exp>;
  measured_average_heart_rate?: Maybe<INumeric_Comparison_Exp>;
  measured_duration?: Maybe<INumeric_Comparison_Exp>;
  measured_max_heart_rate?: Maybe<INumeric_Comparison_Exp>;
  measured_speed?: Maybe<INumeric_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  planned_stress_score?: Maybe<INumeric_Comparison_Exp>;
  section_zuit?: Maybe<INumeric_Comparison_Exp>;
  series_id?: Maybe<IInt_Comparison_Exp>;
  speed?: Maybe<INumeric_Comparison_Exp>;
  speed_percentage?: Maybe<INumeric_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  workout_section_template?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_template_id?: Maybe<IInt_Comparison_Exp>;
  workout_zone?: Maybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  AthleteWorkoutSectionPkey = 'athlete_workout_section_pkey'
}

/** input type for incrementing numeric columns in table "athlete_workout_section" */
export type IAthlete_Workout_Section_Inc_Input = {
  athlete_workout_id?: Maybe<Scalars['Int']>;
  average_heart_rate?: Maybe<Scalars['numeric']>;
  average_heart_rate_percentage?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_average_heart_rate?: Maybe<Scalars['numeric']>;
  measured_duration?: Maybe<Scalars['numeric']>;
  measured_max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_speed?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  section_zuit?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  speed_percentage?: Maybe<Scalars['numeric']>;
  workout_section_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "athlete_workout_section" */
export type IAthlete_Workout_Section_Insert_Input = {
  athlete_workout?: Maybe<IAthlete_Workout_Obj_Rel_Insert_Input>;
  athlete_workout_id?: Maybe<Scalars['Int']>;
  average_heart_rate?: Maybe<Scalars['numeric']>;
  average_heart_rate_percentage?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_average_heart_rate?: Maybe<Scalars['numeric']>;
  measured_duration?: Maybe<Scalars['numeric']>;
  measured_max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_speed?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  section_zuit?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  speed_percentage?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_section_template?: Maybe<IWorkout_Section_Template_Obj_Rel_Insert_Input>;
  workout_section_template_id?: Maybe<Scalars['Int']>;
  workout_zone?: Maybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Max_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Min_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "athlete_workout_section" */
export type IAthlete_Workout_Section_On_Conflict = {
  constraint: IAthlete_Workout_Section_Constraint;
  update_columns?: Array<IAthlete_Workout_Section_Update_Column>;
  where?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
};

/** Ordering options when selecting data from "athlete_workout_section". */
export type IAthlete_Workout_Section_Order_By = {
  athlete_workout?: Maybe<IAthlete_Workout_Order_By>;
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  executed_stress_score?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_main?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  planned_stress_score?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_section_template?: Maybe<IWorkout_Section_Template_Order_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone?: Maybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: athlete_workout_section */
export type IAthlete_Workout_Section_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column {
  /** column name */
  AthleteWorkoutId = 'athlete_workout_id',
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  AverageHeartRatePercentage = 'average_heart_rate_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  MeasuredAverageHeartRate = 'measured_average_heart_rate',
  /** column name */
  MeasuredDuration = 'measured_duration',
  /** column name */
  MeasuredMaxHeartRate = 'measured_max_heart_rate',
  /** column name */
  MeasuredSpeed = 'measured_speed',
  /** column name */
  Order = 'order',
  /** column name */
  SectionZuit = 'section_zuit',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  SpeedPercentage = 'speed_percentage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutSectionTemplateId = 'workout_section_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "athlete_workout_section_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "athlete_workout_section_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Select_Column_Athlete_Workout_Section_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "athlete_workout_section" */
export type IAthlete_Workout_Section_Set_Input = {
  athlete_workout_id?: Maybe<Scalars['Int']>;
  average_heart_rate?: Maybe<Scalars['numeric']>;
  average_heart_rate_percentage?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_average_heart_rate?: Maybe<Scalars['numeric']>;
  measured_duration?: Maybe<Scalars['numeric']>;
  measured_max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_speed?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  section_zuit?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  speed_percentage?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_section_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Pop_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stddev_Samp_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_workout_section" */
export type IAthlete_Workout_Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Workout_Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Workout_Section_Stream_Cursor_Value_Input = {
  athlete_workout_id?: Maybe<Scalars['Int']>;
  average_heart_rate?: Maybe<Scalars['numeric']>;
  average_heart_rate_percentage?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_average_heart_rate?: Maybe<Scalars['numeric']>;
  measured_duration?: Maybe<Scalars['numeric']>;
  measured_max_heart_rate?: Maybe<Scalars['numeric']>;
  measured_speed?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  section_zuit?: Maybe<Scalars['numeric']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  speed_percentage?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_section_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Sum_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_workout_section" */
export enum IAthlete_Workout_Section_Update_Column {
  /** column name */
  AthleteWorkoutId = 'athlete_workout_id',
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  AverageHeartRatePercentage = 'average_heart_rate_percentage',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  MeasuredAverageHeartRate = 'measured_average_heart_rate',
  /** column name */
  MeasuredDuration = 'measured_duration',
  /** column name */
  MeasuredMaxHeartRate = 'measured_max_heart_rate',
  /** column name */
  MeasuredSpeed = 'measured_speed',
  /** column name */
  Order = 'order',
  /** column name */
  SectionZuit = 'section_zuit',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  SpeedPercentage = 'speed_percentage',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutSectionTemplateId = 'workout_section_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IAthlete_Workout_Section_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Workout_Section_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Workout_Section_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Workout_Section_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Var_Pop_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Var_Samp_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_workout_section" */
export type IAthlete_Workout_Section_Variance_Order_By = {
  athlete_workout_id?: Maybe<IOrder_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  average_heart_rate_percentage?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  measured_average_heart_rate?: Maybe<IOrder_By>;
  measured_duration?: Maybe<IOrder_By>;
  measured_max_heart_rate?: Maybe<IOrder_By>;
  measured_speed?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  section_zuit?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  speed_percentage?: Maybe<IOrder_By>;
  workout_section_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** select columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column {
  /** column name */
  AthleteWeekId = 'athlete_week_id',
  /** column name */
  Calories = 'calories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompletedStretchingCircuit = 'completed_stretching_circuit',
  /** column name */
  CompletedWeightCircuit = 'completed_weight_circuit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  MeasuredCalories = 'measured_calories',
  /** column name */
  MeasuredCumulativeElevation = 'measured_cumulative_elevation',
  /** column name */
  MeasuredNegativeElevation = 'measured_negative_elevation',
  /** column name */
  MeasuredPositiveElevation = 'measured_positive_elevation',
  /** column name */
  Motivation = 'motivation',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  StravaActivityId = 'strava_activity_id',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  SumElevation = 'sum_elevation',
  /** column name */
  SumMeasuredElevation = 'sum_measured_elevation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id',
  /** column name */
  Zuit = 'zuit'
}

/** select "athlete_workout_aggregate_bool_exp_bool_and_arguments_columns" columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** select "athlete_workout_aggregate_bool_exp_bool_or_arguments_columns" columns of table "athlete_workout" */
export enum IAthlete_Workout_Select_Column_Athlete_Workout_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** input type for updating data in table "athlete_workout" */
export type IAthlete_Workout_Set_Input = {
  athlete_week_id?: Maybe<Scalars['Int']>;
  calories?: Maybe<Scalars['numeric']>;
  comments?: Maybe<Scalars['String']>;
  completed_stretching_circuit?: Maybe<Scalars['numeric']>;
  completed_weight_circuit?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  day?: Maybe<Scalars['Int']>;
  effort?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  measured_calories?: Maybe<Scalars['numeric']>;
  measured_cumulative_elevation?: Maybe<Scalars['Int']>;
  measured_negative_elevation?: Maybe<Scalars['Int']>;
  measured_positive_elevation?: Maybe<Scalars['Int']>;
  motivation?: Maybe<Scalars['Int']>;
  negative_elevation?: Maybe<Scalars['Int']>;
  positive_elevation?: Maybe<Scalars['Int']>;
  series?: Maybe<Scalars['String']>;
  strava_activity_id?: Maybe<Scalars['bigint']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
  zuit?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Pop_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "athlete_workout" */
export type IAthlete_Workout_Stddev_Samp_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "athlete_workout" */
export type IAthlete_Workout_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IAthlete_Workout_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IAthlete_Workout_Stream_Cursor_Value_Input = {
  athlete_week_id?: Maybe<Scalars['Int']>;
  calories?: Maybe<Scalars['numeric']>;
  comments?: Maybe<Scalars['String']>;
  completed_stretching_circuit?: Maybe<Scalars['numeric']>;
  completed_weight_circuit?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['date']>;
  day?: Maybe<Scalars['Int']>;
  effort?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  measured_calories?: Maybe<Scalars['numeric']>;
  measured_cumulative_elevation?: Maybe<Scalars['Int']>;
  measured_negative_elevation?: Maybe<Scalars['Int']>;
  measured_positive_elevation?: Maybe<Scalars['Int']>;
  motivation?: Maybe<Scalars['Int']>;
  negative_elevation?: Maybe<Scalars['Int']>;
  positive_elevation?: Maybe<Scalars['Int']>;
  series?: Maybe<Scalars['String']>;
  strava_activity_id?: Maybe<Scalars['bigint']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  sum_elevation?: Maybe<Scalars['Int']>;
  sum_measured_elevation?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
  zuit?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "athlete_workout" */
export type IAthlete_Workout_Sum_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** update columns of table "athlete_workout" */
export enum IAthlete_Workout_Update_Column {
  /** column name */
  AthleteWeekId = 'athlete_week_id',
  /** column name */
  Calories = 'calories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompletedStretchingCircuit = 'completed_stretching_circuit',
  /** column name */
  CompletedWeightCircuit = 'completed_weight_circuit',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Effort = 'effort',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  MeasuredCalories = 'measured_calories',
  /** column name */
  MeasuredCumulativeElevation = 'measured_cumulative_elevation',
  /** column name */
  MeasuredNegativeElevation = 'measured_negative_elevation',
  /** column name */
  MeasuredPositiveElevation = 'measured_positive_elevation',
  /** column name */
  Motivation = 'motivation',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  StravaActivityId = 'strava_activity_id',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id',
  /** column name */
  Zuit = 'zuit'
}

export type IAthlete_Workout_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IAthlete_Workout_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IAthlete_Workout_Set_Input>;
  /** filter the rows which have to be updated */
  where: IAthlete_Workout_Bool_Exp;
};

/** order by var_pop() on columns of table "athlete_workout" */
export type IAthlete_Workout_Var_Pop_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "athlete_workout" */
export type IAthlete_Workout_Var_Samp_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "athlete_workout" */
export type IAthlete_Workout_Variance_Order_By = {
  athlete_week_id?: Maybe<IOrder_By>;
  calories?: Maybe<IOrder_By>;
  completed_stretching_circuit?: Maybe<IOrder_By>;
  completed_weight_circuit?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  effort?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  measured_calories?: Maybe<IOrder_By>;
  measured_cumulative_elevation?: Maybe<IOrder_By>;
  measured_negative_elevation?: Maybe<IOrder_By>;
  measured_positive_elevation?: Maybe<IOrder_By>;
  motivation?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  strava_activity_id?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  sum_elevation?: Maybe<IOrder_By>;
  sum_measured_elevation?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
  zuit?: Maybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type IBigint_Comparison_Exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to filter rows from the table "biometric_parameter". All fields are combined with a logical 'AND'. */
export type IBiometric_Parameter_Bool_Exp = {
  _and?: Maybe<Array<IBiometric_Parameter_Bool_Exp>>;
  _not?: Maybe<IBiometric_Parameter_Bool_Exp>;
  _or?: Maybe<Array<IBiometric_Parameter_Bool_Exp>>;
  athlete_biometric_data?: Maybe<IAthlete_Biometric_Data_Bool_Exp>;
  athlete_biometric_data_aggregate?: Maybe<IAthlete_Biometric_Data_Aggregate_Bool_Exp>;
  id?: Maybe<IName_Comparison_Exp>;
  label?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "biometric_parameter" */
export enum IBiometric_Parameter_Constraint {
  /** unique or primary key constraint on columns "id" */
  BiometricParameterPkey = 'biometric_parameter_pkey'
}

/** input type for inserting data into table "biometric_parameter" */
export type IBiometric_Parameter_Insert_Input = {
  athlete_biometric_data?: Maybe<IAthlete_Biometric_Data_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['name']>;
  label?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "biometric_parameter" */
export type IBiometric_Parameter_Obj_Rel_Insert_Input = {
  data: IBiometric_Parameter_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IBiometric_Parameter_On_Conflict>;
};

/** on_conflict condition type for table "biometric_parameter" */
export type IBiometric_Parameter_On_Conflict = {
  constraint: IBiometric_Parameter_Constraint;
  update_columns?: Array<IBiometric_Parameter_Update_Column>;
  where?: Maybe<IBiometric_Parameter_Bool_Exp>;
};

/** Ordering options when selecting data from "biometric_parameter". */
export type IBiometric_Parameter_Order_By = {
  athlete_biometric_data_aggregate?: Maybe<IAthlete_Biometric_Data_Aggregate_Order_By>;
  id?: Maybe<IOrder_By>;
  label?: Maybe<IOrder_By>;
};

/** primary key columns input for table: biometric_parameter */
export type IBiometric_Parameter_Pk_Columns_Input = {
  id: Scalars['name'];
};

/** select columns of table "biometric_parameter" */
export enum IBiometric_Parameter_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

/** input type for updating data in table "biometric_parameter" */
export type IBiometric_Parameter_Set_Input = {
  id?: Maybe<Scalars['name']>;
  label?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "biometric_parameter" */
export type IBiometric_Parameter_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IBiometric_Parameter_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IBiometric_Parameter_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['name']>;
  label?: Maybe<Scalars['String']>;
};

/** update columns of table "biometric_parameter" */
export enum IBiometric_Parameter_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

export type IBiometric_Parameter_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IBiometric_Parameter_Set_Input>;
  /** filter the rows which have to be updated */
  where: IBiometric_Parameter_Bool_Exp;
};

export type IBlock_Template_Aggregate_Bool_Exp = {
  count?: Maybe<IBlock_Template_Aggregate_Bool_Exp_Count>;
};

export type IBlock_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IBlock_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IBlock_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "block_template" */
export type IBlock_Template_Aggregate_Order_By = {
  avg?: Maybe<IBlock_Template_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IBlock_Template_Max_Order_By>;
  min?: Maybe<IBlock_Template_Min_Order_By>;
  stddev?: Maybe<IBlock_Template_Stddev_Order_By>;
  stddev_pop?: Maybe<IBlock_Template_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IBlock_Template_Stddev_Samp_Order_By>;
  sum?: Maybe<IBlock_Template_Sum_Order_By>;
  var_pop?: Maybe<IBlock_Template_Var_Pop_Order_By>;
  var_samp?: Maybe<IBlock_Template_Var_Samp_Order_By>;
  variance?: Maybe<IBlock_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "block_template" */
export type IBlock_Template_Arr_Rel_Insert_Input = {
  data: Array<IBlock_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IBlock_Template_On_Conflict>;
};

/** order by avg() on columns of table "block_template" */
export type IBlock_Template_Avg_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "block_template". All fields are combined with a logical 'AND'. */
export type IBlock_Template_Bool_Exp = {
  _and?: Maybe<Array<IBlock_Template_Bool_Exp>>;
  _not?: Maybe<IBlock_Template_Bool_Exp>;
  _or?: Maybe<Array<IBlock_Template_Bool_Exp>>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  week_templates?: Maybe<IWeek_Template_Bool_Exp>;
  week_templates_aggregate?: Maybe<IWeek_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "block_template" */
export enum IBlock_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  BlockTemplatePkey = 'block_template_pkey'
}

/** input type for incrementing numeric columns in table "block_template" */
export type IBlock_Template_Inc_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "block_template" */
export type IBlock_Template_Insert_Input = {
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  week_templates?: Maybe<IWeek_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "block_template" */
export type IBlock_Template_Max_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "block_template" */
export type IBlock_Template_Min_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "block_template" */
export type IBlock_Template_Obj_Rel_Insert_Input = {
  data: IBlock_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IBlock_Template_On_Conflict>;
};

/** on_conflict condition type for table "block_template" */
export type IBlock_Template_On_Conflict = {
  constraint: IBlock_Template_Constraint;
  update_columns?: Array<IBlock_Template_Update_Column>;
  where?: Maybe<IBlock_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "block_template". */
export type IBlock_Template_Order_By = {
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  week_templates_aggregate?: Maybe<IWeek_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: block_template */
export type IBlock_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "block_template" */
export enum IBlock_Template_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "block_template" */
export type IBlock_Template_Set_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "block_template" */
export type IBlock_Template_Stddev_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "block_template" */
export type IBlock_Template_Stddev_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "block_template" */
export type IBlock_Template_Stddev_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "block_template" */
export type IBlock_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IBlock_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IBlock_Template_Stream_Cursor_Value_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "block_template" */
export type IBlock_Template_Sum_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** update columns of table "block_template" */
export enum IBlock_Template_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IBlock_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IBlock_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IBlock_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IBlock_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "block_template" */
export type IBlock_Template_Var_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "block_template" */
export type IBlock_Template_Var_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "block_template" */
export type IBlock_Template_Variance_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

export type ICircuit_Aggregate_Bool_Exp = {
  count?: Maybe<ICircuit_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICircuit_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICircuit_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit" */
export type ICircuit_Aggregate_Order_By = {
  avg?: Maybe<ICircuit_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICircuit_Max_Order_By>;
  min?: Maybe<ICircuit_Min_Order_By>;
  stddev?: Maybe<ICircuit_Stddev_Order_By>;
  stddev_pop?: Maybe<ICircuit_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICircuit_Stddev_Samp_Order_By>;
  sum?: Maybe<ICircuit_Sum_Order_By>;
  var_pop?: Maybe<ICircuit_Var_Pop_Order_By>;
  var_samp?: Maybe<ICircuit_Var_Samp_Order_By>;
  variance?: Maybe<ICircuit_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit" */
export type ICircuit_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICircuit_On_Conflict>;
};

/** order by avg() on columns of table "circuit" */
export type ICircuit_Avg_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit". All fields are combined with a logical 'AND'. */
export type ICircuit_Bool_Exp = {
  _and?: Maybe<Array<ICircuit_Bool_Exp>>;
  _not?: Maybe<ICircuit_Bool_Exp>;
  _or?: Maybe<Array<ICircuit_Bool_Exp>>;
  athleteWorkoutsByWeightCircuitId?: Maybe<IAthlete_Workout_Bool_Exp>;
  athleteWorkoutsByWeightCircuitId_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  circuit_exercises?: Maybe<ICircuit_Exercise_Bool_Exp>;
  circuit_exercises_aggregate?: Maybe<ICircuit_Exercise_Aggregate_Bool_Exp>;
  circuit_translations?: Maybe<ICircuit_Translation_Bool_Exp>;
  circuit_translations_aggregate?: Maybe<ICircuit_Translation_Aggregate_Bool_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  recovery_interval?: Maybe<INumeric_Comparison_Exp>;
  sports?: Maybe<ICircuit_Sport_Bool_Exp>;
  sports_aggregate?: Maybe<ICircuit_Sport_Aggregate_Bool_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  workoutTemplatesByWeightCircuitId?: Maybe<IWorkout_Template_Bool_Exp>;
  workoutTemplatesByWeightCircuitId_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "circuit" */
export enum ICircuit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitPkey = 'circuit_pkey'
}

export type ICircuit_Exercise_Aggregate_Bool_Exp = {
  count?: Maybe<ICircuit_Exercise_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Exercise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICircuit_Exercise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICircuit_Exercise_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_exercise" */
export type ICircuit_Exercise_Aggregate_Order_By = {
  avg?: Maybe<ICircuit_Exercise_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICircuit_Exercise_Max_Order_By>;
  min?: Maybe<ICircuit_Exercise_Min_Order_By>;
  stddev?: Maybe<ICircuit_Exercise_Stddev_Order_By>;
  stddev_pop?: Maybe<ICircuit_Exercise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICircuit_Exercise_Stddev_Samp_Order_By>;
  sum?: Maybe<ICircuit_Exercise_Sum_Order_By>;
  var_pop?: Maybe<ICircuit_Exercise_Var_Pop_Order_By>;
  var_samp?: Maybe<ICircuit_Exercise_Var_Samp_Order_By>;
  variance?: Maybe<ICircuit_Exercise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_exercise" */
export type ICircuit_Exercise_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Exercise_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICircuit_Exercise_On_Conflict>;
};

/** order by avg() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Avg_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_exercise". All fields are combined with a logical 'AND'. */
export type ICircuit_Exercise_Bool_Exp = {
  _and?: Maybe<Array<ICircuit_Exercise_Bool_Exp>>;
  _not?: Maybe<ICircuit_Exercise_Bool_Exp>;
  _or?: Maybe<Array<ICircuit_Exercise_Bool_Exp>>;
  circuit?: Maybe<ICircuit_Bool_Exp>;
  circuit_id?: Maybe<IInt_Comparison_Exp>;
  duration?: Maybe<INumeric_Comparison_Exp>;
  exercise?: Maybe<IExercise_Bool_Exp>;
  exercise_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  no_of_series?: Maybe<INumeric_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  repetitions?: Maybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_exercise" */
export enum ICircuit_Exercise_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitExercisePkey = 'circuit_exercise_pkey'
}

/** input type for incrementing numeric columns in table "circuit_exercise" */
export type ICircuit_Exercise_Inc_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['numeric']>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_series?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  repetitions?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "circuit_exercise" */
export type ICircuit_Exercise_Insert_Input = {
  circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['numeric']>;
  exercise?: Maybe<IExercise_Obj_Rel_Insert_Input>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_series?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  repetitions?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Max_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Min_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_exercise" */
export type ICircuit_Exercise_On_Conflict = {
  constraint: ICircuit_Exercise_Constraint;
  update_columns?: Array<ICircuit_Exercise_Update_Column>;
  where?: Maybe<ICircuit_Exercise_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_exercise". */
export type ICircuit_Exercise_Order_By = {
  circuit?: Maybe<ICircuit_Order_By>;
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise?: Maybe<IExercise_Order_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** primary key columns input for table: circuit_exercise */
export type ICircuit_Exercise_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_exercise" */
export enum ICircuit_Exercise_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSeries = 'no_of_series',
  /** column name */
  Order = 'order',
  /** column name */
  Repetitions = 'repetitions'
}

/** input type for updating data in table "circuit_exercise" */
export type ICircuit_Exercise_Set_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['numeric']>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_series?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  repetitions?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Stddev_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_exercise" */
export type ICircuit_Exercise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Exercise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Exercise_Stream_Cursor_Value_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['numeric']>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  no_of_series?: Maybe<Scalars['numeric']>;
  order?: Maybe<Scalars['Int']>;
  repetitions?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Sum_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** update columns of table "circuit_exercise" */
export enum ICircuit_Exercise_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Duration = 'duration',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  NoOfSeries = 'no_of_series',
  /** column name */
  Order = 'order',
  /** column name */
  Repetitions = 'repetitions'
}

export type ICircuit_Exercise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICircuit_Exercise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICircuit_Exercise_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Exercise_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Var_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Var_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_exercise" */
export type ICircuit_Exercise_Variance_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  no_of_series?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  repetitions?: Maybe<IOrder_By>;
};

/** input type for incrementing numeric columns in table "circuit" */
export type ICircuit_Inc_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  recovery_interval?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "circuit" */
export type ICircuit_Insert_Input = {
  athleteWorkoutsByWeightCircuitId?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  circuit_exercises?: Maybe<ICircuit_Exercise_Arr_Rel_Insert_Input>;
  circuit_translations?: Maybe<ICircuit_Translation_Arr_Rel_Insert_Input>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  recovery_interval?: Maybe<Scalars['numeric']>;
  sports?: Maybe<ICircuit_Sport_Arr_Rel_Insert_Input>;
  type?: Maybe<Scalars['String']>;
  workoutTemplatesByWeightCircuitId?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "circuit" */
export type ICircuit_Max_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "circuit" */
export type ICircuit_Min_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "circuit" */
export type ICircuit_Obj_Rel_Insert_Input = {
  data: ICircuit_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ICircuit_On_Conflict>;
};

/** on_conflict condition type for table "circuit" */
export type ICircuit_On_Conflict = {
  constraint: ICircuit_Constraint;
  update_columns?: Array<ICircuit_Update_Column>;
  where?: Maybe<ICircuit_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit". */
export type ICircuit_Order_By = {
  athleteWorkoutsByWeightCircuitId_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  circuit_exercises_aggregate?: Maybe<ICircuit_Exercise_Aggregate_Order_By>;
  circuit_translations_aggregate?: Maybe<ICircuit_Translation_Aggregate_Order_By>;
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
  sports_aggregate?: Maybe<ICircuit_Sport_Aggregate_Order_By>;
  type?: Maybe<IOrder_By>;
  workoutTemplatesByWeightCircuitId_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: circuit */
export type ICircuit_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit" */
export enum ICircuit_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecoveryInterval = 'recovery_interval',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "circuit" */
export type ICircuit_Set_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  recovery_interval?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

export type ICircuit_Sport_Aggregate_Bool_Exp = {
  count?: Maybe<ICircuit_Sport_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Sport_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICircuit_Sport_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICircuit_Sport_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_sport" */
export type ICircuit_Sport_Aggregate_Order_By = {
  avg?: Maybe<ICircuit_Sport_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICircuit_Sport_Max_Order_By>;
  min?: Maybe<ICircuit_Sport_Min_Order_By>;
  stddev?: Maybe<ICircuit_Sport_Stddev_Order_By>;
  stddev_pop?: Maybe<ICircuit_Sport_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICircuit_Sport_Stddev_Samp_Order_By>;
  sum?: Maybe<ICircuit_Sport_Sum_Order_By>;
  var_pop?: Maybe<ICircuit_Sport_Var_Pop_Order_By>;
  var_samp?: Maybe<ICircuit_Sport_Var_Samp_Order_By>;
  variance?: Maybe<ICircuit_Sport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_sport" */
export type ICircuit_Sport_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Sport_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICircuit_Sport_On_Conflict>;
};

/** order by avg() on columns of table "circuit_sport" */
export type ICircuit_Sport_Avg_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_sport". All fields are combined with a logical 'AND'. */
export type ICircuit_Sport_Bool_Exp = {
  _and?: Maybe<Array<ICircuit_Sport_Bool_Exp>>;
  _not?: Maybe<ICircuit_Sport_Bool_Exp>;
  _or?: Maybe<Array<ICircuit_Sport_Bool_Exp>>;
  circuit?: Maybe<ICircuit_Bool_Exp>;
  circuit_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IName_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_sport" */
export enum ICircuit_Sport_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitSportPkey = 'circuit_sport_pkey',
  /** unique or primary key constraint on columns "sport_id", "circuit_id" */
  CircuitSportSportIdCircuitIdKey = 'circuit_sport_sport_id_circuit_id_key'
}

/** input type for incrementing numeric columns in table "circuit_sport" */
export type ICircuit_Sport_Inc_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "circuit_sport" */
export type ICircuit_Sport_Insert_Input = {
  circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by max() on columns of table "circuit_sport" */
export type ICircuit_Sport_Max_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_sport" */
export type ICircuit_Sport_Min_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_sport" */
export type ICircuit_Sport_On_Conflict = {
  constraint: ICircuit_Sport_Constraint;
  update_columns?: Array<ICircuit_Sport_Update_Column>;
  where?: Maybe<ICircuit_Sport_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_sport". */
export type ICircuit_Sport_Order_By = {
  circuit?: Maybe<ICircuit_Order_By>;
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: circuit_sport */
export type ICircuit_Sport_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_sport" */
export enum ICircuit_Sport_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

/** input type for updating data in table "circuit_sport" */
export type ICircuit_Sport_Set_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by stddev() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_sport" */
export type ICircuit_Sport_Stddev_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_sport" */
export type ICircuit_Sport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Sport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Sport_Stream_Cursor_Value_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by sum() on columns of table "circuit_sport" */
export type ICircuit_Sport_Sum_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** update columns of table "circuit_sport" */
export enum ICircuit_Sport_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

export type ICircuit_Sport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICircuit_Sport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICircuit_Sport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Sport_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_sport" */
export type ICircuit_Sport_Var_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_sport" */
export type ICircuit_Sport_Var_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_sport" */
export type ICircuit_Sport_Variance_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev() on columns of table "circuit" */
export type ICircuit_Stddev_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit" */
export type ICircuit_Stddev_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit" */
export type ICircuit_Stddev_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit" */
export type ICircuit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Stream_Cursor_Value_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  recovery_interval?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "circuit" */
export type ICircuit_Sum_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

export type ICircuit_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<ICircuit_Translation_Aggregate_Bool_Exp_Count>;
};

export type ICircuit_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICircuit_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICircuit_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "circuit_translation" */
export type ICircuit_Translation_Aggregate_Order_By = {
  avg?: Maybe<ICircuit_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICircuit_Translation_Max_Order_By>;
  min?: Maybe<ICircuit_Translation_Min_Order_By>;
  stddev?: Maybe<ICircuit_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<ICircuit_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICircuit_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<ICircuit_Translation_Sum_Order_By>;
  var_pop?: Maybe<ICircuit_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<ICircuit_Translation_Var_Samp_Order_By>;
  variance?: Maybe<ICircuit_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "circuit_translation" */
export type ICircuit_Translation_Arr_Rel_Insert_Input = {
  data: Array<ICircuit_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICircuit_Translation_On_Conflict>;
};

/** order by avg() on columns of table "circuit_translation" */
export type ICircuit_Translation_Avg_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "circuit_translation". All fields are combined with a logical 'AND'. */
export type ICircuit_Translation_Bool_Exp = {
  _and?: Maybe<Array<ICircuit_Translation_Bool_Exp>>;
  _not?: Maybe<ICircuit_Translation_Bool_Exp>;
  _or?: Maybe<Array<ICircuit_Translation_Bool_Exp>>;
  circuit?: Maybe<ICircuit_Bool_Exp>;
  circuit_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "circuit_translation" */
export enum ICircuit_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CircuitTranslationPkey = 'circuit_translation_pkey'
}

/** input type for incrementing numeric columns in table "circuit_translation" */
export type ICircuit_Translation_Inc_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "circuit_translation" */
export type ICircuit_Translation_Insert_Input = {
  circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  circuit_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "circuit_translation" */
export type ICircuit_Translation_Max_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "circuit_translation" */
export type ICircuit_Translation_Min_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "circuit_translation" */
export type ICircuit_Translation_On_Conflict = {
  constraint: ICircuit_Translation_Constraint;
  update_columns?: Array<ICircuit_Translation_Update_Column>;
  where?: Maybe<ICircuit_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "circuit_translation". */
export type ICircuit_Translation_Order_By = {
  circuit?: Maybe<ICircuit_Order_By>;
  circuit_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** primary key columns input for table: circuit_translation */
export type ICircuit_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "circuit_translation" */
export enum ICircuit_Translation_Select_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "circuit_translation" */
export type ICircuit_Translation_Set_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "circuit_translation" */
export type ICircuit_Translation_Stddev_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "circuit_translation" */
export type ICircuit_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICircuit_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICircuit_Translation_Stream_Cursor_Value_Input = {
  circuit_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "circuit_translation" */
export type ICircuit_Translation_Sum_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "circuit_translation" */
export enum ICircuit_Translation_Update_Column {
  /** column name */
  CircuitId = 'circuit_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

export type ICircuit_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICircuit_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICircuit_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit_translation" */
export type ICircuit_Translation_Var_Pop_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit_translation" */
export type ICircuit_Translation_Var_Samp_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit_translation" */
export type ICircuit_Translation_Variance_Order_By = {
  circuit_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "circuit" */
export enum ICircuit_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  RecoveryInterval = 'recovery_interval',
  /** column name */
  Type = 'type'
}

export type ICircuit_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICircuit_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICircuit_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICircuit_Bool_Exp;
};

/** order by var_pop() on columns of table "circuit" */
export type ICircuit_Var_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "circuit" */
export type ICircuit_Var_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "circuit" */
export type ICircuit_Variance_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  recovery_interval?: Maybe<IOrder_By>;
};

export type ICoach_Aggregate_Bool_Exp = {
  avg?: Maybe<ICoach_Aggregate_Bool_Exp_Avg>;
  bool_and?: Maybe<ICoach_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<ICoach_Aggregate_Bool_Exp_Bool_Or>;
  corr?: Maybe<ICoach_Aggregate_Bool_Exp_Corr>;
  count?: Maybe<ICoach_Aggregate_Bool_Exp_Count>;
  covar_samp?: Maybe<ICoach_Aggregate_Bool_Exp_Covar_Samp>;
  max?: Maybe<ICoach_Aggregate_Bool_Exp_Max>;
  min?: Maybe<ICoach_Aggregate_Bool_Exp_Min>;
  stddev_samp?: Maybe<ICoach_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: Maybe<ICoach_Aggregate_Bool_Exp_Sum>;
  var_samp?: Maybe<ICoach_Aggregate_Bool_Exp_Var_Samp>;
};

export type ICoach_Aggregate_Bool_Exp_Avg = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Bool_And = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Corr = {
  arguments: ICoach_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ICoach_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICoach_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ICoach_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ICoach_Aggregate_Bool_Exp_Max = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Min = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Sum = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ICoach_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

/** order by aggregate values of table "coach" */
export type ICoach_Aggregate_Order_By = {
  avg?: Maybe<ICoach_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICoach_Max_Order_By>;
  min?: Maybe<ICoach_Min_Order_By>;
  stddev?: Maybe<ICoach_Stddev_Order_By>;
  stddev_pop?: Maybe<ICoach_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICoach_Stddev_Samp_Order_By>;
  sum?: Maybe<ICoach_Sum_Order_By>;
  var_pop?: Maybe<ICoach_Var_Pop_Order_By>;
  var_samp?: Maybe<ICoach_Var_Samp_Order_By>;
  variance?: Maybe<ICoach_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach" */
export type ICoach_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICoach_On_Conflict>;
};

/** order by avg() on columns of table "coach" */
export type ICoach_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach". All fields are combined with a logical 'AND'. */
export type ICoach_Bool_Exp = {
  _and?: Maybe<Array<ICoach_Bool_Exp>>;
  _not?: Maybe<ICoach_Bool_Exp>;
  _or?: Maybe<Array<ICoach_Bool_Exp>>;
  address_city?: Maybe<IString_Comparison_Exp>;
  address_country?: Maybe<IString_Comparison_Exp>;
  address_postal_code?: Maybe<IString_Comparison_Exp>;
  address_street?: Maybe<IString_Comparison_Exp>;
  athletes?: Maybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Bool_Exp>;
  block_templates?: Maybe<IBlock_Template_Bool_Exp>;
  block_templates_aggregate?: Maybe<IBlock_Template_Aggregate_Bool_Exp>;
  circuits?: Maybe<ICircuit_Bool_Exp>;
  circuits_aggregate?: Maybe<ICircuit_Aggregate_Bool_Exp>;
  coach_translations?: Maybe<ICoach_Translation_Bool_Exp>;
  coach_translations_aggregate?: Maybe<ICoach_Translation_Aggregate_Bool_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  exercises?: Maybe<IExercise_Bool_Exp>;
  exercises_aggregate?: Maybe<IExercise_Aggregate_Bool_Exp>;
  fiscal_id_number?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_verified?: Maybe<IBoolean_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  phone?: Maybe<IString_Comparison_Exp>;
  platform_content_access?: Maybe<IBoolean_Comparison_Exp>;
  platform_fee?: Maybe<IFloat8_Comparison_Exp>;
  profile_picture?: Maybe<IString_Comparison_Exp>;
  public?: Maybe<IBoolean_Comparison_Exp>;
  spoken_languages?: Maybe<I_Text_Comparison_Exp>;
  sports?: Maybe<ICoach_Sport_Bool_Exp>;
  sports_aggregate?: Maybe<ICoach_Sport_Aggregate_Bool_Exp>;
  subscription_plans?: Maybe<ISubscription_Plan_Bool_Exp>;
  subscription_plans_aggregate?: Maybe<ISubscription_Plan_Aggregate_Bool_Exp>;
  user?: Maybe<IUser_Bool_Exp>;
  user_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach" */
export enum ICoach_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachPkey = 'coach_pkey'
}

/** input type for incrementing numeric columns in table "coach" */
export type ICoach_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  platform_fee?: Maybe<Scalars['float8']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach" */
export type ICoach_Insert_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  athletes?: Maybe<IAthlete_Arr_Rel_Insert_Input>;
  block_templates?: Maybe<IBlock_Template_Arr_Rel_Insert_Input>;
  circuits?: Maybe<ICircuit_Arr_Rel_Insert_Input>;
  coach_translations?: Maybe<ICoach_Translation_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exercises?: Maybe<IExercise_Arr_Rel_Insert_Input>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_content_access?: Maybe<Scalars['Boolean']>;
  platform_fee?: Maybe<Scalars['float8']>;
  profile_picture?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  spoken_languages?: Maybe<Scalars['_text']>;
  sports?: Maybe<ICoach_Sport_Arr_Rel_Insert_Input>;
  subscription_plans?: Maybe<ISubscription_Plan_Arr_Rel_Insert_Input>;
  user?: Maybe<IUser_Obj_Rel_Insert_Input>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "coach" */
export type ICoach_Max_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  profile_picture?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "coach" */
export type ICoach_Min_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  profile_picture?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "coach" */
export type ICoach_Obj_Rel_Insert_Input = {
  data: ICoach_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ICoach_On_Conflict>;
};

/** on_conflict condition type for table "coach" */
export type ICoach_On_Conflict = {
  constraint: ICoach_Constraint;
  update_columns?: Array<ICoach_Update_Column>;
  where?: Maybe<ICoach_Bool_Exp>;
};

/** Ordering options when selecting data from "coach". */
export type ICoach_Order_By = {
  address_city?: Maybe<IOrder_By>;
  address_country?: Maybe<IOrder_By>;
  address_postal_code?: Maybe<IOrder_By>;
  address_street?: Maybe<IOrder_By>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Order_By>;
  block_templates_aggregate?: Maybe<IBlock_Template_Aggregate_Order_By>;
  circuits_aggregate?: Maybe<ICircuit_Aggregate_Order_By>;
  coach_translations_aggregate?: Maybe<ICoach_Translation_Aggregate_Order_By>;
  created_at?: Maybe<IOrder_By>;
  exercises_aggregate?: Maybe<IExercise_Aggregate_Order_By>;
  fiscal_id_number?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_verified?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  phone?: Maybe<IOrder_By>;
  platform_content_access?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  profile_picture?: Maybe<IOrder_By>;
  public?: Maybe<IOrder_By>;
  spoken_languages?: Maybe<IOrder_By>;
  sports_aggregate?: Maybe<ICoach_Sport_Aggregate_Order_By>;
  subscription_plans_aggregate?: Maybe<ISubscription_Plan_Aggregate_Order_By>;
  user?: Maybe<IUser_Order_By>;
  user_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: coach */
export type ICoach_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach" */
export enum ICoach_Select_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Public = 'public',
  /** column name */
  SpokenLanguages = 'spoken_languages',
  /** column name */
  UserId = 'user_id'
}

/** select "coach_aggregate_bool_exp_avg_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_bool_and_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  Public = 'public'
}

/** select "coach_aggregate_bool_exp_bool_or_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  Public = 'public'
}

/** select "coach_aggregate_bool_exp_corr_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_max_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_min_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_sum_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "coach_aggregate_bool_exp_var_samp_arguments_columns" columns of table "coach" */
export enum ICoach_Select_Column_Coach_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  PlatformFee = 'platform_fee'
}

/** input type for updating data in table "coach" */
export type ICoach_Set_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_content_access?: Maybe<Scalars['Boolean']>;
  platform_fee?: Maybe<Scalars['float8']>;
  profile_picture?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  spoken_languages?: Maybe<Scalars['_text']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type ICoach_Sport_Aggregate_Bool_Exp = {
  count?: Maybe<ICoach_Sport_Aggregate_Bool_Exp_Count>;
};

export type ICoach_Sport_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICoach_Sport_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Sport_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "coach_sport" */
export type ICoach_Sport_Aggregate_Order_By = {
  avg?: Maybe<ICoach_Sport_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICoach_Sport_Max_Order_By>;
  min?: Maybe<ICoach_Sport_Min_Order_By>;
  stddev?: Maybe<ICoach_Sport_Stddev_Order_By>;
  stddev_pop?: Maybe<ICoach_Sport_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICoach_Sport_Stddev_Samp_Order_By>;
  sum?: Maybe<ICoach_Sport_Sum_Order_By>;
  var_pop?: Maybe<ICoach_Sport_Var_Pop_Order_By>;
  var_samp?: Maybe<ICoach_Sport_Var_Samp_Order_By>;
  variance?: Maybe<ICoach_Sport_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach_sport" */
export type ICoach_Sport_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Sport_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICoach_Sport_On_Conflict>;
};

/** order by avg() on columns of table "coach_sport" */
export type ICoach_Sport_Avg_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach_sport". All fields are combined with a logical 'AND'. */
export type ICoach_Sport_Bool_Exp = {
  _and?: Maybe<Array<ICoach_Sport_Bool_Exp>>;
  _not?: Maybe<ICoach_Sport_Bool_Exp>;
  _or?: Maybe<Array<ICoach_Sport_Bool_Exp>>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IName_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach_sport" */
export enum ICoach_Sport_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachSportPkey = 'coach_sport_pkey'
}

/** input type for incrementing numeric columns in table "coach_sport" */
export type ICoach_Sport_Inc_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_sport" */
export type ICoach_Sport_Insert_Input = {
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by max() on columns of table "coach_sport" */
export type ICoach_Sport_Max_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "coach_sport" */
export type ICoach_Sport_Min_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "coach_sport" */
export type ICoach_Sport_On_Conflict = {
  constraint: ICoach_Sport_Constraint;
  update_columns?: Array<ICoach_Sport_Update_Column>;
  where?: Maybe<ICoach_Sport_Bool_Exp>;
};

/** Ordering options when selecting data from "coach_sport". */
export type ICoach_Sport_Order_By = {
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: coach_sport */
export type ICoach_Sport_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach_sport" */
export enum ICoach_Sport_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

/** input type for updating data in table "coach_sport" */
export type ICoach_Sport_Set_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by stddev() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach_sport" */
export type ICoach_Sport_Stddev_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "coach_sport" */
export type ICoach_Sport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Sport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Sport_Stream_Cursor_Value_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
};

/** order by sum() on columns of table "coach_sport" */
export type ICoach_Sport_Sum_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** update columns of table "coach_sport" */
export enum ICoach_Sport_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  SportId = 'sport_id'
}

export type ICoach_Sport_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICoach_Sport_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICoach_Sport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Sport_Bool_Exp;
};

/** order by var_pop() on columns of table "coach_sport" */
export type ICoach_Sport_Var_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach_sport" */
export type ICoach_Sport_Var_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "coach_sport" */
export type ICoach_Sport_Variance_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev() on columns of table "coach" */
export type ICoach_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach" */
export type ICoach_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach" */
export type ICoach_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "coach" */
export type ICoach_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Stream_Cursor_Value_Input = {
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_postal_code?: Maybe<Scalars['String']>;
  address_street?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  fiscal_id_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_content_access?: Maybe<Scalars['Boolean']>;
  platform_fee?: Maybe<Scalars['float8']>;
  profile_picture?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  spoken_languages?: Maybe<Scalars['_text']>;
  user_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coach" */
export type ICoach_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

export type ICoach_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<ICoach_Translation_Aggregate_Bool_Exp_Count>;
};

export type ICoach_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ICoach_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ICoach_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "coach_translation" */
export type ICoach_Translation_Aggregate_Order_By = {
  avg?: Maybe<ICoach_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ICoach_Translation_Max_Order_By>;
  min?: Maybe<ICoach_Translation_Min_Order_By>;
  stddev?: Maybe<ICoach_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<ICoach_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ICoach_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<ICoach_Translation_Sum_Order_By>;
  var_pop?: Maybe<ICoach_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<ICoach_Translation_Var_Samp_Order_By>;
  variance?: Maybe<ICoach_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "coach_translation" */
export type ICoach_Translation_Arr_Rel_Insert_Input = {
  data: Array<ICoach_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ICoach_Translation_On_Conflict>;
};

/** order by avg() on columns of table "coach_translation" */
export type ICoach_Translation_Avg_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coach_translation". All fields are combined with a logical 'AND'. */
export type ICoach_Translation_Bool_Exp = {
  _and?: Maybe<Array<ICoach_Translation_Bool_Exp>>;
  _not?: Maybe<ICoach_Translation_Bool_Exp>;
  _or?: Maybe<Array<ICoach_Translation_Bool_Exp>>;
  bio?: Maybe<IString_Comparison_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "coach_translation" */
export enum ICoach_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoachTranslationPkey = 'coach_translation_pkey'
}

/** input type for incrementing numeric columns in table "coach_translation" */
export type ICoach_Translation_Inc_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "coach_translation" */
export type ICoach_Translation_Insert_Input = {
  bio?: Maybe<Scalars['String']>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "coach_translation" */
export type ICoach_Translation_Max_Order_By = {
  bio?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "coach_translation" */
export type ICoach_Translation_Min_Order_By = {
  bio?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "coach_translation" */
export type ICoach_Translation_On_Conflict = {
  constraint: ICoach_Translation_Constraint;
  update_columns?: Array<ICoach_Translation_Update_Column>;
  where?: Maybe<ICoach_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "coach_translation". */
export type ICoach_Translation_Order_By = {
  bio?: Maybe<IOrder_By>;
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: coach_translation */
export type ICoach_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coach_translation" */
export enum ICoach_Translation_Select_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id'
}

/** input type for updating data in table "coach_translation" */
export type ICoach_Translation_Set_Input = {
  bio?: Maybe<Scalars['String']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "coach_translation" */
export type ICoach_Translation_Stddev_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "coach_translation" */
export type ICoach_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoach_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoach_Translation_Stream_Cursor_Value_Input = {
  bio?: Maybe<Scalars['String']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "coach_translation" */
export type ICoach_Translation_Sum_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "coach_translation" */
export enum ICoach_Translation_Update_Column {
  /** column name */
  Bio = 'bio',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id'
}

export type ICoach_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICoach_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICoach_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "coach_translation" */
export type ICoach_Translation_Var_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach_translation" */
export type ICoach_Translation_Var_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "coach_translation" */
export type ICoach_Translation_Variance_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "coach" */
export enum ICoach_Update_Column {
  /** column name */
  AddressCity = 'address_city',
  /** column name */
  AddressCountry = 'address_country',
  /** column name */
  AddressPostalCode = 'address_postal_code',
  /** column name */
  AddressStreet = 'address_street',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FiscalIdNumber = 'fiscal_id_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlatformContentAccess = 'platform_content_access',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  Public = 'public',
  /** column name */
  SpokenLanguages = 'spoken_languages',
  /** column name */
  UserId = 'user_id'
}

export type ICoach_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICoach_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICoach_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoach_Bool_Exp;
};

/** order by var_pop() on columns of table "coach" */
export type ICoach_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "coach" */
export type ICoach_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "coach" */
export type ICoach_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  user_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "coupon". All fields are combined with a logical 'AND'. */
export type ICoupon_Bool_Exp = {
  _and?: Maybe<Array<ICoupon_Bool_Exp>>;
  _not?: Maybe<ICoupon_Bool_Exp>;
  _or?: Maybe<Array<ICoupon_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  duration?: Maybe<IString_Comparison_Exp>;
  duration_in_months?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  percent_off?: Maybe<INumeric_Comparison_Exp>;
  promo_code?: Maybe<IString_Comparison_Exp>;
  stripe_coupon_id?: Maybe<IString_Comparison_Exp>;
  stripe_product_id?: Maybe<IString_Comparison_Exp>;
  subscription_plan?: Maybe<ISubscription_Plan_Bool_Exp>;
  times_redeemed?: Maybe<IInt_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  valid?: Maybe<IBoolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "coupon" */
export enum ICoupon_Constraint {
  /** unique or primary key constraint on columns "stripe_coupon_id" */
  CouponStripeCouponIdKey = 'coupon_stripe_coupon_id_key',
  /** unique or primary key constraint on columns "id" */
  CouponsPkey = 'coupons_pkey'
}

/** input type for incrementing numeric columns in table "coupon" */
export type ICoupon_Inc_Input = {
  duration_in_months?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  percent_off?: Maybe<Scalars['numeric']>;
  times_redeemed?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "coupon" */
export type ICoupon_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['String']>;
  duration_in_months?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percent_off?: Maybe<Scalars['numeric']>;
  promo_code?: Maybe<Scalars['String']>;
  stripe_coupon_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  subscription_plan?: Maybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  times_redeemed?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** on_conflict condition type for table "coupon" */
export type ICoupon_On_Conflict = {
  constraint: ICoupon_Constraint;
  update_columns?: Array<ICoupon_Update_Column>;
  where?: Maybe<ICoupon_Bool_Exp>;
};

/** Ordering options when selecting data from "coupon". */
export type ICoupon_Order_By = {
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  duration_in_months?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  percent_off?: Maybe<IOrder_By>;
  promo_code?: Maybe<IOrder_By>;
  stripe_coupon_id?: Maybe<IOrder_By>;
  stripe_product_id?: Maybe<IOrder_By>;
  subscription_plan?: Maybe<ISubscription_Plan_Order_By>;
  times_redeemed?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  valid?: Maybe<IOrder_By>;
};

/** primary key columns input for table: coupon */
export type ICoupon_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "coupon" */
export enum ICoupon_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percent_off',
  /** column name */
  PromoCode = 'promo_code',
  /** column name */
  StripeCouponId = 'stripe_coupon_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TimesRedeemed = 'times_redeemed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valid = 'valid'
}

/** input type for updating data in table "coupon" */
export type ICoupon_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['String']>;
  duration_in_months?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percent_off?: Maybe<Scalars['numeric']>;
  promo_code?: Maybe<Scalars['String']>;
  stripe_coupon_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  times_redeemed?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "coupon" */
export type ICoupon_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ICoupon_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ICoupon_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['String']>;
  duration_in_months?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  percent_off?: Maybe<Scalars['numeric']>;
  promo_code?: Maybe<Scalars['String']>;
  stripe_coupon_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  times_redeemed?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "coupon" */
export enum ICoupon_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PercentOff = 'percent_off',
  /** column name */
  PromoCode = 'promo_code',
  /** column name */
  StripeCouponId = 'stripe_coupon_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  TimesRedeemed = 'times_redeemed',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Valid = 'valid'
}

export type ICoupon_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ICoupon_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ICoupon_Set_Input>;
  /** filter the rows which have to be updated */
  where: ICoupon_Bool_Exp;
};

/** ordering argument of a cursor */
export enum ICursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type IDate_Comparison_Exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

export type IExercise_Aggregate_Bool_Exp = {
  count?: Maybe<IExercise_Aggregate_Bool_Exp_Count>;
};

export type IExercise_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IExercise_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IExercise_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "exercise" */
export type IExercise_Aggregate_Order_By = {
  avg?: Maybe<IExercise_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IExercise_Max_Order_By>;
  min?: Maybe<IExercise_Min_Order_By>;
  stddev?: Maybe<IExercise_Stddev_Order_By>;
  stddev_pop?: Maybe<IExercise_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IExercise_Stddev_Samp_Order_By>;
  sum?: Maybe<IExercise_Sum_Order_By>;
  var_pop?: Maybe<IExercise_Var_Pop_Order_By>;
  var_samp?: Maybe<IExercise_Var_Samp_Order_By>;
  variance?: Maybe<IExercise_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise" */
export type IExercise_Arr_Rel_Insert_Input = {
  data: Array<IExercise_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IExercise_On_Conflict>;
};

/** order by avg() on columns of table "exercise" */
export type IExercise_Avg_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "exercise". All fields are combined with a logical 'AND'. */
export type IExercise_Bool_Exp = {
  _and?: Maybe<Array<IExercise_Bool_Exp>>;
  _not?: Maybe<IExercise_Bool_Exp>;
  _or?: Maybe<Array<IExercise_Bool_Exp>>;
  circuit_exercises?: Maybe<ICircuit_Exercise_Bool_Exp>;
  circuit_exercises_aggregate?: Maybe<ICircuit_Exercise_Aggregate_Bool_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  exercise_translations?: Maybe<IExercise_Translation_Bool_Exp>;
  exercise_translations_aggregate?: Maybe<IExercise_Translation_Aggregate_Bool_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  media_url?: Maybe<IString_Comparison_Exp>;
  target?: Maybe<IString_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise" */
export enum IExercise_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExercisePkey = 'exercise_pkey'
}

/** input type for incrementing numeric columns in table "exercise" */
export type IExercise_Inc_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise" */
export type IExercise_Insert_Input = {
  circuit_exercises?: Maybe<ICircuit_Exercise_Arr_Rel_Insert_Input>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  exercise_translations?: Maybe<IExercise_Translation_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  media_url?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise" */
export type IExercise_Max_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  media_url?: Maybe<IOrder_By>;
  target?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "exercise" */
export type IExercise_Min_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  media_url?: Maybe<IOrder_By>;
  target?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "exercise" */
export type IExercise_Obj_Rel_Insert_Input = {
  data: IExercise_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IExercise_On_Conflict>;
};

/** on_conflict condition type for table "exercise" */
export type IExercise_On_Conflict = {
  constraint: IExercise_Constraint;
  update_columns?: Array<IExercise_Update_Column>;
  where?: Maybe<IExercise_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise". */
export type IExercise_Order_By = {
  circuit_exercises_aggregate?: Maybe<ICircuit_Exercise_Aggregate_Order_By>;
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  exercise_translations_aggregate?: Maybe<IExercise_Translation_Aggregate_Order_By>;
  id?: Maybe<IOrder_By>;
  media_url?: Maybe<IOrder_By>;
  target?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
};

/** primary key columns input for table: exercise */
export type IExercise_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exercise" */
export enum IExercise_Select_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "exercise" */
export type IExercise_Set_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_url?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "exercise" */
export type IExercise_Stddev_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "exercise" */
export type IExercise_Stddev_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "exercise" */
export type IExercise_Stddev_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "exercise" */
export type IExercise_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IExercise_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IExercise_Stream_Cursor_Value_Input = {
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  media_url?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "exercise" */
export type IExercise_Sum_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

export type IExercise_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<IExercise_Translation_Aggregate_Bool_Exp_Count>;
};

export type IExercise_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IExercise_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IExercise_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "exercise_translation" */
export type IExercise_Translation_Aggregate_Order_By = {
  avg?: Maybe<IExercise_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IExercise_Translation_Max_Order_By>;
  min?: Maybe<IExercise_Translation_Min_Order_By>;
  stddev?: Maybe<IExercise_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<IExercise_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IExercise_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<IExercise_Translation_Sum_Order_By>;
  var_pop?: Maybe<IExercise_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<IExercise_Translation_Var_Samp_Order_By>;
  variance?: Maybe<IExercise_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "exercise_translation" */
export type IExercise_Translation_Arr_Rel_Insert_Input = {
  data: Array<IExercise_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IExercise_Translation_On_Conflict>;
};

/** order by avg() on columns of table "exercise_translation" */
export type IExercise_Translation_Avg_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "exercise_translation". All fields are combined with a logical 'AND'. */
export type IExercise_Translation_Bool_Exp = {
  _and?: Maybe<Array<IExercise_Translation_Bool_Exp>>;
  _not?: Maybe<IExercise_Translation_Bool_Exp>;
  _or?: Maybe<Array<IExercise_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  exercise?: Maybe<IExercise_Bool_Exp>;
  exercise_id?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "exercise_translation" */
export enum IExercise_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExerciseTranslationPkey = 'exercise_translation_pkey'
}

/** input type for incrementing numeric columns in table "exercise_translation" */
export type IExercise_Translation_Inc_Input = {
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "exercise_translation" */
export type IExercise_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  exercise?: Maybe<IExercise_Obj_Rel_Insert_Input>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exercise_translation" */
export type IExercise_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "exercise_translation" */
export type IExercise_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "exercise_translation" */
export type IExercise_Translation_On_Conflict = {
  constraint: IExercise_Translation_Constraint;
  update_columns?: Array<IExercise_Translation_Update_Column>;
  where?: Maybe<IExercise_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "exercise_translation". */
export type IExercise_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  exercise?: Maybe<IExercise_Order_By>;
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
};

/** primary key columns input for table: exercise_translation */
export type IExercise_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "exercise_translation" */
export enum IExercise_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "exercise_translation" */
export type IExercise_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Pop_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "exercise_translation" */
export type IExercise_Translation_Stddev_Samp_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "exercise_translation" */
export type IExercise_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IExercise_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IExercise_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  exercise_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "exercise_translation" */
export type IExercise_Translation_Sum_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "exercise_translation" */
export enum IExercise_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  ExerciseId = 'exercise_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name'
}

export type IExercise_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IExercise_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IExercise_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IExercise_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "exercise_translation" */
export type IExercise_Translation_Var_Pop_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "exercise_translation" */
export type IExercise_Translation_Var_Samp_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "exercise_translation" */
export type IExercise_Translation_Variance_Order_By = {
  exercise_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "exercise" */
export enum IExercise_Update_Column {
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  Id = 'id',
  /** column name */
  MediaUrl = 'media_url',
  /** column name */
  Target = 'target',
  /** column name */
  Type = 'type'
}

export type IExercise_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IExercise_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IExercise_Set_Input>;
  /** filter the rows which have to be updated */
  where: IExercise_Bool_Exp;
};

/** order by var_pop() on columns of table "exercise" */
export type IExercise_Var_Pop_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "exercise" */
export type IExercise_Var_Samp_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "exercise" */
export type IExercise_Variance_Order_By = {
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type IFloat8_Comparison_Exp = {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
};

/** Boolean expression to filter rows from the table "locale". All fields are combined with a logical 'AND'. */
export type ILocale_Bool_Exp = {
  _and?: Maybe<Array<ILocale_Bool_Exp>>;
  _not?: Maybe<ILocale_Bool_Exp>;
  _or?: Maybe<Array<ILocale_Bool_Exp>>;
  circuit_translations?: Maybe<ICircuit_Translation_Bool_Exp>;
  circuit_translations_aggregate?: Maybe<ICircuit_Translation_Aggregate_Bool_Exp>;
  coach_translations?: Maybe<ICoach_Translation_Bool_Exp>;
  coach_translations_aggregate?: Maybe<ICoach_Translation_Aggregate_Bool_Exp>;
  code?: Maybe<IString_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  exercise_translations?: Maybe<IExercise_Translation_Bool_Exp>;
  exercise_translations_aggregate?: Maybe<IExercise_Translation_Aggregate_Bool_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  language?: Maybe<IString_Comparison_Exp>;
  review_translations?: Maybe<IReview_Translation_Bool_Exp>;
  review_translations_aggregate?: Maybe<IReview_Translation_Aggregate_Bool_Exp>;
  sport_translations?: Maybe<ISport_Translation_Bool_Exp>;
  sport_translations_aggregate?: Maybe<ISport_Translation_Aggregate_Bool_Exp>;
  subscription_plan_translations?: Maybe<ISubscription_Plan_Translation_Bool_Exp>;
  subscription_plan_translations_aggregate?: Maybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp>;
  workout_altimetry_translations?: Maybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  workout_altimetry_translations_aggregate?: Maybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp>;
  workout_terrain_translations?: Maybe<IWorkout_Terrain_Translation_Bool_Exp>;
  workout_terrain_translations_aggregate?: Maybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp>;
  workout_type_translations?: Maybe<IWorkout_Type_Translation_Bool_Exp>;
  workout_type_translations_aggregate?: Maybe<IWorkout_Type_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "locale" */
export enum ILocale_Constraint {
  /** unique or primary key constraint on columns "code" */
  LocaleCodeKey = 'locale_code_key',
  /** unique or primary key constraint on columns "language" */
  LocaleLanguageKey = 'locale_language_key',
  /** unique or primary key constraint on columns "id" */
  LocalePkey = 'locale_pkey'
}

/** input type for incrementing numeric columns in table "locale" */
export type ILocale_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "locale" */
export type ILocale_Insert_Input = {
  circuit_translations?: Maybe<ICircuit_Translation_Arr_Rel_Insert_Input>;
  coach_translations?: Maybe<ICoach_Translation_Arr_Rel_Insert_Input>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  exercise_translations?: Maybe<IExercise_Translation_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
  review_translations?: Maybe<IReview_Translation_Arr_Rel_Insert_Input>;
  sport_translations?: Maybe<ISport_Translation_Arr_Rel_Insert_Input>;
  subscription_plan_translations?: Maybe<ISubscription_Plan_Translation_Arr_Rel_Insert_Input>;
  workout_altimetry_translations?: Maybe<IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input>;
  workout_terrain_translations?: Maybe<IWorkout_Terrain_Translation_Arr_Rel_Insert_Input>;
  workout_type_translations?: Maybe<IWorkout_Type_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "locale" */
export type ILocale_Obj_Rel_Insert_Input = {
  data: ILocale_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ILocale_On_Conflict>;
};

/** on_conflict condition type for table "locale" */
export type ILocale_On_Conflict = {
  constraint: ILocale_Constraint;
  update_columns?: Array<ILocale_Update_Column>;
  where?: Maybe<ILocale_Bool_Exp>;
};

/** Ordering options when selecting data from "locale". */
export type ILocale_Order_By = {
  circuit_translations_aggregate?: Maybe<ICircuit_Translation_Aggregate_Order_By>;
  coach_translations_aggregate?: Maybe<ICoach_Translation_Aggregate_Order_By>;
  code?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  exercise_translations_aggregate?: Maybe<IExercise_Translation_Aggregate_Order_By>;
  id?: Maybe<IOrder_By>;
  language?: Maybe<IOrder_By>;
  review_translations_aggregate?: Maybe<IReview_Translation_Aggregate_Order_By>;
  sport_translations_aggregate?: Maybe<ISport_Translation_Aggregate_Order_By>;
  subscription_plan_translations_aggregate?: Maybe<ISubscription_Plan_Translation_Aggregate_Order_By>;
  workout_altimetry_translations_aggregate?: Maybe<IWorkout_Altimetry_Translation_Aggregate_Order_By>;
  workout_terrain_translations_aggregate?: Maybe<IWorkout_Terrain_Translation_Aggregate_Order_By>;
  workout_type_translations_aggregate?: Maybe<IWorkout_Type_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: locale */
export type ILocale_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "locale" */
export enum ILocale_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language'
}

/** input type for updating data in table "locale" */
export type ILocale_Set_Input = {
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "locale" */
export type ILocale_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ILocale_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ILocale_Stream_Cursor_Value_Input = {
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['String']>;
};

/** update columns of table "locale" */
export enum ILocale_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language'
}

export type ILocale_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ILocale_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ILocale_Set_Input>;
  /** filter the rows which have to be updated */
  where: ILocale_Bool_Exp;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type IName_Comparison_Exp = {
  _eq?: Maybe<Scalars['name']>;
  _gt?: Maybe<Scalars['name']>;
  _gte?: Maybe<Scalars['name']>;
  _in?: Maybe<Array<Scalars['name']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['name']>;
  _lte?: Maybe<Scalars['name']>;
  _neq?: Maybe<Scalars['name']>;
  _nin?: Maybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type INumeric_Comparison_Exp = {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum IOrder_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Boolean expression to filter rows from the table "review". All fields are combined with a logical 'AND'. */
export type IReview_Bool_Exp = {
  _and?: Maybe<Array<IReview_Bool_Exp>>;
  _not?: Maybe<IReview_Bool_Exp>;
  _or?: Maybe<Array<IReview_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  image?: Maybe<IString_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  review_translations?: Maybe<IReview_Translation_Bool_Exp>;
  review_translations_aggregate?: Maybe<IReview_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "review" */
export enum IReview_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewPkey = 'review_pkey'
}

/** input type for incrementing numeric columns in table "review" */
export type IReview_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "review" */
export type IReview_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  review_translations?: Maybe<IReview_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "review" */
export type IReview_Obj_Rel_Insert_Input = {
  data: IReview_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IReview_On_Conflict>;
};

/** on_conflict condition type for table "review" */
export type IReview_On_Conflict = {
  constraint: IReview_Constraint;
  update_columns?: Array<IReview_Update_Column>;
  where?: Maybe<IReview_Bool_Exp>;
};

/** Ordering options when selecting data from "review". */
export type IReview_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  image?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  review_translations_aggregate?: Maybe<IReview_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: review */
export type IReview_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "review" */
export enum IReview_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "review" */
export type IReview_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "review" */
export type IReview_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IReview_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IReview_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type IReview_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<IReview_Translation_Aggregate_Bool_Exp_Count>;
};

export type IReview_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IReview_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IReview_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "review_translation" */
export type IReview_Translation_Aggregate_Order_By = {
  avg?: Maybe<IReview_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IReview_Translation_Max_Order_By>;
  min?: Maybe<IReview_Translation_Min_Order_By>;
  stddev?: Maybe<IReview_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<IReview_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IReview_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<IReview_Translation_Sum_Order_By>;
  var_pop?: Maybe<IReview_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<IReview_Translation_Var_Samp_Order_By>;
  variance?: Maybe<IReview_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "review_translation" */
export type IReview_Translation_Arr_Rel_Insert_Input = {
  data: Array<IReview_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IReview_Translation_On_Conflict>;
};

/** order by avg() on columns of table "review_translation" */
export type IReview_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "review_translation". All fields are combined with a logical 'AND'. */
export type IReview_Translation_Bool_Exp = {
  _and?: Maybe<Array<IReview_Translation_Bool_Exp>>;
  _not?: Maybe<IReview_Translation_Bool_Exp>;
  _or?: Maybe<Array<IReview_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  review?: Maybe<IReview_Bool_Exp>;
  review_id?: Maybe<IInt_Comparison_Exp>;
  text?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_translation" */
export enum IReview_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewTranslationPkey = 'review_translation_pkey'
}

/** input type for incrementing numeric columns in table "review_translation" */
export type IReview_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  review_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "review_translation" */
export type IReview_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  review?: Maybe<IReview_Obj_Rel_Insert_Input>;
  review_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "review_translation" */
export type IReview_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
  text?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "review_translation" */
export type IReview_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
  text?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "review_translation" */
export type IReview_Translation_On_Conflict = {
  constraint: IReview_Translation_Constraint;
  update_columns?: Array<IReview_Translation_Update_Column>;
  where?: Maybe<IReview_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "review_translation". */
export type IReview_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  review?: Maybe<IReview_Order_By>;
  review_id?: Maybe<IOrder_By>;
  text?: Maybe<IOrder_By>;
};

/** primary key columns input for table: review_translation */
export type IReview_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "review_translation" */
export enum IReview_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Text = 'text'
}

/** input type for updating data in table "review_translation" */
export type IReview_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  review_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "review_translation" */
export type IReview_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "review_translation" */
export type IReview_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IReview_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IReview_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  review_id?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "review_translation" */
export type IReview_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** update columns of table "review_translation" */
export enum IReview_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  Text = 'text'
}

export type IReview_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IReview_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IReview_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IReview_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "review_translation" */
export type IReview_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "review_translation" */
export type IReview_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "review_translation" */
export type IReview_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  review_id?: Maybe<IOrder_By>;
};

/** update columns of table "review" */
export enum IReview_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

export type IReview_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IReview_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IReview_Set_Input>;
  /** filter the rows which have to be updated */
  where: IReview_Bool_Exp;
};

/** Boolean expression to filter rows from the table "sport". All fields are combined with a logical 'AND'. */
export type ISport_Bool_Exp = {
  _and?: Maybe<Array<ISport_Bool_Exp>>;
  _not?: Maybe<ISport_Bool_Exp>;
  _or?: Maybe<Array<ISport_Bool_Exp>>;
  athlete_blocks?: Maybe<IAthlete_Block_Bool_Exp>;
  athlete_blocks_aggregate?: Maybe<IAthlete_Block_Aggregate_Bool_Exp>;
  athlete_challenges?: Maybe<IAthlete_Challenge_Bool_Exp>;
  athlete_challenges_aggregate?: Maybe<IAthlete_Challenge_Aggregate_Bool_Exp>;
  athlete_weeks?: Maybe<IAthlete_Week_Bool_Exp>;
  athlete_weeks_aggregate?: Maybe<IAthlete_Week_Aggregate_Bool_Exp>;
  athletes?: Maybe<IAthlete_Bool_Exp>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Bool_Exp>;
  avatar?: Maybe<IString_Comparison_Exp>;
  block_templates?: Maybe<IBlock_Template_Bool_Exp>;
  block_templates_aggregate?: Maybe<IBlock_Template_Aggregate_Bool_Exp>;
  circuits?: Maybe<ICircuit_Sport_Bool_Exp>;
  circuits_aggregate?: Maybe<ICircuit_Sport_Aggregate_Bool_Exp>;
  coaches?: Maybe<ICoach_Sport_Bool_Exp>;
  coaches_aggregate?: Maybe<ICoach_Sport_Aggregate_Bool_Exp>;
  id?: Maybe<IName_Comparison_Exp>;
  image?: Maybe<IString_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  sport_translations?: Maybe<ISport_Translation_Bool_Exp>;
  sport_translations_aggregate?: Maybe<ISport_Translation_Aggregate_Bool_Exp>;
  subscription_plan_templates?: Maybe<ISubscription_Plan_Template_Bool_Exp>;
  subscription_plan_templates_aggregate?: Maybe<ISubscription_Plan_Template_Aggregate_Bool_Exp>;
  subscription_plans?: Maybe<ISubscription_Plan_Bool_Exp>;
  subscription_plans_aggregate?: Maybe<ISubscription_Plan_Aggregate_Bool_Exp>;
  week_templates?: Maybe<IWeek_Template_Bool_Exp>;
  week_templates_aggregate?: Maybe<IWeek_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "sport" */
export enum ISport_Constraint {
  /** unique or primary key constraint on columns "id" */
  SportPkey = 'sport_pkey'
}

/** input type for inserting data into table "sport" */
export type ISport_Insert_Input = {
  athlete_blocks?: Maybe<IAthlete_Block_Arr_Rel_Insert_Input>;
  athlete_challenges?: Maybe<IAthlete_Challenge_Arr_Rel_Insert_Input>;
  athlete_weeks?: Maybe<IAthlete_Week_Arr_Rel_Insert_Input>;
  athletes?: Maybe<IAthlete_Arr_Rel_Insert_Input>;
  avatar?: Maybe<Scalars['String']>;
  block_templates?: Maybe<IBlock_Template_Arr_Rel_Insert_Input>;
  circuits?: Maybe<ICircuit_Sport_Arr_Rel_Insert_Input>;
  coaches?: Maybe<ICoach_Sport_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['name']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sport_translations?: Maybe<ISport_Translation_Arr_Rel_Insert_Input>;
  subscription_plan_templates?: Maybe<ISubscription_Plan_Template_Arr_Rel_Insert_Input>;
  subscription_plans?: Maybe<ISubscription_Plan_Arr_Rel_Insert_Input>;
  week_templates?: Maybe<IWeek_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "sport" */
export type ISport_Obj_Rel_Insert_Input = {
  data: ISport_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ISport_On_Conflict>;
};

/** on_conflict condition type for table "sport" */
export type ISport_On_Conflict = {
  constraint: ISport_Constraint;
  update_columns?: Array<ISport_Update_Column>;
  where?: Maybe<ISport_Bool_Exp>;
};

/** Ordering options when selecting data from "sport". */
export type ISport_Order_By = {
  athlete_blocks_aggregate?: Maybe<IAthlete_Block_Aggregate_Order_By>;
  athlete_challenges_aggregate?: Maybe<IAthlete_Challenge_Aggregate_Order_By>;
  athlete_weeks_aggregate?: Maybe<IAthlete_Week_Aggregate_Order_By>;
  athletes_aggregate?: Maybe<IAthlete_Aggregate_Order_By>;
  avatar?: Maybe<IOrder_By>;
  block_templates_aggregate?: Maybe<IBlock_Template_Aggregate_Order_By>;
  circuits_aggregate?: Maybe<ICircuit_Sport_Aggregate_Order_By>;
  coaches_aggregate?: Maybe<ICoach_Sport_Aggregate_Order_By>;
  id?: Maybe<IOrder_By>;
  image?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  sport_translations_aggregate?: Maybe<ISport_Translation_Aggregate_Order_By>;
  subscription_plan_templates_aggregate?: Maybe<ISubscription_Plan_Template_Aggregate_Order_By>;
  subscription_plans_aggregate?: Maybe<ISubscription_Plan_Aggregate_Order_By>;
  week_templates_aggregate?: Maybe<IWeek_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: sport */
export type ISport_Pk_Columns_Input = {
  id: Scalars['name'];
};

/** select columns of table "sport" */
export enum ISport_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "sport" */
export type ISport_Set_Input = {
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['name']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "sport" */
export type ISport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISport_Stream_Cursor_Value_Input = {
  avatar?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['name']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type ISport_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<ISport_Translation_Aggregate_Bool_Exp_Count>;
};

export type ISport_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISport_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISport_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "sport_translation" */
export type ISport_Translation_Aggregate_Order_By = {
  avg?: Maybe<ISport_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISport_Translation_Max_Order_By>;
  min?: Maybe<ISport_Translation_Min_Order_By>;
  stddev?: Maybe<ISport_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<ISport_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISport_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<ISport_Translation_Sum_Order_By>;
  var_pop?: Maybe<ISport_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<ISport_Translation_Var_Samp_Order_By>;
  variance?: Maybe<ISport_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sport_translation" */
export type ISport_Translation_Arr_Rel_Insert_Input = {
  data: Array<ISport_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISport_Translation_On_Conflict>;
};

/** order by avg() on columns of table "sport_translation" */
export type ISport_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "sport_translation". All fields are combined with a logical 'AND'. */
export type ISport_Translation_Bool_Exp = {
  _and?: Maybe<Array<ISport_Translation_Bool_Exp>>;
  _not?: Maybe<ISport_Translation_Bool_Exp>;
  _or?: Maybe<Array<ISport_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IName_Comparison_Exp>;
  title?: Maybe<IString_Comparison_Exp>;
};

/** unique or primary key constraints on table "sport_translation" */
export enum ISport_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SportTranslationPkey = 'sport_translation_pkey'
}

/** input type for incrementing numeric columns in table "sport_translation" */
export type ISport_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "sport_translation" */
export type ISport_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['name']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sport_translation" */
export type ISport_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  title?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "sport_translation" */
export type ISport_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  title?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "sport_translation" */
export type ISport_Translation_On_Conflict = {
  constraint: ISport_Translation_Constraint;
  update_columns?: Array<ISport_Translation_Update_Column>;
  where?: Maybe<ISport_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "sport_translation". */
export type ISport_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  title?: Maybe<IOrder_By>;
};

/** primary key columns input for table: sport_translation */
export type ISport_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sport_translation" */
export enum ISport_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "sport_translation" */
export type ISport_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
  title?: Maybe<Scalars['String']>;
};

/** order by stddev() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "sport_translation" */
export type ISport_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "sport_translation" */
export type ISport_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISport_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISport_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['name']>;
  title?: Maybe<Scalars['String']>;
};

/** order by sum() on columns of table "sport_translation" */
export type ISport_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "sport_translation" */
export enum ISport_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  Title = 'title'
}

export type ISport_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISport_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISport_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISport_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "sport_translation" */
export type ISport_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "sport_translation" */
export type ISport_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "sport_translation" */
export type ISport_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
};

/** update columns of table "sport" */
export enum ISport_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  Name = 'name'
}

export type ISport_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISport_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISport_Bool_Exp;
};

export type ISubscription_Aggregate_Bool_Exp = {
  count?: Maybe<ISubscription_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription" */
export type ISubscription_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Max_Order_By>;
  min?: Maybe<ISubscription_Min_Order_By>;
  stddev?: Maybe<ISubscription_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription" */
export type ISubscription_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_On_Conflict>;
};

/** order by avg() on columns of table "subscription" */
export type ISubscription_Avg_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription". All fields are combined with a logical 'AND'. */
export type ISubscription_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Bool_Exp>>;
  _not?: Maybe<ISubscription_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  athlete_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  date_end?: Maybe<IDate_Comparison_Exp>;
  date_start?: Maybe<IDate_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  interval_count?: Maybe<IInt_Comparison_Exp>;
  price?: Maybe<IInt_Comparison_Exp>;
  status?: Maybe<IString_Comparison_Exp>;
  stripe_subscription_id?: Maybe<IString_Comparison_Exp>;
  subscription_payments?: Maybe<ISubscription_Payment_Bool_Exp>;
  subscription_payments_aggregate?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp>;
  subscription_plan?: Maybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription" */
export enum ISubscription_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPkey = 'subscription_pkey',
  /** unique or primary key constraint on columns "stripe_subscription_id" */
  SubscriptionStripeSubscriptionIdKey = 'subscription_stripe_subscription_id_key'
}

/** input type for incrementing numeric columns in table "subscription" */
export type ISubscription_Inc_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription" */
export type ISubscription_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_end?: Maybe<Scalars['date']>;
  date_start?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  subscription_payments?: Maybe<ISubscription_Payment_Arr_Rel_Insert_Input>;
  subscription_plan?: Maybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "subscription" */
export type ISubscription_Max_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  date_end?: Maybe<IOrder_By>;
  date_start?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_subscription_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription" */
export type ISubscription_Min_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  date_end?: Maybe<IOrder_By>;
  date_start?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_subscription_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "subscription" */
export type ISubscription_Obj_Rel_Insert_Input = {
  data: ISubscription_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_On_Conflict>;
};

/** on_conflict condition type for table "subscription" */
export type ISubscription_On_Conflict = {
  constraint: ISubscription_Constraint;
  update_columns?: Array<ISubscription_Update_Column>;
  where?: Maybe<ISubscription_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription". */
export type ISubscription_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  athlete_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  date_end?: Maybe<IOrder_By>;
  date_start?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  status?: Maybe<IOrder_By>;
  stripe_subscription_id?: Maybe<IOrder_By>;
  subscription_payments_aggregate?: Maybe<ISubscription_Payment_Aggregate_Order_By>;
  subscription_plan?: Maybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

export type ISubscription_Payment_Aggregate_Bool_Exp = {
  avg?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Avg>;
  corr?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Corr>;
  count?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Count>;
  covar_samp?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp>;
  max?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Max>;
  min?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Min>;
  stddev_samp?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Sum>;
  var_samp?: Maybe<ISubscription_Payment_Aggregate_Bool_Exp_Var_Samp>;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Avg = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Corr = {
  arguments: ISubscription_Payment_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Corr_Arguments = {
  X: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Payment_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Max = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Min = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Sum = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

export type ISubscription_Payment_Aggregate_Bool_Exp_Var_Samp = {
  arguments: ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Payment_Bool_Exp>;
  predicate: IFloat8_Comparison_Exp;
};

/** order by aggregate values of table "subscription_payment" */
export type ISubscription_Payment_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Payment_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Payment_Max_Order_By>;
  min?: Maybe<ISubscription_Payment_Min_Order_By>;
  stddev?: Maybe<ISubscription_Payment_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Payment_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Payment_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Payment_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Payment_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Payment_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Payment_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_payment" */
export type ISubscription_Payment_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Payment_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Payment_On_Conflict>;
};

/** order by avg() on columns of table "subscription_payment" */
export type ISubscription_Payment_Avg_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_payment". All fields are combined with a logical 'AND'. */
export type ISubscription_Payment_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Payment_Bool_Exp>>;
  _not?: Maybe<ISubscription_Payment_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Payment_Bool_Exp>>;
  amount?: Maybe<IFloat8_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  discount_name?: Maybe<IString_Comparison_Exp>;
  discount_percentage?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  platform_fee?: Maybe<IFloat8_Comparison_Exp>;
  stripe_charge_id?: Maybe<IString_Comparison_Exp>;
  subscription?: Maybe<ISubscription_Bool_Exp>;
  subscription_id?: Maybe<IInt_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_payment" */
export enum ISubscription_Payment_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPaymentPkey = 'subscription_payment_pkey'
}

/** input type for incrementing numeric columns in table "subscription_payment" */
export type ISubscription_Payment_Inc_Input = {
  amount?: Maybe<Scalars['float8']>;
  id?: Maybe<Scalars['Int']>;
  platform_fee?: Maybe<Scalars['float8']>;
  subscription_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_payment" */
export type ISubscription_Payment_Insert_Input = {
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_name?: Maybe<Scalars['String']>;
  discount_percentage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  platform_fee?: Maybe<Scalars['float8']>;
  stripe_charge_id?: Maybe<Scalars['String']>;
  subscription?: Maybe<ISubscription_Obj_Rel_Insert_Input>;
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_payment" */
export type ISubscription_Payment_Max_Order_By = {
  amount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  discount_name?: Maybe<IOrder_By>;
  discount_percentage?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  stripe_charge_id?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_payment" */
export type ISubscription_Payment_Min_Order_By = {
  amount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  discount_name?: Maybe<IOrder_By>;
  discount_percentage?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  stripe_charge_id?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_payment" */
export type ISubscription_Payment_On_Conflict = {
  constraint: ISubscription_Payment_Constraint;
  update_columns?: Array<ISubscription_Payment_Update_Column>;
  where?: Maybe<ISubscription_Payment_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_payment". */
export type ISubscription_Payment_Order_By = {
  amount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  discount_name?: Maybe<IOrder_By>;
  discount_percentage?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  stripe_charge_id?: Maybe<IOrder_By>;
  subscription?: Maybe<ISubscription_Order_By>;
  subscription_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription_payment */
export type ISubscription_Payment_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountName = 'discount_name',
  /** column name */
  DiscountPercentage = 'discount_percentage',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  StripeChargeId = 'stripe_charge_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "subscription_payment_aggregate_bool_exp_avg_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_corr_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_max_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_min_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_sum_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** select "subscription_payment_aggregate_bool_exp_var_samp_arguments_columns" columns of table "subscription_payment" */
export enum ISubscription_Payment_Select_Column_Subscription_Payment_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Amount = 'amount',
  /** column name */
  PlatformFee = 'platform_fee'
}

/** input type for updating data in table "subscription_payment" */
export type ISubscription_Payment_Set_Input = {
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_name?: Maybe<Scalars['String']>;
  discount_percentage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  platform_fee?: Maybe<Scalars['float8']>;
  stripe_charge_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Pop_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_payment" */
export type ISubscription_Payment_Stddev_Samp_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_payment" */
export type ISubscription_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Payment_Stream_Cursor_Value_Input = {
  amount?: Maybe<Scalars['float8']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  discount_name?: Maybe<Scalars['String']>;
  discount_percentage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  platform_fee?: Maybe<Scalars['float8']>;
  stripe_charge_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "subscription_payment" */
export type ISubscription_Payment_Sum_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** update columns of table "subscription_payment" */
export enum ISubscription_Payment_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DiscountName = 'discount_name',
  /** column name */
  DiscountPercentage = 'discount_percentage',
  /** column name */
  Id = 'id',
  /** column name */
  PlatformFee = 'platform_fee',
  /** column name */
  StripeChargeId = 'stripe_charge_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ISubscription_Payment_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Payment_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Payment_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_payment" */
export type ISubscription_Payment_Var_Pop_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_payment" */
export type ISubscription_Payment_Var_Samp_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_payment" */
export type ISubscription_Payment_Variance_Order_By = {
  amount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  platform_fee?: Maybe<IOrder_By>;
  subscription_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription */
export type ISubscription_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type ISubscription_Plan_Aggregate_Bool_Exp = {
  bool_and?: Maybe<ISubscription_Plan_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<ISubscription_Plan_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<ISubscription_Plan_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Bool_And = {
  arguments: ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type ISubscription_Plan_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Plan_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan" */
export type ISubscription_Plan_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Plan_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Plan_Max_Order_By>;
  min?: Maybe<ISubscription_Plan_Min_Order_By>;
  stddev?: Maybe<ISubscription_Plan_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Plan_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Plan_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Plan_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Plan_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Plan_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Plan_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan" */
export type ISubscription_Plan_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Plan_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan" */
export type ISubscription_Plan_Avg_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Plan_Bool_Exp>>;
  _not?: Maybe<ISubscription_Plan_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Plan_Bool_Exp>>;
  biannualy_discount?: Maybe<INumeric_Comparison_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coach_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  image?: Maybe<IString_Comparison_Exp>;
  is_verified?: Maybe<IBoolean_Comparison_Exp>;
  level?: Maybe<IInt_Comparison_Exp>;
  min_duration?: Maybe<INumeric_Comparison_Exp>;
  quarterly_discount?: Maybe<INumeric_Comparison_Exp>;
  recomended_duration?: Maybe<INumeric_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  stripe_product_id?: Maybe<IString_Comparison_Exp>;
  subscription_plan_prices?: Maybe<ISubscription_Plan_Price_Bool_Exp>;
  subscription_plan_prices_aggregate?: Maybe<ISubscription_Plan_Price_Aggregate_Bool_Exp>;
  subscription_plan_translations?: Maybe<ISubscription_Plan_Translation_Bool_Exp>;
  subscription_plan_translations_aggregate?: Maybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp>;
  subscriptions?: Maybe<ISubscription_Bool_Exp>;
  subscriptions_aggregate?: Maybe<ISubscription_Aggregate_Bool_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  weekly_price?: Maybe<INumeric_Comparison_Exp>;
  yearly_discount?: Maybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan" */
export enum ISubscription_Plan_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanPkey = 'subscription_plan_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan" */
export type ISubscription_Plan_Inc_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  coach_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan" */
export type ISubscription_Plan_Insert_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  subscription_plan_prices?: Maybe<ISubscription_Plan_Price_Arr_Rel_Insert_Input>;
  subscription_plan_translations?: Maybe<ISubscription_Plan_Translation_Arr_Rel_Insert_Input>;
  subscriptions?: Maybe<ISubscription_Arr_Rel_Insert_Input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "subscription_plan" */
export type ISubscription_Plan_Max_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  image?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  stripe_product_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan" */
export type ISubscription_Plan_Min_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  image?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  stripe_product_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "subscription_plan" */
export type ISubscription_Plan_Obj_Rel_Insert_Input = {
  data: ISubscription_Plan_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Plan_On_Conflict>;
};

/** on_conflict condition type for table "subscription_plan" */
export type ISubscription_Plan_On_Conflict = {
  constraint: ISubscription_Plan_Constraint;
  update_columns?: Array<ISubscription_Plan_Update_Column>;
  where?: Maybe<ISubscription_Plan_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan". */
export type ISubscription_Plan_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach?: Maybe<ICoach_Order_By>;
  coach_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  image?: Maybe<IOrder_By>;
  is_verified?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  stripe_product_id?: Maybe<IOrder_By>;
  subscription_plan_prices_aggregate?: Maybe<ISubscription_Plan_Price_Aggregate_Order_By>;
  subscription_plan_translations_aggregate?: Maybe<ISubscription_Plan_Translation_Aggregate_Order_By>;
  subscriptions_aggregate?: Maybe<ISubscription_Aggregate_Order_By>;
  updated_at?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan */
export type ISubscription_Plan_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type ISubscription_Plan_Price_Aggregate_Bool_Exp = {
  count?: Maybe<ISubscription_Plan_Price_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Price_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Plan_Price_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Price_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Plan_Price_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Plan_Price_Max_Order_By>;
  min?: Maybe<ISubscription_Plan_Price_Min_Order_By>;
  stddev?: Maybe<ISubscription_Plan_Price_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Plan_Price_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Plan_Price_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Plan_Price_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Plan_Price_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Plan_Price_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Plan_Price_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_price" */
export type ISubscription_Plan_Price_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Price_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Plan_Price_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_price". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Price_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Plan_Price_Bool_Exp>>;
  _not?: Maybe<ISubscription_Plan_Price_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Plan_Price_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  interval_count?: Maybe<INumeric_Comparison_Exp>;
  stripe_lookup_key?: Maybe<IString_Comparison_Exp>;
  stripe_price_id?: Maybe<IString_Comparison_Exp>;
  subscription_plan?: Maybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: Maybe<IInt_Comparison_Exp>;
  unit_amount?: Maybe<INumeric_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanPricePkey = 'subscription_plan_price_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_price" */
export type ISubscription_Plan_Price_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['numeric']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
  unit_amount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan_price" */
export type ISubscription_Plan_Price_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['numeric']>;
  stripe_lookup_key?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  subscription_plan?: Maybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
  unit_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  stripe_lookup_key?: Maybe<IOrder_By>;
  stripe_price_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  stripe_lookup_key?: Maybe<IOrder_By>;
  stripe_price_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_price" */
export type ISubscription_Plan_Price_On_Conflict = {
  constraint: ISubscription_Plan_Price_Constraint;
  update_columns?: Array<ISubscription_Plan_Price_Update_Column>;
  where?: Maybe<ISubscription_Plan_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_price". */
export type ISubscription_Plan_Price_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  stripe_lookup_key?: Maybe<IOrder_By>;
  stripe_price_id?: Maybe<IOrder_By>;
  subscription_plan?: Maybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_price */
export type ISubscription_Plan_Price_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  StripeLookupKey = 'stripe_lookup_key',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UnitAmount = 'unit_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "subscription_plan_price" */
export type ISubscription_Plan_Price_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['numeric']>;
  stripe_lookup_key?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
  unit_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_price" */
export type ISubscription_Plan_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Price_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['numeric']>;
  stripe_lookup_key?: Maybe<Scalars['String']>;
  stripe_price_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
  unit_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** update columns of table "subscription_plan_price" */
export enum ISubscription_Plan_Price_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  StripeLookupKey = 'stripe_lookup_key',
  /** column name */
  StripePriceId = 'stripe_price_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id',
  /** column name */
  UnitAmount = 'unit_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type ISubscription_Plan_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Plan_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Plan_Price_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Price_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_price" */
export type ISubscription_Plan_Price_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
  unit_amount?: Maybe<IOrder_By>;
};

/** select columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

/** select "subscription_plan_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified'
}

/** select "subscription_plan_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscription_plan" */
export enum ISubscription_Plan_Select_Column_Subscription_Plan_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVerified = 'is_verified'
}

/** input type for updating data in table "subscription_plan" */
export type ISubscription_Plan_Set_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Pop_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan" */
export type ISubscription_Plan_Stddev_Samp_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan" */
export type ISubscription_Plan_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Stream_Cursor_Value_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  coach_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport_id?: Maybe<Scalars['String']>;
  stripe_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "subscription_plan" */
export type ISubscription_Plan_Sum_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

export type ISubscription_Plan_Template_Aggregate_Bool_Exp = {
  count?: Maybe<ISubscription_Plan_Template_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Plan_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Plan_Template_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Plan_Template_Max_Order_By>;
  min?: Maybe<ISubscription_Plan_Template_Min_Order_By>;
  stddev?: Maybe<ISubscription_Plan_Template_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Plan_Template_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Plan_Template_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Plan_Template_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Plan_Template_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Plan_Template_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Plan_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_template" */
export type ISubscription_Plan_Template_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Plan_Template_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Avg_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_template". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Template_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Plan_Template_Bool_Exp>>;
  _not?: Maybe<ISubscription_Plan_Template_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Plan_Template_Bool_Exp>>;
  biannualy_discount?: Maybe<INumeric_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  level?: Maybe<IInt_Comparison_Exp>;
  min_duration?: Maybe<INumeric_Comparison_Exp>;
  quarterly_discount?: Maybe<INumeric_Comparison_Exp>;
  recomended_duration?: Maybe<INumeric_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  weekly_price?: Maybe<INumeric_Comparison_Exp>;
  yearly_discount?: Maybe<INumeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanTemplatePkey = 'subscription_plan_template_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_template" */
export type ISubscription_Plan_Template_Inc_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscription_plan_template" */
export type ISubscription_Plan_Template_Insert_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Max_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Min_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_template" */
export type ISubscription_Plan_Template_On_Conflict = {
  constraint: ISubscription_Plan_Template_Constraint;
  update_columns?: Array<ISubscription_Plan_Template_Update_Column>;
  where?: Maybe<ISubscription_Plan_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_template". */
export type ISubscription_Plan_Template_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_template */
export type ISubscription_Plan_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Select_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

/** input type for updating data in table "subscription_plan_template" */
export type ISubscription_Plan_Template_Set_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport_id?: Maybe<Scalars['String']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by stddev() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Pop_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stddev_Samp_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_template" */
export type ISubscription_Plan_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Template_Stream_Cursor_Value_Input = {
  biannualy_discount?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Int']>;
  min_duration?: Maybe<Scalars['numeric']>;
  quarterly_discount?: Maybe<Scalars['numeric']>;
  recomended_duration?: Maybe<Scalars['numeric']>;
  sport_id?: Maybe<Scalars['String']>;
  weekly_price?: Maybe<Scalars['numeric']>;
  yearly_discount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Sum_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** update columns of table "subscription_plan_template" */
export enum ISubscription_Plan_Template_Update_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

export type ISubscription_Plan_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Plan_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Plan_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Var_Pop_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Var_Samp_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_template" */
export type ISubscription_Plan_Template_Variance_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

export type ISubscription_Plan_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<ISubscription_Plan_Translation_Aggregate_Bool_Exp_Count>;
};

export type ISubscription_Plan_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<ISubscription_Plan_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<ISubscription_Plan_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Aggregate_Order_By = {
  avg?: Maybe<ISubscription_Plan_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<ISubscription_Plan_Translation_Max_Order_By>;
  min?: Maybe<ISubscription_Plan_Translation_Min_Order_By>;
  stddev?: Maybe<ISubscription_Plan_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<ISubscription_Plan_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<ISubscription_Plan_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<ISubscription_Plan_Translation_Sum_Order_By>;
  var_pop?: Maybe<ISubscription_Plan_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<ISubscription_Plan_Translation_Var_Samp_Order_By>;
  variance?: Maybe<ISubscription_Plan_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Arr_Rel_Insert_Input = {
  data: Array<ISubscription_Plan_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<ISubscription_Plan_Translation_On_Conflict>;
};

/** order by avg() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "subscription_plan_translation". All fields are combined with a logical 'AND'. */
export type ISubscription_Plan_Translation_Bool_Exp = {
  _and?: Maybe<Array<ISubscription_Plan_Translation_Bool_Exp>>;
  _not?: Maybe<ISubscription_Plan_Translation_Bool_Exp>;
  _or?: Maybe<Array<ISubscription_Plan_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  subscription_plan?: Maybe<ISubscription_Plan_Bool_Exp>;
  subscription_plan_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionPlanTranslationPkey = 'subscription_plan_translation_pkey'
}

/** input type for incrementing numeric columns in table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  subscription_plan?: Maybe<ISubscription_Plan_Obj_Rel_Insert_Input>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_On_Conflict = {
  constraint: ISubscription_Plan_Translation_Constraint;
  update_columns?: Array<ISubscription_Plan_Translation_Update_Column>;
  where?: Maybe<ISubscription_Plan_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "subscription_plan_translation". */
export type ISubscription_Plan_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan?: Maybe<ISubscription_Plan_Order_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: subscription_plan_translation */
export type ISubscription_Plan_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

/** input type for updating data in table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Plan_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Plan_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** update columns of table "subscription_plan_translation" */
export enum ISubscription_Plan_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

export type ISubscription_Plan_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Plan_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Plan_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan_translation" */
export type ISubscription_Plan_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** update columns of table "subscription_plan" */
export enum ISubscription_Plan_Update_Column {
  /** column name */
  BiannualyDiscount = 'biannualy_discount',
  /** column name */
  CoachId = 'coach_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Image = 'image',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Level = 'level',
  /** column name */
  MinDuration = 'min_duration',
  /** column name */
  QuarterlyDiscount = 'quarterly_discount',
  /** column name */
  RecomendedDuration = 'recomended_duration',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  StripeProductId = 'stripe_product_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyPrice = 'weekly_price',
  /** column name */
  YearlyDiscount = 'yearly_discount'
}

export type ISubscription_Plan_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Plan_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Plan_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Plan_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription_plan" */
export type ISubscription_Plan_Var_Pop_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription_plan" */
export type ISubscription_Plan_Var_Samp_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription_plan" */
export type ISubscription_Plan_Variance_Order_By = {
  biannualy_discount?: Maybe<IOrder_By>;
  coach_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  level?: Maybe<IOrder_By>;
  min_duration?: Maybe<IOrder_By>;
  quarterly_discount?: Maybe<IOrder_By>;
  recomended_duration?: Maybe<IOrder_By>;
  weekly_price?: Maybe<IOrder_By>;
  yearly_discount?: Maybe<IOrder_By>;
};

/** select columns of table "subscription" */
export enum ISubscription_Select_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

/** input type for updating data in table "subscription" */
export type ISubscription_Set_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_end?: Maybe<Scalars['date']>;
  date_start?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "subscription" */
export type ISubscription_Stddev_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "subscription" */
export type ISubscription_Stddev_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "subscription" */
export type ISubscription_Stddev_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "subscription" */
export type ISubscription_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ISubscription_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ISubscription_Stream_Cursor_Value_Input = {
  athlete_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  date_end?: Maybe<Scalars['date']>;
  date_start?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['Int']>;
  interval_count?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripe_subscription_id?: Maybe<Scalars['String']>;
  subscription_plan_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subscription" */
export type ISubscription_Sum_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** update columns of table "subscription" */
export enum ISubscription_Update_Column {
  /** column name */
  AthleteId = 'athlete_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateEnd = 'date_end',
  /** column name */
  DateStart = 'date_start',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Price = 'price',
  /** column name */
  Status = 'status',
  /** column name */
  StripeSubscriptionId = 'stripe_subscription_id',
  /** column name */
  SubscriptionPlanId = 'subscription_plan_id'
}

export type ISubscription_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<ISubscription_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<ISubscription_Set_Input>;
  /** filter the rows which have to be updated */
  where: ISubscription_Bool_Exp;
};

/** order by var_pop() on columns of table "subscription" */
export type ISubscription_Var_Pop_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "subscription" */
export type ISubscription_Var_Samp_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "subscription" */
export type ISubscription_Variance_Order_By = {
  athlete_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  interval_count?: Maybe<IOrder_By>;
  price?: Maybe<IOrder_By>;
  subscription_plan_id?: Maybe<IOrder_By>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type ITimestamptz_Comparison_Exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type IUser_Bool_Exp = {
  _and?: Maybe<Array<IUser_Bool_Exp>>;
  _not?: Maybe<IUser_Bool_Exp>;
  _or?: Maybe<Array<IUser_Bool_Exp>>;
  athlete?: Maybe<IAthlete_Bool_Exp>;
  coach?: Maybe<ICoach_Bool_Exp>;
  coaches?: Maybe<ICoach_Bool_Exp>;
  coaches_aggregate?: Maybe<ICoach_Aggregate_Bool_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  email?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  keycloak_id?: Maybe<IUuid_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  recovery_token?: Maybe<IString_Comparison_Exp>;
  strava_access_token?: Maybe<IString_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "user" */
export enum IUser_Constraint {
  /** unique or primary key constraint on columns "type", "email" */
  UserEmailTypeKey = 'user_email_type_key',
  /** unique or primary key constraint on columns "keycloak_id" */
  UserKeycloakIdKey = 'user_keycloak_id_key',
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** input type for incrementing numeric columns in table "user" */
export type IUser_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "user" */
export type IUser_Insert_Input = {
  athlete?: Maybe<IAthlete_Obj_Rel_Insert_Input>;
  coach?: Maybe<ICoach_Obj_Rel_Insert_Input>;
  coaches?: Maybe<ICoach_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keycloak_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  recovery_token?: Maybe<Scalars['String']>;
  strava_access_token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** input type for inserting object relation for remote table "user" */
export type IUser_Obj_Rel_Insert_Input = {
  data: IUser_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IUser_On_Conflict>;
};

/** on_conflict condition type for table "user" */
export type IUser_On_Conflict = {
  constraint: IUser_Constraint;
  update_columns?: Array<IUser_Update_Column>;
  where?: Maybe<IUser_Bool_Exp>;
};

/** Ordering options when selecting data from "user". */
export type IUser_Order_By = {
  athlete?: Maybe<IAthlete_Order_By>;
  coach?: Maybe<ICoach_Order_By>;
  coaches_aggregate?: Maybe<ICoach_Aggregate_Order_By>;
  created_at?: Maybe<IOrder_By>;
  email?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  keycloak_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  recovery_token?: Maybe<IOrder_By>;
  strava_access_token?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** primary key columns input for table: user */
export type IUser_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "user" */
export enum IUser_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  KeycloakId = 'keycloak_id',
  /** column name */
  Name = 'name',
  /** column name */
  RecoveryToken = 'recovery_token',
  /** column name */
  StravaAccessToken = 'strava_access_token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "user" */
export type IUser_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keycloak_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  recovery_token?: Maybe<Scalars['String']>;
  strava_access_token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "user" */
export type IUser_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IUser_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IUser_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  keycloak_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  recovery_token?: Maybe<Scalars['String']>;
  strava_access_token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "user" */
export enum IUser_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  KeycloakId = 'keycloak_id',
  /** column name */
  Name = 'name',
  /** column name */
  RecoveryToken = 'recovery_token',
  /** column name */
  StravaAccessToken = 'strava_access_token',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IUser_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IUser_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IUser_Set_Input>;
  /** filter the rows which have to be updated */
  where: IUser_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type IUuid_Comparison_Exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

export type IWeek_Template_Aggregate_Bool_Exp = {
  count?: Maybe<IWeek_Template_Aggregate_Bool_Exp_Count>;
};

export type IWeek_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWeek_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWeek_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "week_template" */
export type IWeek_Template_Aggregate_Order_By = {
  avg?: Maybe<IWeek_Template_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWeek_Template_Max_Order_By>;
  min?: Maybe<IWeek_Template_Min_Order_By>;
  stddev?: Maybe<IWeek_Template_Stddev_Order_By>;
  stddev_pop?: Maybe<IWeek_Template_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWeek_Template_Stddev_Samp_Order_By>;
  sum?: Maybe<IWeek_Template_Sum_Order_By>;
  var_pop?: Maybe<IWeek_Template_Var_Pop_Order_By>;
  var_samp?: Maybe<IWeek_Template_Var_Samp_Order_By>;
  variance?: Maybe<IWeek_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "week_template" */
export type IWeek_Template_Arr_Rel_Insert_Input = {
  data: Array<IWeek_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWeek_Template_On_Conflict>;
};

/** order by avg() on columns of table "week_template" */
export type IWeek_Template_Avg_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "week_template". All fields are combined with a logical 'AND'. */
export type IWeek_Template_Bool_Exp = {
  _and?: Maybe<Array<IWeek_Template_Bool_Exp>>;
  _not?: Maybe<IWeek_Template_Bool_Exp>;
  _or?: Maybe<Array<IWeek_Template_Bool_Exp>>;
  block_template?: Maybe<IBlock_Template_Bool_Exp>;
  block_template_id?: Maybe<IInt_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  sport?: Maybe<ISport_Bool_Exp>;
  sport_id?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "week_template" */
export enum IWeek_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  WeekTemplatePkey = 'week_template_pkey'
}

/** input type for incrementing numeric columns in table "week_template" */
export type IWeek_Template_Inc_Input = {
  block_template_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "week_template" */
export type IWeek_Template_Insert_Input = {
  block_template?: Maybe<IBlock_Template_Obj_Rel_Insert_Input>;
  block_template_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport?: Maybe<ISport_Obj_Rel_Insert_Input>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "week_template" */
export type IWeek_Template_Max_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "week_template" */
export type IWeek_Template_Min_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "week_template" */
export type IWeek_Template_Obj_Rel_Insert_Input = {
  data: IWeek_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWeek_Template_On_Conflict>;
};

/** on_conflict condition type for table "week_template" */
export type IWeek_Template_On_Conflict = {
  constraint: IWeek_Template_Constraint;
  update_columns?: Array<IWeek_Template_Update_Column>;
  where?: Maybe<IWeek_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "week_template". */
export type IWeek_Template_Order_By = {
  block_template?: Maybe<IBlock_Template_Order_By>;
  block_template_id?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  sport?: Maybe<ISport_Order_By>;
  sport_id?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: week_template */
export type IWeek_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "week_template" */
export enum IWeek_Template_Select_Column {
  /** column name */
  BlockTemplateId = 'block_template_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "week_template" */
export type IWeek_Template_Set_Input = {
  block_template_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by stddev() on columns of table "week_template" */
export type IWeek_Template_Stddev_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "week_template" */
export type IWeek_Template_Stddev_Pop_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "week_template" */
export type IWeek_Template_Stddev_Samp_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "week_template" */
export type IWeek_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWeek_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWeek_Template_Stream_Cursor_Value_Input = {
  block_template_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sport_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by sum() on columns of table "week_template" */
export type IWeek_Template_Sum_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** update columns of table "week_template" */
export enum IWeek_Template_Update_Column {
  /** column name */
  BlockTemplateId = 'block_template_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SportId = 'sport_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type IWeek_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWeek_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWeek_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWeek_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "week_template" */
export type IWeek_Template_Var_Pop_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "week_template" */
export type IWeek_Template_Var_Samp_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "week_template" */
export type IWeek_Template_Variance_Order_By = {
  block_template_id?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Altimetry_Bool_Exp>>;
  _not?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Altimetry_Bool_Exp>>;
  athlete_profile_altimetry_adjustments?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Bool_Exp>;
  athlete_profile_altimetry_adjustments_aggregate?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Bool_Exp>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  coefficient?: Maybe<INumeric_Comparison_Exp>;
  icon?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  workout_altimetry_translations?: Maybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  workout_altimetry_translations_aggregate?: Maybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp>;
  workout_altimetry_workout_types?: Maybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  workout_altimetry_workout_types_aggregate?: Maybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry" */
export enum IWorkout_Altimetry_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryPkey = 'workout_altimetry_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry" */
export type IWorkout_Altimetry_Inc_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry" */
export type IWorkout_Altimetry_Insert_Input = {
  athlete_profile_altimetry_adjustments?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Arr_Rel_Insert_Input>;
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_altimetry_translations?: Maybe<IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input>;
  workout_altimetry_workout_types?: Maybe<IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_altimetry" */
export type IWorkout_Altimetry_Obj_Rel_Insert_Input = {
  data: IWorkout_Altimetry_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Altimetry_On_Conflict>;
};

/** on_conflict condition type for table "workout_altimetry" */
export type IWorkout_Altimetry_On_Conflict = {
  constraint: IWorkout_Altimetry_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Update_Column>;
  where?: Maybe<IWorkout_Altimetry_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry". */
export type IWorkout_Altimetry_Order_By = {
  athlete_profile_altimetry_adjustments_aggregate?: Maybe<IAthlete_Profile_Altimetry_Adjustment_Aggregate_Order_By>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  coefficient?: Maybe<IOrder_By>;
  icon?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_altimetry_translations_aggregate?: Maybe<IWorkout_Altimetry_Translation_Aggregate_Order_By>;
  workout_altimetry_workout_types_aggregate?: Maybe<IWorkout_Altimetry_Workout_Type_Aggregate_Order_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_altimetry */
export type IWorkout_Altimetry_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry" */
export enum IWorkout_Altimetry_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workout_altimetry" */
export type IWorkout_Altimetry_Set_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "workout_altimetry" */
export type IWorkout_Altimetry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Stream_Cursor_Value_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type IWorkout_Altimetry_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<IWorkout_Altimetry_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Altimetry_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Altimetry_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Altimetry_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Altimetry_Translation_Max_Order_By>;
  min?: Maybe<IWorkout_Altimetry_Translation_Min_Order_By>;
  stddev?: Maybe<IWorkout_Altimetry_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Altimetry_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Altimetry_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Altimetry_Translation_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Altimetry_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Altimetry_Translation_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Altimetry_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Altimetry_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Altimetry_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Translation_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Altimetry_Translation_Bool_Exp>>;
  _not?: Maybe<IWorkout_Altimetry_Translation_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Altimetry_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryTranslationPkey = 'workout_altimetry_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_On_Conflict = {
  constraint: IWorkout_Altimetry_Translation_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Translation_Update_Column>;
  where?: Maybe<IWorkout_Altimetry_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry_translation". */
export type IWorkout_Altimetry_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_altimetry_translation */
export type IWorkout_Altimetry_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

/** input type for updating data in table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_altimetry_translation" */
export enum IWorkout_Altimetry_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id'
}

export type IWorkout_Altimetry_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Altimetry_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Altimetry_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_altimetry_translation" */
export type IWorkout_Altimetry_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_altimetry" */
export enum IWorkout_Altimetry_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type IWorkout_Altimetry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Altimetry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Altimetry_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Bool_Exp;
};

export type IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp = {
  count?: Maybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Altimetry_Workout_Type_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Altimetry_Workout_Type_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Altimetry_Workout_Type_Max_Order_By>;
  min?: Maybe<IWorkout_Altimetry_Workout_Type_Min_Order_By>;
  stddev?: Maybe<IWorkout_Altimetry_Workout_Type_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Altimetry_Workout_Type_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Altimetry_Workout_Type_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Altimetry_Workout_Type_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Altimetry_Workout_Type_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Altimetry_Workout_Type_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Altimetry_Workout_Type_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Altimetry_Workout_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Altimetry_Workout_Type_On_Conflict>;
};

/** order by avg() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_altimetry_workout_type". All fields are combined with a logical 'AND'. */
export type IWorkout_Altimetry_Workout_Type_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Altimetry_Workout_Type_Bool_Exp>>;
  _not?: Maybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Altimetry_Workout_Type_Bool_Exp>>;
  id?: Maybe<IInt_Comparison_Exp>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: Maybe<IInt_Comparison_Exp>;
  workout_type?: Maybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Constraint {
  /** unique or primary key constraint on columns "workout_type_id", "workout_altimetry_id" */
  WorkoutAltimetryWorkoutTypeAltimetryIdTypeIdKey = 'workout_altimetry_workout_type_altimetry_id_type_id_key',
  /** unique or primary key constraint on columns "id" */
  WorkoutAltimetryWorkoutTypePkey = 'workout_altimetry_workout_type_pkey'
}

/** input type for incrementing numeric columns in table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Insert_Input = {
  id?: Maybe<Scalars['Int']>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_type?: Maybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Max_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Min_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_On_Conflict = {
  constraint: IWorkout_Altimetry_Workout_Type_Constraint;
  update_columns?: Array<IWorkout_Altimetry_Workout_Type_Update_Column>;
  where?: Maybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_altimetry_workout_type". */
export type IWorkout_Altimetry_Workout_Type_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type?: Maybe<IWorkout_Type_Order_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_altimetry_workout_type */
export type IWorkout_Altimetry_Workout_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Altimetry_Workout_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Altimetry_Workout_Type_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_altimetry_workout_type" */
export enum IWorkout_Altimetry_Workout_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IWorkout_Altimetry_Workout_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Altimetry_Workout_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Altimetry_Workout_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Altimetry_Workout_Type_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_altimetry_workout_type" */
export type IWorkout_Altimetry_Workout_Type_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_duration". All fields are combined with a logical 'AND'. */
export type IWorkout_Duration_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Duration_Bool_Exp>>;
  _not?: Maybe<IWorkout_Duration_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Duration_Bool_Exp>>;
  coefficient?: Maybe<INumeric_Comparison_Exp>;
  duration?: Maybe<INumeric_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_duration" */
export enum IWorkout_Duration_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutDurationPkey = 'workout_duration_pkey'
}

/** input type for incrementing numeric columns in table "workout_duration" */
export type IWorkout_Duration_Inc_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_duration" */
export type IWorkout_Duration_Insert_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** on_conflict condition type for table "workout_duration" */
export type IWorkout_Duration_On_Conflict = {
  constraint: IWorkout_Duration_Constraint;
  update_columns?: Array<IWorkout_Duration_Update_Column>;
  where?: Maybe<IWorkout_Duration_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_duration". */
export type IWorkout_Duration_Order_By = {
  coefficient?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_duration */
export type IWorkout_Duration_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_duration" */
export enum IWorkout_Duration_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_duration" */
export type IWorkout_Duration_Set_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_duration" */
export type IWorkout_Duration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Duration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Duration_Stream_Cursor_Value_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "workout_duration" */
export enum IWorkout_Duration_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id'
}

export type IWorkout_Duration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Duration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Duration_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Duration_Bool_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp = {
  bool_and?: Maybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<IWorkout_Section_Template_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Section_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Section_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_section_template" */
export type IWorkout_Section_Template_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Section_Template_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Section_Template_Max_Order_By>;
  min?: Maybe<IWorkout_Section_Template_Min_Order_By>;
  stddev?: Maybe<IWorkout_Section_Template_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Section_Template_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Section_Template_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Section_Template_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Section_Template_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Section_Template_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Section_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_section_template" */
export type IWorkout_Section_Template_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Section_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Section_Template_On_Conflict>;
};

/** order by avg() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Avg_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_section_template". All fields are combined with a logical 'AND'. */
export type IWorkout_Section_Template_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Section_Template_Bool_Exp>>;
  _not?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Section_Template_Bool_Exp>>;
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  average_heart_rate?: Maybe<INumeric_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  duration?: Maybe<INumeric_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_main?: Maybe<IBoolean_Comparison_Exp>;
  max_heart_rate?: Maybe<IInt_Comparison_Exp>;
  order?: Maybe<IInt_Comparison_Exp>;
  series_id?: Maybe<IInt_Comparison_Exp>;
  speed?: Maybe<INumeric_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  workout_template?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_template_id?: Maybe<IInt_Comparison_Exp>;
  workout_zone?: Maybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_section_template" */
export enum IWorkout_Section_Template_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutSectionTemplatePkey = 'workout_section_template_pkey'
}

/** input type for incrementing numeric columns in table "workout_section_template" */
export type IWorkout_Section_Template_Inc_Input = {
  average_heart_rate?: Maybe<Scalars['numeric']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  max_heart_rate?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_section_template" */
export type IWorkout_Section_Template_Insert_Input = {
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  average_heart_rate?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_template?: Maybe<IWorkout_Template_Obj_Rel_Insert_Input>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_zone?: Maybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Max_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Min_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "workout_section_template" */
export type IWorkout_Section_Template_Obj_Rel_Insert_Input = {
  data: IWorkout_Section_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Section_Template_On_Conflict>;
};

/** on_conflict condition type for table "workout_section_template" */
export type IWorkout_Section_Template_On_Conflict = {
  constraint: IWorkout_Section_Template_Constraint;
  update_columns?: Array<IWorkout_Section_Template_Update_Column>;
  where?: Maybe<IWorkout_Section_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_section_template". */
export type IWorkout_Section_Template_Order_By = {
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  average_heart_rate?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_main?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  workout_template?: Maybe<IWorkout_Template_Order_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone?: Maybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_section_template */
export type IWorkout_Section_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column {
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  Order = 'order',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "workout_section_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** select "workout_section_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Select_Column_Workout_Section_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsMain = 'is_main'
}

/** input type for updating data in table "workout_section_template" */
export type IWorkout_Section_Template_Set_Input = {
  average_heart_rate?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Pop_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Stddev_Samp_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_section_template" */
export type IWorkout_Section_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Section_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Section_Template_Stream_Cursor_Value_Input = {
  average_heart_rate?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
  is_main?: Maybe<Scalars['Boolean']>;
  max_heart_rate?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  series_id?: Maybe<Scalars['Int']>;
  speed?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  workout_template_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Sum_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_section_template" */
export enum IWorkout_Section_Template_Update_Column {
  /** column name */
  AverageHeartRate = 'average_heart_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  IsMain = 'is_main',
  /** column name */
  MaxHeartRate = 'max_heart_rate',
  /** column name */
  Order = 'order',
  /** column name */
  SeriesId = 'series_id',
  /** column name */
  Speed = 'speed',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkoutTemplateId = 'workout_template_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IWorkout_Section_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Section_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Section_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Section_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Var_Pop_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Var_Samp_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_section_template" */
export type IWorkout_Section_Template_Variance_Order_By = {
  average_heart_rate?: Maybe<IOrder_By>;
  duration?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  max_heart_rate?: Maybe<IOrder_By>;
  order?: Maybe<IOrder_By>;
  series_id?: Maybe<IOrder_By>;
  speed?: Maybe<IOrder_By>;
  workout_template_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

export type IWorkout_Template_Aggregate_Bool_Exp = {
  bool_and?: Maybe<IWorkout_Template_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: Maybe<IWorkout_Template_Aggregate_Bool_Exp_Bool_Or>;
  count?: Maybe<IWorkout_Template_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Bool_And = {
  arguments: IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Bool_Or = {
  arguments: IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Template_Bool_Exp>;
  predicate: IBoolean_Comparison_Exp;
};

export type IWorkout_Template_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Template_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Template_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_template" */
export type IWorkout_Template_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Template_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Template_Max_Order_By>;
  min?: Maybe<IWorkout_Template_Min_Order_By>;
  stddev?: Maybe<IWorkout_Template_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Template_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Template_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Template_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Template_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Template_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Template_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_template" */
export type IWorkout_Template_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Template_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Template_On_Conflict>;
};

/** order by avg() on columns of table "workout_template" */
export type IWorkout_Template_Avg_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_template". All fields are combined with a logical 'AND'. */
export type IWorkout_Template_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Template_Bool_Exp>>;
  _not?: Maybe<IWorkout_Template_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Template_Bool_Exp>>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  cumulative_elevation?: Maybe<INumeric_Comparison_Exp>;
  day?: Maybe<IInt_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  is_primary?: Maybe<IBoolean_Comparison_Exp>;
  negative_elevation?: Maybe<INumeric_Comparison_Exp>;
  positive_elevation?: Maybe<INumeric_Comparison_Exp>;
  series?: Maybe<IString_Comparison_Exp>;
  series_repetitions?: Maybe<IInt_Comparison_Exp>;
  stretching_circuit?: Maybe<ICircuit_Bool_Exp>;
  stretching_circuit_id?: Maybe<IInt_Comparison_Exp>;
  stretching_circuit_repetitions?: Maybe<IInt_Comparison_Exp>;
  type?: Maybe<IString_Comparison_Exp>;
  updated_at?: Maybe<ITimestamptz_Comparison_Exp>;
  week_template?: Maybe<IWeek_Template_Bool_Exp>;
  week_template_id?: Maybe<IInt_Comparison_Exp>;
  weight_circuit?: Maybe<ICircuit_Bool_Exp>;
  weight_circuit_id?: Maybe<IInt_Comparison_Exp>;
  weight_circuit_repetitions?: Maybe<IInt_Comparison_Exp>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Bool_Exp>;
  workout_altimetry_id?: Maybe<IInt_Comparison_Exp>;
  workout_section_templates?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_templates_aggregate?: Maybe<IWorkout_Section_Template_Aggregate_Bool_Exp>;
  workout_terrain?: Maybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: Maybe<IInt_Comparison_Exp>;
  workout_type?: Maybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: Maybe<IInt_Comparison_Exp>;
  workout_zone?: Maybe<IWorkout_Zone_Bool_Exp>;
  workout_zone_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_template" */
export enum IWorkout_Template_Constraint {
  /** unique or primary key constraint on columns "day", "week_template_id", "is_primary" */
  UniqueWorkoutTemplatePerWeekKey = 'unique_workout_template_per_week_key',
  /** unique or primary key constraint on columns "id" */
  WorkoutTemplatePkey = 'workout_template_pkey'
}

/** input type for incrementing numeric columns in table "workout_template" */
export type IWorkout_Template_Inc_Input = {
  cumulative_elevation?: Maybe<Scalars['numeric']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  negative_elevation?: Maybe<Scalars['numeric']>;
  positive_elevation?: Maybe<Scalars['numeric']>;
  series_repetitions?: Maybe<Scalars['Int']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  week_template_id?: Maybe<Scalars['Int']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_template" */
export type IWorkout_Template_Insert_Input = {
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['numeric']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  negative_elevation?: Maybe<Scalars['numeric']>;
  positive_elevation?: Maybe<Scalars['numeric']>;
  series?: Maybe<Scalars['String']>;
  series_repetitions?: Maybe<Scalars['Int']>;
  stretching_circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  week_template?: Maybe<IWeek_Template_Obj_Rel_Insert_Input>;
  week_template_id?: Maybe<Scalars['Int']>;
  weight_circuit?: Maybe<ICircuit_Obj_Rel_Insert_Input>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Obj_Rel_Insert_Input>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_section_templates?: Maybe<IWorkout_Section_Template_Arr_Rel_Insert_Input>;
  workout_terrain?: Maybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type?: Maybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone?: Maybe<IWorkout_Zone_Obj_Rel_Insert_Input>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_template" */
export type IWorkout_Template_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_template" */
export type IWorkout_Template_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** input type for inserting object relation for remote table "workout_template" */
export type IWorkout_Template_Obj_Rel_Insert_Input = {
  data: IWorkout_Template_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Template_On_Conflict>;
};

/** on_conflict condition type for table "workout_template" */
export type IWorkout_Template_On_Conflict = {
  constraint: IWorkout_Template_Constraint;
  update_columns?: Array<IWorkout_Template_Update_Column>;
  where?: Maybe<IWorkout_Template_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_template". */
export type IWorkout_Template_Order_By = {
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  created_at?: Maybe<IOrder_By>;
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  is_primary?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit?: Maybe<ICircuit_Order_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  type?: Maybe<IOrder_By>;
  updated_at?: Maybe<IOrder_By>;
  week_template?: Maybe<IWeek_Template_Order_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit?: Maybe<ICircuit_Order_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry?: Maybe<IWorkout_Altimetry_Order_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_section_templates_aggregate?: Maybe<IWorkout_Section_Template_Aggregate_Order_By>;
  workout_terrain?: Maybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type?: Maybe<IWorkout_Type_Order_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone?: Maybe<IWorkout_Zone_Order_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_template */
export type IWorkout_Template_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_template" */
export enum IWorkout_Template_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  SeriesRepetitions = 'series_repetitions',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeekTemplateId = 'week_template_id',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

/** select "workout_template_aggregate_bool_exp_bool_and_arguments_columns" columns of table "workout_template" */
export enum IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** select "workout_template_aggregate_bool_exp_bool_or_arguments_columns" columns of table "workout_template" */
export enum IWorkout_Template_Select_Column_Workout_Template_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPrimary = 'is_primary'
}

/** input type for updating data in table "workout_template" */
export type IWorkout_Template_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['numeric']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  negative_elevation?: Maybe<Scalars['numeric']>;
  positive_elevation?: Maybe<Scalars['numeric']>;
  series?: Maybe<Scalars['String']>;
  series_repetitions?: Maybe<Scalars['Int']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  week_template_id?: Maybe<Scalars['Int']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Pop_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_template" */
export type IWorkout_Template_Stddev_Samp_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_template" */
export type IWorkout_Template_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Template_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Template_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  cumulative_elevation?: Maybe<Scalars['numeric']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_primary?: Maybe<Scalars['Boolean']>;
  negative_elevation?: Maybe<Scalars['numeric']>;
  positive_elevation?: Maybe<Scalars['numeric']>;
  series?: Maybe<Scalars['String']>;
  series_repetitions?: Maybe<Scalars['Int']>;
  stretching_circuit_id?: Maybe<Scalars['Int']>;
  stretching_circuit_repetitions?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  week_template_id?: Maybe<Scalars['Int']>;
  weight_circuit_id?: Maybe<Scalars['Int']>;
  weight_circuit_repetitions?: Maybe<Scalars['Int']>;
  workout_altimetry_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
  workout_zone_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_template" */
export type IWorkout_Template_Sum_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_template" */
export enum IWorkout_Template_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CumulativeElevation = 'cumulative_elevation',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  NegativeElevation = 'negative_elevation',
  /** column name */
  PositiveElevation = 'positive_elevation',
  /** column name */
  Series = 'series',
  /** column name */
  SeriesRepetitions = 'series_repetitions',
  /** column name */
  StretchingCircuitId = 'stretching_circuit_id',
  /** column name */
  StretchingCircuitRepetitions = 'stretching_circuit_repetitions',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeekTemplateId = 'week_template_id',
  /** column name */
  WeightCircuitId = 'weight_circuit_id',
  /** column name */
  WeightCircuitRepetitions = 'weight_circuit_repetitions',
  /** column name */
  WorkoutAltimetryId = 'workout_altimetry_id',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id',
  /** column name */
  WorkoutTypeId = 'workout_type_id',
  /** column name */
  WorkoutZoneId = 'workout_zone_id'
}

export type IWorkout_Template_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Template_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Template_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Template_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_template" */
export type IWorkout_Template_Var_Pop_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_template" */
export type IWorkout_Template_Var_Samp_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_template" */
export type IWorkout_Template_Variance_Order_By = {
  cumulative_elevation?: Maybe<IOrder_By>;
  day?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  negative_elevation?: Maybe<IOrder_By>;
  positive_elevation?: Maybe<IOrder_By>;
  series_repetitions?: Maybe<IOrder_By>;
  stretching_circuit_id?: Maybe<IOrder_By>;
  stretching_circuit_repetitions?: Maybe<IOrder_By>;
  week_template_id?: Maybe<IOrder_By>;
  weight_circuit_id?: Maybe<IOrder_By>;
  weight_circuit_repetitions?: Maybe<IOrder_By>;
  workout_altimetry_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
  workout_zone_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_terrain". All fields are combined with a logical 'AND'. */
export type IWorkout_Terrain_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Terrain_Bool_Exp>>;
  _not?: Maybe<IWorkout_Terrain_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Terrain_Bool_Exp>>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  coefficient?: Maybe<INumeric_Comparison_Exp>;
  icon?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_terrain_translations?: Maybe<IWorkout_Terrain_Translation_Bool_Exp>;
  workout_terrain_translations_aggregate?: Maybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_terrain" */
export enum IWorkout_Terrain_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTerrainsPkey = 'workout_terrains_pkey'
}

/** input type for incrementing numeric columns in table "workout_terrain" */
export type IWorkout_Terrain_Inc_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_terrain" */
export type IWorkout_Terrain_Insert_Input = {
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_terrain_translations?: Maybe<IWorkout_Terrain_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_terrain" */
export type IWorkout_Terrain_Obj_Rel_Insert_Input = {
  data: IWorkout_Terrain_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Terrain_On_Conflict>;
};

/** on_conflict condition type for table "workout_terrain" */
export type IWorkout_Terrain_On_Conflict = {
  constraint: IWorkout_Terrain_Constraint;
  update_columns?: Array<IWorkout_Terrain_Update_Column>;
  where?: Maybe<IWorkout_Terrain_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_terrain". */
export type IWorkout_Terrain_Order_By = {
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  coefficient?: Maybe<IOrder_By>;
  icon?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
  workout_terrain_translations_aggregate?: Maybe<IWorkout_Terrain_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_terrain */
export type IWorkout_Terrain_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_terrain" */
export enum IWorkout_Terrain_Select_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_terrain" */
export type IWorkout_Terrain_Set_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_terrain" */
export type IWorkout_Terrain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Terrain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Terrain_Stream_Cursor_Value_Input = {
  coefficient?: Maybe<Scalars['numeric']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type IWorkout_Terrain_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<IWorkout_Terrain_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Terrain_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Terrain_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Terrain_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Terrain_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Terrain_Translation_Max_Order_By>;
  min?: Maybe<IWorkout_Terrain_Translation_Min_Order_By>;
  stddev?: Maybe<IWorkout_Terrain_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Terrain_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Terrain_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Terrain_Translation_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Terrain_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Terrain_Translation_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Terrain_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Terrain_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Terrain_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_terrain_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Terrain_Translation_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Terrain_Translation_Bool_Exp>>;
  _not?: Maybe<IWorkout_Terrain_Translation_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Terrain_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  description?: Maybe<IString_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  workout_terrain?: Maybe<IWorkout_Terrain_Bool_Exp>;
  workout_terrain_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTerrainTranslationPkey = 'workout_terrain_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_terrain?: Maybe<IWorkout_Terrain_Obj_Rel_Insert_Input>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_On_Conflict = {
  constraint: IWorkout_Terrain_Translation_Constraint;
  update_columns?: Array<IWorkout_Terrain_Translation_Update_Column>;
  where?: Maybe<IWorkout_Terrain_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_terrain_translation". */
export type IWorkout_Terrain_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  description?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_terrain?: Maybe<IWorkout_Terrain_Order_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_terrain_translation */
export type IWorkout_Terrain_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id'
}

/** input type for updating data in table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Terrain_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Terrain_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_terrain_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_terrain_translation" */
export enum IWorkout_Terrain_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTerrainId = 'workout_terrain_id'
}

export type IWorkout_Terrain_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Terrain_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Terrain_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Terrain_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_terrain_translation" */
export type IWorkout_Terrain_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_terrain_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_terrain" */
export enum IWorkout_Terrain_Update_Column {
  /** column name */
  Coefficient = 'coefficient',
  /** column name */
  Icon = 'icon',
  /** column name */
  Id = 'id'
}

export type IWorkout_Terrain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Terrain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Terrain_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Terrain_Bool_Exp;
};

/** Boolean expression to filter rows from the table "workout_type". All fields are combined with a logical 'AND'. */
export type IWorkout_Type_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Type_Bool_Exp>>;
  _not?: Maybe<IWorkout_Type_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Type_Bool_Exp>>;
  athlete_speeds?: Maybe<IAthlete_Speed_Bool_Exp>;
  athlete_speeds_aggregate?: Maybe<IAthlete_Speed_Aggregate_Bool_Exp>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  avatar?: Maybe<IString_Comparison_Exp>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  workout_altimetry_workout_types?: Maybe<IWorkout_Altimetry_Workout_Type_Bool_Exp>;
  workout_altimetry_workout_types_aggregate?: Maybe<IWorkout_Altimetry_Workout_Type_Aggregate_Bool_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
  workout_type_translations?: Maybe<IWorkout_Type_Translation_Bool_Exp>;
  workout_type_translations_aggregate?: Maybe<IWorkout_Type_Translation_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_type" */
export enum IWorkout_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTypePkey = 'workout_type_pkey'
}

/** input type for incrementing numeric columns in table "workout_type" */
export type IWorkout_Type_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_type" */
export type IWorkout_Type_Insert_Input = {
  athlete_speeds?: Maybe<IAthlete_Speed_Arr_Rel_Insert_Input>;
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  workout_altimetry_workout_types?: Maybe<IWorkout_Altimetry_Workout_Type_Arr_Rel_Insert_Input>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
  workout_type_translations?: Maybe<IWorkout_Type_Translation_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_type" */
export type IWorkout_Type_Obj_Rel_Insert_Input = {
  data: IWorkout_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Type_On_Conflict>;
};

/** on_conflict condition type for table "workout_type" */
export type IWorkout_Type_On_Conflict = {
  constraint: IWorkout_Type_Constraint;
  update_columns?: Array<IWorkout_Type_Update_Column>;
  where?: Maybe<IWorkout_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_type". */
export type IWorkout_Type_Order_By = {
  athlete_speeds_aggregate?: Maybe<IAthlete_Speed_Aggregate_Order_By>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  avatar?: Maybe<IOrder_By>;
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  workout_altimetry_workout_types_aggregate?: Maybe<IWorkout_Altimetry_Workout_Type_Aggregate_Order_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
  workout_type_translations_aggregate?: Maybe<IWorkout_Type_Translation_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_type */
export type IWorkout_Type_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_type" */
export enum IWorkout_Type_Select_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "workout_type" */
export type IWorkout_Type_Set_Input = {
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

/** Streaming cursor of the table "workout_type" */
export type IWorkout_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Type_Stream_Cursor_Value_Input = {
  avatar?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
};

export type IWorkout_Type_Translation_Aggregate_Bool_Exp = {
  count?: Maybe<IWorkout_Type_Translation_Aggregate_Bool_Exp_Count>;
};

export type IWorkout_Type_Translation_Aggregate_Bool_Exp_Count = {
  arguments?: Maybe<Array<IWorkout_Type_Translation_Select_Column>>;
  distinct?: Maybe<Scalars['Boolean']>;
  filter?: Maybe<IWorkout_Type_Translation_Bool_Exp>;
  predicate: IInt_Comparison_Exp;
};

/** order by aggregate values of table "workout_type_translation" */
export type IWorkout_Type_Translation_Aggregate_Order_By = {
  avg?: Maybe<IWorkout_Type_Translation_Avg_Order_By>;
  count?: Maybe<IOrder_By>;
  max?: Maybe<IWorkout_Type_Translation_Max_Order_By>;
  min?: Maybe<IWorkout_Type_Translation_Min_Order_By>;
  stddev?: Maybe<IWorkout_Type_Translation_Stddev_Order_By>;
  stddev_pop?: Maybe<IWorkout_Type_Translation_Stddev_Pop_Order_By>;
  stddev_samp?: Maybe<IWorkout_Type_Translation_Stddev_Samp_Order_By>;
  sum?: Maybe<IWorkout_Type_Translation_Sum_Order_By>;
  var_pop?: Maybe<IWorkout_Type_Translation_Var_Pop_Order_By>;
  var_samp?: Maybe<IWorkout_Type_Translation_Var_Samp_Order_By>;
  variance?: Maybe<IWorkout_Type_Translation_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "workout_type_translation" */
export type IWorkout_Type_Translation_Arr_Rel_Insert_Input = {
  data: Array<IWorkout_Type_Translation_Insert_Input>;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Type_Translation_On_Conflict>;
};

/** order by avg() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Avg_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Boolean expression to filter rows from the table "workout_type_translation". All fields are combined with a logical 'AND'. */
export type IWorkout_Type_Translation_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Type_Translation_Bool_Exp>>;
  _not?: Maybe<IWorkout_Type_Translation_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Type_Translation_Bool_Exp>>;
  created_at?: Maybe<ITimestamptz_Comparison_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  locale?: Maybe<ILocale_Bool_Exp>;
  locale_id?: Maybe<IInt_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  workout_type?: Maybe<IWorkout_Type_Bool_Exp>;
  workout_type_id?: Maybe<IInt_Comparison_Exp>;
};

/** unique or primary key constraints on table "workout_type_translation" */
export enum IWorkout_Type_Translation_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutTypeTranslationPkey = 'workout_type_translation_pkey'
}

/** input type for incrementing numeric columns in table "workout_type_translation" */
export type IWorkout_Type_Translation_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "workout_type_translation" */
export type IWorkout_Type_Translation_Insert_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<ILocale_Obj_Rel_Insert_Input>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_type?: Maybe<IWorkout_Type_Obj_Rel_Insert_Input>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Max_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by min() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Min_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** on_conflict condition type for table "workout_type_translation" */
export type IWorkout_Type_Translation_On_Conflict = {
  constraint: IWorkout_Type_Translation_Constraint;
  update_columns?: Array<IWorkout_Type_Translation_Update_Column>;
  where?: Maybe<IWorkout_Type_Translation_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_type_translation". */
export type IWorkout_Type_Translation_Order_By = {
  created_at?: Maybe<IOrder_By>;
  id?: Maybe<IOrder_By>;
  locale?: Maybe<ILocale_Order_By>;
  locale_id?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_type?: Maybe<IWorkout_Type_Order_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** primary key columns input for table: workout_type_translation */
export type IWorkout_Type_Translation_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_type_translation" */
export enum IWorkout_Type_Translation_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

/** input type for updating data in table "workout_type_translation" */
export type IWorkout_Type_Translation_Set_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_pop() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by stddev_samp() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Stddev_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** Streaming cursor of the table "workout_type_translation" */
export type IWorkout_Type_Translation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Type_Translation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Type_Translation_Stream_Cursor_Value_Input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  locale_id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workout_type_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Sum_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_type_translation" */
export enum IWorkout_Type_Translation_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocaleId = 'locale_id',
  /** column name */
  Name = 'name',
  /** column name */
  WorkoutTypeId = 'workout_type_id'
}

export type IWorkout_Type_Translation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Type_Translation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Type_Translation_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Type_Translation_Bool_Exp;
};

/** order by var_pop() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Var_Pop_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by var_samp() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Var_Samp_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** order by variance() on columns of table "workout_type_translation" */
export type IWorkout_Type_Translation_Variance_Order_By = {
  id?: Maybe<IOrder_By>;
  locale_id?: Maybe<IOrder_By>;
  workout_type_id?: Maybe<IOrder_By>;
};

/** update columns of table "workout_type" */
export enum IWorkout_Type_Update_Column {
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id'
}

export type IWorkout_Type_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Type_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Type_Bool_Exp;
};

/** Boolean expression to filter rows from the table "workout_zone". All fields are combined with a logical 'AND'. */
export type IWorkout_Zone_Bool_Exp = {
  _and?: Maybe<Array<IWorkout_Zone_Bool_Exp>>;
  _not?: Maybe<IWorkout_Zone_Bool_Exp>;
  _or?: Maybe<Array<IWorkout_Zone_Bool_Exp>>;
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Bool_Exp>;
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Bool_Exp>;
  athlete_workouts?: Maybe<IAthlete_Workout_Bool_Exp>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Bool_Exp>;
  id?: Maybe<IInt_Comparison_Exp>;
  interval_end?: Maybe<INumeric_Comparison_Exp>;
  interval_start?: Maybe<INumeric_Comparison_Exp>;
  name?: Maybe<IString_Comparison_Exp>;
  workout_section_templates?: Maybe<IWorkout_Section_Template_Bool_Exp>;
  workout_section_templates_aggregate?: Maybe<IWorkout_Section_Template_Aggregate_Bool_Exp>;
  workout_templates?: Maybe<IWorkout_Template_Bool_Exp>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "workout_zone" */
export enum IWorkout_Zone_Constraint {
  /** unique or primary key constraint on columns "id" */
  WorkoutZonePkey = 'workout_zone_pkey'
}

/** input type for incrementing numeric columns in table "workout_zone" */
export type IWorkout_Zone_Inc_Input = {
  id?: Maybe<Scalars['Int']>;
  interval_end?: Maybe<Scalars['numeric']>;
  interval_start?: Maybe<Scalars['numeric']>;
};

/** input type for inserting data into table "workout_zone" */
export type IWorkout_Zone_Insert_Input = {
  athlete_workout_sections?: Maybe<IAthlete_Workout_Section_Arr_Rel_Insert_Input>;
  athlete_workouts?: Maybe<IAthlete_Workout_Arr_Rel_Insert_Input>;
  id?: Maybe<Scalars['Int']>;
  interval_end?: Maybe<Scalars['numeric']>;
  interval_start?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  workout_section_templates?: Maybe<IWorkout_Section_Template_Arr_Rel_Insert_Input>;
  workout_templates?: Maybe<IWorkout_Template_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "workout_zone" */
export type IWorkout_Zone_Obj_Rel_Insert_Input = {
  data: IWorkout_Zone_Insert_Input;
  /** upsert condition */
  on_conflict?: Maybe<IWorkout_Zone_On_Conflict>;
};

/** on_conflict condition type for table "workout_zone" */
export type IWorkout_Zone_On_Conflict = {
  constraint: IWorkout_Zone_Constraint;
  update_columns?: Array<IWorkout_Zone_Update_Column>;
  where?: Maybe<IWorkout_Zone_Bool_Exp>;
};

/** Ordering options when selecting data from "workout_zone". */
export type IWorkout_Zone_Order_By = {
  athlete_workout_sections_aggregate?: Maybe<IAthlete_Workout_Section_Aggregate_Order_By>;
  athlete_workouts_aggregate?: Maybe<IAthlete_Workout_Aggregate_Order_By>;
  id?: Maybe<IOrder_By>;
  interval_end?: Maybe<IOrder_By>;
  interval_start?: Maybe<IOrder_By>;
  name?: Maybe<IOrder_By>;
  workout_section_templates_aggregate?: Maybe<IWorkout_Section_Template_Aggregate_Order_By>;
  workout_templates_aggregate?: Maybe<IWorkout_Template_Aggregate_Order_By>;
};

/** primary key columns input for table: workout_zone */
export type IWorkout_Zone_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "workout_zone" */
export enum IWorkout_Zone_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IntervalEnd = 'interval_end',
  /** column name */
  IntervalStart = 'interval_start',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "workout_zone" */
export type IWorkout_Zone_Set_Input = {
  id?: Maybe<Scalars['Int']>;
  interval_end?: Maybe<Scalars['numeric']>;
  interval_start?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** Streaming cursor of the table "workout_zone" */
export type IWorkout_Zone_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IWorkout_Zone_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: Maybe<ICursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IWorkout_Zone_Stream_Cursor_Value_Input = {
  id?: Maybe<Scalars['Int']>;
  interval_end?: Maybe<Scalars['numeric']>;
  interval_start?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "workout_zone" */
export enum IWorkout_Zone_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IntervalEnd = 'interval_end',
  /** column name */
  IntervalStart = 'interval_start',
  /** column name */
  Name = 'name'
}

export type IWorkout_Zone_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: Maybe<IWorkout_Zone_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: Maybe<IWorkout_Zone_Set_Input>;
  /** filter the rows which have to be updated */
  where: IWorkout_Zone_Bool_Exp;
};

export type IClient_Athlete_WorkoutFragment = { __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, motivation?: Maybe<number>, effort?: Maybe<number>, comments?: Maybe<string>, series?: Maybe<string>, strava_activity_id?: Maybe<any>, measured_calories?: Maybe<number>, calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, type?: Maybe<string>, stretching_circuit_id?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, completed_stretching_circuit?: Maybe<number>, weight_circuit_id?: Maybe<number>, weight_circuit_repetitions?: Maybe<number>, completed_weight_circuit?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> }>, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: Maybe<string>, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: Maybe<string>, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: Maybe<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> }> };

export type ICircuit_BasicFragment = { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> };

export type ICancelSubscriptionMutationVariables = Exact<{
  subscription_id: Scalars['String'];
}>;


export type ICancelSubscriptionMutation = { __typename?: 'mutation_root', cancel_subscription: { __typename?: 'cancel_subscription_res', success: boolean } };

export type IDeleteBioDataMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteBioDataMutation = { __typename?: 'mutation_root', delete_athlete_biometric_data_by_pk?: Maybe<{ __typename?: 'athlete_biometric_data', id: number }> };

export type IDeleteAthleteChallengeMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IDeleteAthleteChallengeMutation = { __typename?: 'mutation_root', delete_athlete_challenge_by_pk?: Maybe<{ __typename?: 'athlete_challenge', id: number }> };

export type IInsertAthleteChallengeMutationVariables = Exact<{
  object: IAthlete_Challenge_Insert_Input;
}>;


export type IInsertAthleteChallengeMutation = { __typename?: 'mutation_root', insert_athlete_challenge_one?: Maybe<{ __typename?: 'athlete_challenge', id: number }> };

export type IInsertBiometricDataMutationVariables = Exact<{
  objects: Array<IAthlete_Biometric_Data_Insert_Input> | IAthlete_Biometric_Data_Insert_Input;
}>;


export type IInsertBiometricDataMutation = { __typename?: 'mutation_root', insert_athlete_biometric_data?: Maybe<{ __typename?: 'athlete_biometric_data_mutation_response', returning: Array<{ __typename?: 'athlete_biometric_data', id: number }> }> };

export type IRecoverPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type IRecoverPasswordMutation = { __typename?: 'mutation_root', recover_password?: Maybe<boolean> };

export type IRegisterMutationVariables = Exact<{
  inputs: IRegisterInput;
}>;


export type IRegisterMutation = { __typename?: 'mutation_root', user_register: { __typename?: 'user_register_res', success: boolean } };

export type IRegisterCoachMutationVariables = Exact<{
  inputs: IRegisterCoachInput;
}>;


export type IRegisterCoachMutation = { __typename?: 'mutation_root', coach_register: { __typename?: 'coach_register_res', success: boolean } };

export type ISetNewUserPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type ISetNewUserPasswordMutation = { __typename?: 'mutation_root', set_new_user_password?: Maybe<boolean> };

export type IUpdateAthleteMutationVariables = Exact<{
  id: Scalars['Int'];
  _set: IAthlete_Set_Input;
}>;


export type IUpdateAthleteMutation = { __typename?: 'mutation_root', update_athlete_by_pk?: Maybe<{ __typename?: 'athlete', id: number }> };

export type IUpdateAthleteChallengeMutationVariables = Exact<{
  _set: IAthlete_Challenge_Set_Input;
  id: Scalars['Int'];
}>;


export type IUpdateAthleteChallengeMutation = { __typename?: 'mutation_root', update_athlete_challenge_by_pk?: Maybe<{ __typename?: 'athlete_challenge', id: number }> };

export type IUpdateUserStravaAccessTokenMutationVariables = Exact<{
  id: Scalars['Int'];
  strava_access_token: Scalars['String'];
}>;


export type IUpdateUserStravaAccessTokenMutation = { __typename?: 'mutation_root', update_user_by_pk?: Maybe<{ __typename?: 'user', id: number }> };

export type IUpsertAthleteWorkoutSectionsMutationVariables = Exact<{
  athlete_workout_section_objects: Array<IAthlete_Workout_Section_Insert_Input> | IAthlete_Workout_Section_Insert_Input;
  athlete_workout_id: Scalars['Int'];
  athlete_workout_object: IAthlete_Workout_Set_Input;
}>;


export type IUpsertAthleteWorkoutSectionsMutation = { __typename?: 'mutation_root', delete_athlete_workout_section?: Maybe<{ __typename?: 'athlete_workout_section_mutation_response', affected_rows: number }>, insert_athlete_workout_section?: Maybe<{ __typename?: 'athlete_workout_section_mutation_response', returning: Array<{ __typename?: 'athlete_workout_section', id: number }> }>, update_athlete_workout_by_pk?: Maybe<{ __typename?: 'athlete_workout', id: number }> };

export type IAthleteBaseInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type IAthleteBaseInfoQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', id: number, name?: Maybe<string>, strava_access_token?: Maybe<string>, athlete?: Maybe<{ __typename?: 'athlete', avatar?: Maybe<string>, id: number, name: string, gender?: Maybe<string>, sport_id?: Maybe<string>, stripe_customer_id?: Maybe<string>, user: { __typename?: 'user', email: string } }> }> };

export type IAthleteBaseInfoFragment = { __typename?: 'user', id: number, name?: Maybe<string>, strava_access_token?: Maybe<string>, athlete?: Maybe<{ __typename?: 'athlete', avatar?: Maybe<string>, id: number, name: string, gender?: Maybe<string>, sport_id?: Maybe<string>, stripe_customer_id?: Maybe<string>, user: { __typename?: 'user', email: string } }> };

export type IAthleteBioDataAndEvolutionQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteBioDataAndEvolutionQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', id: number, name: string, birthday?: Maybe<any>, avatar?: Maybe<string>, gender?: Maybe<string>, goal?: Maybe<string>, sport_id?: Maybe<string>, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: Maybe<number>, biometric_parameter_id: string, created_at: string, file_url?: Maybe<string>, biometric_parameter: { __typename?: 'biometric_parameter', label?: Maybe<string> } }> }> };

export type IAthlete_Bio_Data_DetailsFragment = { __typename?: 'athlete', id: number, name: string, birthday?: Maybe<any>, avatar?: Maybe<string>, gender?: Maybe<string>, goal?: Maybe<string>, sport_id?: Maybe<string>, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: Maybe<number>, biometric_parameter_id: string, created_at: string, file_url?: Maybe<string>, biometric_parameter: { __typename?: 'biometric_parameter', label?: Maybe<string> } }> };

export type IAthleteChallengesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IAthleteChallengesQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', id: number, athlete_challenges: Array<{ __typename?: 'athlete_challenge', sport_id?: Maybe<string>, athlete_id: number, notes?: Maybe<string>, description: string, time_done_hours?: Maybe<number>, time_done_minutes?: Maybe<number>, result?: Maybe<string>, id: number, date?: Maybe<any>, created_at: string, completed_at?: Maybe<any>, is_main?: Maybe<boolean>, time_goal_hours?: Maybe<number>, time_goal_minutes?: Maybe<number>, positive_univeness?: Maybe<number>, negative_univeness?: Maybe<number>, cumulated_univeness?: Maybe<number>, distance?: Maybe<string> }> }> };

export type IAthleteChallengesDataQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
}>;


export type IAthleteChallengesDataQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', athlete_challenges: Array<{ __typename?: 'athlete_challenge', description: string, date?: Maybe<any>, time_goal_hours?: Maybe<number>, time_goal_minutes?: Maybe<number>, positive_univeness?: Maybe<number>, negative_univeness?: Maybe<number>, cumulated_univeness?: Maybe<number>, distance?: Maybe<string> }> }> };

export type IAthleteHasAccessQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
}>;


export type IAthleteHasAccessQuery = { __typename?: 'query_root', check_if_athlete_has_access: { __typename?: 'access_response', success: boolean, message?: Maybe<string> } };

export type IAthleteWorkoutSectionsQueryVariables = Exact<{
  workouts_ids?: Maybe<Array<Scalars['Int']> | Scalars['Int']>;
  athlete_id: Scalars['Int'];
}>;


export type IAthleteWorkoutSectionsQuery = { __typename?: 'query_root', current_weight: Array<{ __typename?: 'athlete_biometric_data', value?: Maybe<number> }>, athlete_workout: Array<{ __typename?: 'athlete_workout', id: number, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number }, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, order?: Maybe<number>, speed?: Maybe<number>, workout_zone_id?: Maybe<number>, average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, duration?: Maybe<number>, type?: Maybe<string>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number> }> }> };

export type IAthlete_Workout_Sections_OnlyFragment = { __typename?: 'athlete_workout', id: number, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number }, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, order?: Maybe<number>, speed?: Maybe<number>, workout_zone_id?: Maybe<number>, average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, duration?: Maybe<number>, type?: Maybe<string>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number> }> };

export type IAthleteWorkoutsQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
  start_date: Scalars['date'];
  end_date: Scalars['date'];
}>;


export type IAthleteWorkoutsQuery = { __typename?: 'query_root', athlete_week: Array<{ __typename?: 'athlete_week', start_date?: Maybe<any>, end_date?: Maybe<any>, id: number, order: number, name?: Maybe<string>, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, motivation?: Maybe<number>, effort?: Maybe<number>, comments?: Maybe<string>, series?: Maybe<string>, strava_activity_id?: Maybe<any>, measured_calories?: Maybe<number>, calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, type?: Maybe<string>, stretching_circuit_id?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, completed_stretching_circuit?: Maybe<number>, weight_circuit_id?: Maybe<number>, weight_circuit_repetitions?: Maybe<number>, completed_weight_circuit?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: Maybe<string>, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: Maybe<string>, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: Maybe<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> }> }> }> };

export type IFull_Athlete_WeekFragment = { __typename?: 'athlete_week', start_date?: Maybe<any>, end_date?: Maybe<any>, id: number, order: number, name?: Maybe<string>, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, motivation?: Maybe<number>, effort?: Maybe<number>, comments?: Maybe<string>, series?: Maybe<string>, strava_activity_id?: Maybe<any>, measured_calories?: Maybe<number>, calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, type?: Maybe<string>, stretching_circuit_id?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, completed_stretching_circuit?: Maybe<number>, weight_circuit_id?: Maybe<number>, weight_circuit_repetitions?: Maybe<number>, completed_weight_circuit?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: Maybe<string>, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: Maybe<string>, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: Maybe<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> }> }> };

export type ICalendarWorkoutDatesQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
  start_date: Scalars['date'];
  end_date: Scalars['date'];
}>;


export type ICalendarWorkoutDatesQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', start_date?: Maybe<any>, athlete_workouts: Array<{ __typename?: 'athlete_workout', date: any }> }> }> }> };

export type ICoachPageQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ICoachPageQuery = { __typename?: 'query_root', coach_by_pk?: Maybe<{ __typename?: 'coach', id: number, name: string, profile_picture?: Maybe<string>, spoken_languages?: Maybe<string[]>, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, min_duration?: Maybe<number>, biannualy_discount?: Maybe<number>, quarterly_discount?: Maybe<number>, recomended_duration?: Maybe<number>, sport_id?: Maybe<string>, coach_id?: Maybe<number>, created_at: string, weekly_price?: Maybe<number>, yearly_discount?: Maybe<number>, sport?: Maybe<{ __typename?: 'sport', avatar?: Maybe<string>, id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }> }>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> }> };

export type ICoachesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ICoachesListQuery = { __typename?: 'query_root', coach: Array<{ __typename?: 'coach', id: number, name: string, profile_picture?: Maybe<string>, spoken_languages?: Maybe<string[]>, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, min_duration?: Maybe<number>, biannualy_discount?: Maybe<number>, quarterly_discount?: Maybe<number>, recomended_duration?: Maybe<number>, sport_id?: Maybe<string>, coach_id?: Maybe<number>, created_at: string, weekly_price?: Maybe<number>, yearly_discount?: Maybe<number>, sport?: Maybe<{ __typename?: 'sport', avatar?: Maybe<string>, id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }> }>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> }> };

export type ICreateStripeCheckoutUrlQueryVariables = Exact<{
  stripe_price_id: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  customer?: Maybe<Scalars['String']>;
  email_language?: Maybe<Scalars['String']>;
}>;


export type ICreateStripeCheckoutUrlQuery = { __typename?: 'query_root', create_stripe_checkout_url: string };

export type IHomePageQueryVariables = Exact<{ [key: string]: never; }>;


export type IHomePageQuery = { __typename?: 'query_root', sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, min_duration?: Maybe<number>, biannualy_discount?: Maybe<number>, quarterly_discount?: Maybe<number>, recomended_duration?: Maybe<number>, sport_id?: Maybe<string>, coach_id?: Maybe<number>, created_at: string, weekly_price?: Maybe<number>, yearly_discount?: Maybe<number>, sport?: Maybe<{ __typename?: 'sport', avatar?: Maybe<string>, id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }> }>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, review: Array<{ __typename?: 'review', image?: Maybe<string>, id: number, name: string, review_translations: Array<{ __typename?: 'review_translation', id: number, text?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ISubscription_PlanFragment = { __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, min_duration?: Maybe<number>, biannualy_discount?: Maybe<number>, quarterly_discount?: Maybe<number>, recomended_duration?: Maybe<number>, sport_id?: Maybe<string>, coach_id?: Maybe<number>, created_at: string, weekly_price?: Maybe<number>, yearly_discount?: Maybe<number>, sport?: Maybe<{ __typename?: 'sport', avatar?: Maybe<string>, id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }> };

export type ICoachFragment = { __typename?: 'coach', id: number, name: string, profile_picture?: Maybe<string>, spoken_languages?: Maybe<string[]>, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sports: Array<{ __typename?: 'coach_sport', id: number, sport: { __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, min_duration?: Maybe<number>, biannualy_discount?: Maybe<number>, quarterly_discount?: Maybe<number>, recomended_duration?: Maybe<number>, sport_id?: Maybe<string>, coach_id?: Maybe<number>, created_at: string, weekly_price?: Maybe<number>, yearly_discount?: Maybe<number>, sport?: Maybe<{ __typename?: 'sport', avatar?: Maybe<string>, id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }> }>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> };

export type IIsEmailAvailableQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IIsEmailAvailableQuery = { __typename?: 'query_root', is_email_available: boolean };

export type ILocalesListQueryVariables = Exact<{ [key: string]: never; }>;


export type ILocalesListQuery = { __typename?: 'query_root', locale: Array<{ __typename?: 'locale', id: number, code: string, language: string }> };

export type IProfileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IProfileQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', id: number, name: string, birthday?: Maybe<any>, avatar?: Maybe<string>, gender?: Maybe<string>, athlete_profile_id?: Maybe<number>, address_city?: Maybe<string>, address_postal_code?: Maybe<string>, address_street?: Maybe<string>, address_country?: Maybe<string>, phone?: Maybe<string>, status?: Maybe<string>, fiscal_id_number?: Maybe<string>, goal?: Maybe<string>, sport_id?: Maybe<string>, user_id: number, subscriptions: Array<{ __typename?: 'subscription', date_start: any, date_end: any, id: number, interval_count?: Maybe<number>, price?: Maybe<number>, status: string, stripe_subscription_id?: Maybe<string>, subscription_plan: { __typename?: 'subscription_plan', id: number, level?: Maybe<number>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sport?: Maybe<{ __typename?: 'sport', id: any, name: string, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> } }>, user: { __typename?: 'user', email: string }, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: Maybe<number>, biometric_parameter_id: string, created_at: string, file_url?: Maybe<string>, biometric_parameter: { __typename?: 'biometric_parameter', label?: Maybe<string> } }> }> };

export type IAthlete_DetailsFragment = { __typename?: 'athlete', id: number, name: string, birthday?: Maybe<any>, avatar?: Maybe<string>, gender?: Maybe<string>, athlete_profile_id?: Maybe<number>, address_city?: Maybe<string>, address_postal_code?: Maybe<string>, address_street?: Maybe<string>, address_country?: Maybe<string>, phone?: Maybe<string>, status?: Maybe<string>, fiscal_id_number?: Maybe<string>, goal?: Maybe<string>, sport_id?: Maybe<string>, user_id: number, user: { __typename?: 'user', email: string }, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', id: number, value?: Maybe<number>, biometric_parameter_id: string, created_at: string, file_url?: Maybe<string>, biometric_parameter: { __typename?: 'biometric_parameter', label?: Maybe<string> } }> };

export type ISubscriptionFragment = { __typename?: 'subscription', date_start: any, date_end: any, id: number, interval_count?: Maybe<number>, price?: Maybe<number>, status: string, stripe_subscription_id?: Maybe<string>, subscription_plan: { __typename?: 'subscription_plan', id: number, level?: Maybe<number>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, sport?: Maybe<{ __typename?: 'sport', id: any, name: string, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> } };

export type ISportByPkQueryVariables = Exact<{
  id: Scalars['name'];
}>;


export type ISportByPkQuery = { __typename?: 'query_root', sport_by_pk?: Maybe<{ __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }>, coaches: Array<{ __typename?: 'coach_sport', coach: { __typename?: 'coach', id: number, name: string, profile_picture?: Maybe<string>, is_verified: boolean, public?: Maybe<boolean>, spoken_languages?: Maybe<string[]>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, sport_id?: Maybe<string> }>, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> } }> }> };

export type ISportCoachFragment = { __typename?: 'coach', id: number, name: string, profile_picture?: Maybe<string>, is_verified: boolean, public?: Maybe<boolean>, spoken_languages?: Maybe<string[]>, subscription_plans: Array<{ __typename?: 'subscription_plan', id: number, sport_id?: Maybe<string> }>, coach_translations: Array<{ __typename?: 'coach_translation', id: number, bio?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type ISportsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ISportsListQuery = { __typename?: 'query_root', sport: Array<{ __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type IStatsWorkoutDataQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
  start_date: Scalars['date'];
  end_date: Scalars['date'];
}>;


export type IStatsWorkoutDataQuery = { __typename?: 'query_root', workout_type: Array<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_by_pk?: Maybe<{ __typename?: 'athlete', athlete_profile?: Maybe<{ __typename?: 'athlete_profile', param_effort?: Maybe<number>, param_motivation?: Maybe<number>, param_distance_variation?: Maybe<number>, param_calories?: Maybe<number>, param_ziut?: Maybe<number>, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> }>, athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', start_date?: Maybe<any>, end_date?: Maybe<any>, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, effort?: Maybe<number>, motivation?: Maybe<number>, calories?: Maybe<number>, measured_calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, series?: Maybe<string>, type?: Maybe<string>, weight_circuit_repetitions?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: Maybe<number>, measured_duration?: Maybe<number>, speed?: Maybe<number>, measured_speed?: Maybe<number>, average_heart_rate?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, type?: Maybe<string>, workout_zone_id?: Maybe<number>, is_main?: Maybe<boolean> }> }> }> }> }> };

export type ISubscriptionPlanByPkQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ISubscriptionPlanByPkQuery = { __typename?: 'query_root', subscription_plan_by_pk?: Maybe<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, image?: Maybe<string>, min_duration?: Maybe<number>, recomended_duration?: Maybe<number>, weekly_price?: Maybe<number>, quarterly_discount?: Maybe<number>, biannualy_discount?: Maybe<number>, yearly_discount?: Maybe<number>, created_at: string, stripe_product_id?: Maybe<string>, sport?: Maybe<{ __typename?: 'sport', id: any, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, coach?: Maybe<{ __typename?: 'coach', id: number, name: string }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string>, stripe_lookup_key?: Maybe<string> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type ISubscriptionPlansListQueryVariables = Exact<{
  where?: Maybe<ISubscription_Plan_Bool_Exp>;
}>;


export type ISubscriptionPlansListQuery = { __typename?: 'query_root', subscription_plan: Array<{ __typename?: 'subscription_plan', id: number, level?: Maybe<number>, is_verified?: Maybe<boolean>, image?: Maybe<string>, recomended_duration?: Maybe<number>, weekly_price?: Maybe<number>, created_at: string, stripe_product_id?: Maybe<string>, coach?: Maybe<{ __typename?: 'coach', id: number, name: string }>, sport?: Maybe<{ __typename?: 'sport', id: any, name: string, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }>, subscription_plan_prices: Array<{ __typename?: 'subscription_plan_price', interval_count: number, unit_amount: number, id: number, subscription_plan_id: number, stripe_price_id?: Maybe<string> }>, subscription_plan_translations: Array<{ __typename?: 'subscription_plan_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }> };

export type IUserStravaAccessTokenQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type IUserStravaAccessTokenQuery = { __typename?: 'query_root', user_by_pk?: Maybe<{ __typename?: 'user', strava_access_token?: Maybe<string> }> };

export type IWorkoutCircuitsQueryVariables = Exact<{
  workout_id: Scalars['Int'];
}>;


export type IWorkoutCircuitsQuery = { __typename?: 'query_root', athlete_workout_by_pk?: Maybe<{ __typename?: 'athlete_workout', id: number, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }> }> };

export type IWorkoutDetailsForDateQueryVariables = Exact<{
  athlete_id: Scalars['Int'];
  date: Scalars['date'];
}>;


export type IWorkoutDetailsForDateQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', max_heart_rate: Array<{ __typename?: 'athlete_biometric_data', value?: Maybe<number> }>, athlete_profile?: Maybe<{ __typename?: 'athlete_profile', param_effort?: Maybe<number>, param_motivation?: Maybe<number>, param_distance_variation?: Maybe<number>, param_calories?: Maybe<number>, param_ziut?: Maybe<number>, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> }> }>, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, motivation?: Maybe<number>, effort?: Maybe<number>, comments?: Maybe<string>, series?: Maybe<string>, strava_activity_id?: Maybe<any>, measured_calories?: Maybe<number>, calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, type?: Maybe<string>, stretching_circuit_id?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, completed_stretching_circuit?: Maybe<number>, weight_circuit_id?: Maybe<number>, weight_circuit_repetitions?: Maybe<number>, completed_weight_circuit?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> }>, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: Maybe<string>, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: Maybe<string>, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: Maybe<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> }> }> };

export type IWorkoutZoneListQueryVariables = Exact<{ [key: string]: never; }>;


export type IWorkoutZoneListQuery = { __typename?: 'query_root', workout_zone: Array<{ __typename?: 'workout_zone', id: number, name: string }> };

export type IAthlete_ChallengeFragment = { __typename?: 'athlete_challenge', description: string, time_done_hours?: Maybe<number>, time_done_minutes?: Maybe<number>, result?: Maybe<string>, id: number, date?: Maybe<any>, created_at: string, completed_at?: Maybe<any>, is_main?: Maybe<boolean>, time_goal_hours?: Maybe<number>, time_goal_minutes?: Maybe<number>, positive_univeness?: Maybe<number>, negative_univeness?: Maybe<number>, cumulated_univeness?: Maybe<number>, distance?: Maybe<string> };

export type IAthlete_Details_Biometric_ParamFragment = { __typename?: 'athlete_biometric_data', id: number, value?: Maybe<number>, biometric_parameter_id: string, created_at: string, file_url?: Maybe<string>, biometric_parameter: { __typename?: 'biometric_parameter', label?: Maybe<string> } };

export type IStats_Athlete_ProfileFragment = { __typename?: 'athlete_profile', param_effort?: Maybe<number>, param_motivation?: Maybe<number>, param_distance_variation?: Maybe<number>, param_calories?: Maybe<number>, param_ziut?: Maybe<number>, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> };

export type IStats_Athlete_WeekFragment = { __typename?: 'athlete_week', start_date?: Maybe<any>, end_date?: Maybe<any>, id: number, order: number, name?: Maybe<string>, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, effort?: Maybe<number>, motivation?: Maybe<number>, calories?: Maybe<number>, measured_calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, series?: Maybe<string>, type?: Maybe<string>, weight_circuit_repetitions?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: Maybe<number>, measured_duration?: Maybe<number>, speed?: Maybe<number>, measured_speed?: Maybe<number>, average_heart_rate?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, type?: Maybe<string>, workout_zone_id?: Maybe<number>, is_main?: Maybe<boolean> }> }> };

export type IStats_Athlete_WorkoutFragment = { __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, effort?: Maybe<number>, motivation?: Maybe<number>, calories?: Maybe<number>, measured_calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, series?: Maybe<string>, type?: Maybe<string>, weight_circuit_repetitions?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: Maybe<number>, measured_duration?: Maybe<number>, speed?: Maybe<number>, measured_speed?: Maybe<number>, average_heart_rate?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, type?: Maybe<string>, workout_zone_id?: Maybe<number>, is_main?: Maybe<boolean> }> };

export type IAthlete_WorkoutFragment = { __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, motivation?: Maybe<number>, effort?: Maybe<number>, comments?: Maybe<string>, series?: Maybe<string>, strava_activity_id?: Maybe<any>, measured_calories?: Maybe<number>, calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, type?: Maybe<string>, stretching_circuit_id?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, completed_stretching_circuit?: Maybe<number>, weight_circuit_id?: Maybe<number>, weight_circuit_repetitions?: Maybe<number>, completed_weight_circuit?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, stretching_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, weight_circuit?: Maybe<{ __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> }>, workout_altimetry: { __typename?: 'workout_altimetry', coefficient: number, icon?: Maybe<string>, id: number, name: string, workout_altimetry_translations: Array<{ __typename?: 'workout_altimetry_translation', id: number, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_terrain: { __typename?: 'workout_terrain', coefficient: number, icon?: Maybe<string>, id: number, workout_terrain_translations: Array<{ __typename?: 'workout_terrain_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> }, workout_type?: Maybe<{ __typename?: 'workout_type', id: number, avatar: string, workout_type_translations: Array<{ __typename?: 'workout_type_translation', name?: Maybe<string>, locale: { __typename?: 'locale', code: string } }> }>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> }> };

export type IAthlete_Workout_SectionFragment = { __typename?: 'athlete_workout_section', athlete_workout_id: number, duration?: Maybe<number>, max_heart_rate?: Maybe<number>, speed?: Maybe<number>, speed_percentage?: Maybe<number>, average_heart_rate?: Maybe<number>, average_heart_rate_percentage?: Maybe<number>, measured_duration?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, measured_speed?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, id: number, type?: Maybe<string>, workout_zone_id?: Maybe<number>, order?: Maybe<number>, planned_stress_score?: Maybe<number>, executed_stress_score?: Maybe<number>, workout_zone?: Maybe<{ __typename?: 'workout_zone', name: string, id: number, interval_start: number, interval_end: number }> };

export type IStats_Biometric_DataFragment = { __typename?: 'athlete_biometric_data', biometric_parameter_id: string, value?: Maybe<number> };

export type ICircuitFragment = { __typename?: 'circuit', id: number, type: string, circuit_translations: Array<{ __typename?: 'circuit_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }>, circuit_exercises: Array<{ __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } }> };

export type ICircuit_ExerciseFragment = { __typename?: 'circuit_exercise', id: number, circuit_id: number, duration?: Maybe<number>, exercise_id: number, no_of_series?: Maybe<number>, order?: Maybe<number>, repetitions?: Maybe<number>, exercise: { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> } };

export type IExerciseFragment = { __typename?: 'exercise', id: number, media_url: string, type: string, target?: Maybe<string>, exercise_translations: Array<{ __typename?: 'exercise_translation', id: number, name?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string } }> };

export type IReviewFragment = { __typename?: 'review', image?: Maybe<string>, id: number, name: string, review_translations: Array<{ __typename?: 'review_translation', id: number, text?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type ISportFragment = { __typename?: 'sport', id: any, name: string, avatar?: Maybe<string>, image?: Maybe<string>, sport_translations: Array<{ __typename?: 'sport_translation', id: number, title?: Maybe<string>, description?: Maybe<string>, locale: { __typename?: 'locale', id: number, code: string, language: string } }> };

export type IGetAthleteStressDataQueryVariables = Exact<{
  athleteId: Scalars['Int'];
  startDate: Scalars['date'];
  endDate: Scalars['date'];
}>;


export type IGetAthleteStressDataQuery = { __typename?: 'query_root', athlete_workout: Array<{ __typename?: 'athlete_workout', id: number, date: any, athlete_week_id: number, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, executed_stress_score?: Maybe<number> }> }> };

export type IStatsAthleteDashboardQueryVariables = Exact<{
  athleteId: Scalars['Int'];
}>;


export type IStatsAthleteDashboardQuery = { __typename?: 'query_root', athlete_by_pk?: Maybe<{ __typename?: 'athlete', athlete_profile?: Maybe<{ __typename?: 'athlete_profile', param_effort?: Maybe<number>, param_motivation?: Maybe<number>, param_distance_variation?: Maybe<number>, param_calories?: Maybe<number>, param_ziut?: Maybe<number>, athlete_profile_altimetry_adjustments: Array<{ __typename?: 'athlete_profile_altimetry_adjustment', workout_altimetry_id: number, value: number }> }>, athlete_biometric_data: Array<{ __typename?: 'athlete_biometric_data', biometric_parameter_id: string, value?: Maybe<number> }>, athlete_blocks: Array<{ __typename?: 'athlete_block', athlete_weeks: Array<{ __typename?: 'athlete_week', start_date?: Maybe<any>, end_date?: Maybe<any>, id: number, order: number, name?: Maybe<string>, sport_id: string, athlete_workouts: Array<{ __typename?: 'athlete_workout', athlete_week_id: number, date: any, day: number, id: number, is_primary?: Maybe<boolean>, workout_type_id?: Maybe<number>, workout_altimetry_id: number, workout_terrain_id: number, effort?: Maybe<number>, motivation?: Maybe<number>, calories?: Maybe<number>, measured_calories?: Maybe<number>, zuit?: Maybe<number>, positive_elevation?: Maybe<number>, negative_elevation?: Maybe<number>, measured_positive_elevation?: Maybe<number>, measured_negative_elevation?: Maybe<number>, series?: Maybe<string>, type?: Maybe<string>, weight_circuit_repetitions?: Maybe<number>, stretching_circuit_repetitions?: Maybe<number>, cumulative_elevation?: Maybe<number>, measured_cumulative_elevation?: Maybe<number>, athlete_workout_sections: Array<{ __typename?: 'athlete_workout_section', id: number, athlete_workout_id: number, duration?: Maybe<number>, measured_duration?: Maybe<number>, speed?: Maybe<number>, measured_speed?: Maybe<number>, average_heart_rate?: Maybe<number>, measured_average_heart_rate?: Maybe<number>, max_heart_rate?: Maybe<number>, measured_max_heart_rate?: Maybe<number>, type?: Maybe<string>, workout_zone_id?: Maybe<number>, is_main?: Maybe<boolean> }> }> }> }> }> };

export const Circuit_BasicFragmentDoc = /*#__PURE__*/ gql`
    fragment circuit_basic on circuit {
  id
  type
  circuit_translations {
    id
    name
    description
    locale {
      id
      code
    }
  }
}
    `;
export const Athlete_Workout_SectionFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_workout_section on athlete_workout_section {
  athlete_workout_id
  duration
  max_heart_rate
  speed
  speed_percentage
  average_heart_rate
  average_heart_rate_percentage
  measured_duration
  measured_max_heart_rate
  measured_speed
  measured_average_heart_rate
  id
  type
  workout_zone_id
  order
  workout_zone {
    name
    id
    interval_start
    interval_end
  }
  planned_stress_score
  executed_stress_score
}
    `;
export const Client_Athlete_WorkoutFragmentDoc = /*#__PURE__*/ gql`
    fragment client_athlete_workout on athlete_workout {
  athlete_week_id
  date
  day
  id
  is_primary
  workout_type_id
  motivation
  effort
  comments
  series
  strava_activity_id
  measured_calories
  calories
  zuit
  positive_elevation
  negative_elevation
  cumulative_elevation: sum_elevation
  measured_positive_elevation
  measured_negative_elevation
  measured_cumulative_elevation: sum_measured_elevation
  type
  stretching_circuit_id
  stretching_circuit_repetitions
  completed_stretching_circuit
  weight_circuit_id
  weight_circuit_repetitions
  completed_weight_circuit
  workout_altimetry_id
  workout_terrain_id
  stretching_circuit {
    ...circuit_basic
  }
  weight_circuit {
    ...circuit_basic
  }
  workout_altimetry {
    coefficient
    icon
    id
    name
    workout_altimetry_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_terrain {
    coefficient
    icon
    id
    workout_terrain_translations {
      id
      name
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  athlete_workout_sections(order_by: {order: asc}) {
    ...athlete_workout_section
  }
}
    ${Circuit_BasicFragmentDoc}
${Athlete_Workout_SectionFragmentDoc}`;
export const AthleteBaseInfoFragmentDoc = /*#__PURE__*/ gql`
    fragment athleteBaseInfo on user {
  id
  name
  strava_access_token
  athlete {
    avatar
    id
    name
    gender
    sport_id
    stripe_customer_id
    user {
      email
    }
  }
}
    `;
export const Athlete_Details_Biometric_ParamFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_details_biometric_param on athlete_biometric_data {
  id
  value
  biometric_parameter_id
  created_at
  file_url
  biometric_parameter {
    label
  }
}
    `;
export const Athlete_Bio_Data_DetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_bio_data_details on athlete {
  id
  name
  birthday
  avatar
  gender
  goal
  sport_id
  athlete_biometric_data(order_by: {created_at: asc}) {
    ...athlete_details_biometric_param
  }
}
    ${Athlete_Details_Biometric_ParamFragmentDoc}`;
export const Athlete_Workout_Sections_OnlyFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_workout_sections_only on athlete_workout {
  id
  workout_altimetry {
    coefficient
  }
  athlete_workout_sections(order_by: {order: asc}) {
    id
    athlete_workout_id
    order
    speed
    workout_zone_id
    average_heart_rate
    max_heart_rate
    duration
    athlete_workout_id
    type
    planned_stress_score
    executed_stress_score
  }
}
    `;
export const ExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment exercise on exercise {
  id
  media_url
  type
  target
  exercise_translations {
    id
    name
    description
    locale {
      id
      code
    }
  }
}
    `;
export const Circuit_ExerciseFragmentDoc = /*#__PURE__*/ gql`
    fragment circuit_exercise on circuit_exercise {
  id
  circuit_id
  duration
  exercise_id
  no_of_series
  order
  repetitions
  exercise {
    ...exercise
  }
}
    ${ExerciseFragmentDoc}`;
export const CircuitFragmentDoc = /*#__PURE__*/ gql`
    fragment circuit on circuit {
  id
  type
  circuit_translations {
    id
    name
    description
    locale {
      id
      code
    }
  }
  circuit_exercises {
    ...circuit_exercise
  }
}
    ${Circuit_ExerciseFragmentDoc}`;
export const Athlete_WorkoutFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_workout on athlete_workout {
  athlete_week_id
  date
  day
  id
  is_primary
  workout_type_id
  motivation
  effort
  comments
  series
  strava_activity_id
  measured_calories
  calories
  zuit
  positive_elevation
  negative_elevation
  cumulative_elevation: sum_elevation
  measured_positive_elevation
  measured_negative_elevation
  measured_cumulative_elevation: sum_measured_elevation
  type
  stretching_circuit_id
  stretching_circuit_repetitions
  completed_stretching_circuit
  weight_circuit_id
  weight_circuit_repetitions
  completed_weight_circuit
  workout_altimetry_id
  workout_terrain_id
  stretching_circuit {
    ...circuit
  }
  weight_circuit {
    ...circuit
  }
  workout_altimetry {
    coefficient
    icon
    id
    name
    workout_altimetry_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_terrain {
    coefficient
    icon
    id
    workout_terrain_translations {
      id
      name
      description
      locale {
        id
        code
        language
      }
    }
  }
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  athlete_workout_sections(order_by: {order: asc}) {
    ...athlete_workout_section
  }
}
    ${CircuitFragmentDoc}
${Athlete_Workout_SectionFragmentDoc}`;
export const Full_Athlete_WeekFragmentDoc = /*#__PURE__*/ gql`
    fragment full_athlete_week on athlete_week {
  start_date
  end_date
  id
  order
  name
  sport_id
  athlete_workouts {
    ...athlete_workout
  }
}
    ${Athlete_WorkoutFragmentDoc}`;
export const SportFragmentDoc = /*#__PURE__*/ gql`
    fragment sport on sport {
  id
  name
  avatar
  image
  sport_translations {
    id
    title
    description
    locale {
      id
      code
      language
    }
  }
}
    `;
export const Subscription_PlanFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription_plan on subscription_plan {
  id
  level
  is_verified
  min_duration
  biannualy_discount
  quarterly_discount
  recomended_duration
  sport_id
  coach_id
  created_at
  sport {
    avatar
    id
    sport_translations {
      id
      title
      locale {
        id
        code
        language
      }
    }
  }
  subscription_plan_translations {
    id
    description
    locale {
      id
      code
      language
    }
  }
  subscription_plan_prices {
    interval_count
    unit_amount
    id
    subscription_plan_id
    stripe_price_id
    stripe_lookup_key
  }
  weekly_price
  yearly_discount
}
    `;
export const CoachFragmentDoc = /*#__PURE__*/ gql`
    fragment coach on coach {
  id
  name
  profile_picture
  spoken_languages
  coach_translations {
    id
    bio
    locale {
      id
      code
      language
    }
  }
  sports {
    id
    sport {
      ...sport
      subscription_plans {
        ...subscription_plan
      }
    }
  }
}
    ${SportFragmentDoc}
${Subscription_PlanFragmentDoc}`;
export const Athlete_DetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_details on athlete {
  id
  name
  birthday
  avatar
  gender
  athlete_profile_id
  address_city
  address_postal_code
  address_street
  address_country
  phone
  status
  fiscal_id_number
  goal
  sport_id
  user {
    email
  }
  user_id
  athlete_biometric_data(order_by: {created_at: desc}) {
    ...athlete_details_biometric_param
  }
}
    ${Athlete_Details_Biometric_ParamFragmentDoc}`;
export const SubscriptionFragmentDoc = /*#__PURE__*/ gql`
    fragment subscription on subscription {
  date_start
  date_end
  id
  interval_count
  price
  status
  stripe_subscription_id
  subscription_plan {
    id
    level
    subscription_plan_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
    sport {
      id
      name
      sport_translations {
        id
        title
        locale {
          id
          code
          language
        }
      }
    }
  }
}
    `;
export const SportCoachFragmentDoc = /*#__PURE__*/ gql`
    fragment sportCoach on coach {
  id
  name
  profile_picture
  is_verified
  public
  spoken_languages
  subscription_plans {
    id
    sport_id
  }
  coach_translations {
    id
    bio
    locale {
      id
      code
      language
    }
  }
}
    `;
export const Athlete_ChallengeFragmentDoc = /*#__PURE__*/ gql`
    fragment athlete_challenge on athlete_challenge {
  description
  time_done_hours
  time_done_minutes
  result
  id
  date
  created_at
  completed_at
  is_main
  time_goal_hours
  time_goal_minutes
  positive_univeness
  negative_univeness
  cumulated_univeness
  distance
}
    `;
export const Stats_Athlete_ProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_profile on athlete_profile {
  param_effort
  param_motivation
  param_distance_variation
  param_calories
  param_ziut
  athlete_profile_altimetry_adjustments {
    workout_altimetry_id
    value
  }
}
    `;
export const Stats_Athlete_WorkoutFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_workout on athlete_workout {
  athlete_week_id
  date
  day
  id
  is_primary
  workout_type_id
  workout_altimetry_id
  workout_terrain_id
  effort
  motivation
  calories
  measured_calories
  zuit
  positive_elevation
  negative_elevation
  measured_positive_elevation
  measured_negative_elevation
  cumulative_elevation: sum_elevation
  measured_cumulative_elevation: sum_measured_elevation
  series
  type
  weight_circuit_repetitions
  stretching_circuit_repetitions
  athlete_workout_sections {
    id
    athlete_workout_id
    duration
    measured_duration
    speed
    measured_speed
    average_heart_rate
    measured_average_heart_rate
    max_heart_rate
    measured_max_heart_rate
    type
    workout_zone_id
    is_main
  }
}
    `;
export const Stats_Athlete_WeekFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_athlete_week on athlete_week {
  start_date
  end_date
  id
  order
  name
  sport_id
  athlete_workouts {
    ...stats_athlete_workout
  }
}
    ${Stats_Athlete_WorkoutFragmentDoc}`;
export const Stats_Biometric_DataFragmentDoc = /*#__PURE__*/ gql`
    fragment stats_biometric_data on athlete_biometric_data {
  biometric_parameter_id
  value
}
    `;
export const ReviewFragmentDoc = /*#__PURE__*/ gql`
    fragment review on review {
  image
  id
  name
  review_translations {
    id
    text
    locale {
      id
      code
      language
    }
  }
}
    `;
export const CancelSubscriptionDocument = /*#__PURE__*/ gql`
    mutation CancelSubscription($subscription_id: String!) {
  cancel_subscription(subscription_id: $subscription_id) {
    success
  }
}
    `;
export type ICancelSubscriptionMutationFn = Apollo.MutationFunction<ICancelSubscriptionMutation, ICancelSubscriptionMutationVariables>;
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ICancelSubscriptionMutation, ICancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICancelSubscriptionMutation, ICancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<ICancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<ICancelSubscriptionMutation, ICancelSubscriptionMutationVariables>;
export const DeleteBioDataDocument = /*#__PURE__*/ gql`
    mutation DeleteBioData($id: Int!) {
  delete_athlete_biometric_data_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteBioDataMutationFn = Apollo.MutationFunction<IDeleteBioDataMutation, IDeleteBioDataMutationVariables>;
export function useDeleteBioDataMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteBioDataMutation, IDeleteBioDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteBioDataMutation, IDeleteBioDataMutationVariables>(DeleteBioDataDocument, options);
      }
export type DeleteBioDataMutationHookResult = ReturnType<typeof useDeleteBioDataMutation>;
export type DeleteBioDataMutationResult = Apollo.MutationResult<IDeleteBioDataMutation>;
export type DeleteBioDataMutationOptions = Apollo.BaseMutationOptions<IDeleteBioDataMutation, IDeleteBioDataMutationVariables>;
export const DeleteAthleteChallengeDocument = /*#__PURE__*/ gql`
    mutation DeleteAthleteChallenge($id: Int!) {
  delete_athlete_challenge_by_pk(id: $id) {
    id
  }
}
    `;
export type IDeleteAthleteChallengeMutationFn = Apollo.MutationFunction<IDeleteAthleteChallengeMutation, IDeleteAthleteChallengeMutationVariables>;
export function useDeleteAthleteChallengeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteAthleteChallengeMutation, IDeleteAthleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteAthleteChallengeMutation, IDeleteAthleteChallengeMutationVariables>(DeleteAthleteChallengeDocument, options);
      }
export type DeleteAthleteChallengeMutationHookResult = ReturnType<typeof useDeleteAthleteChallengeMutation>;
export type DeleteAthleteChallengeMutationResult = Apollo.MutationResult<IDeleteAthleteChallengeMutation>;
export type DeleteAthleteChallengeMutationOptions = Apollo.BaseMutationOptions<IDeleteAthleteChallengeMutation, IDeleteAthleteChallengeMutationVariables>;
export const InsertAthleteChallengeDocument = /*#__PURE__*/ gql`
    mutation InsertAthleteChallenge($object: athlete_challenge_insert_input!) {
  insert_athlete_challenge_one(object: $object) {
    id
  }
}
    `;
export type IInsertAthleteChallengeMutationFn = Apollo.MutationFunction<IInsertAthleteChallengeMutation, IInsertAthleteChallengeMutationVariables>;
export function useInsertAthleteChallengeMutation(baseOptions?: Apollo.MutationHookOptions<IInsertAthleteChallengeMutation, IInsertAthleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertAthleteChallengeMutation, IInsertAthleteChallengeMutationVariables>(InsertAthleteChallengeDocument, options);
      }
export type InsertAthleteChallengeMutationHookResult = ReturnType<typeof useInsertAthleteChallengeMutation>;
export type InsertAthleteChallengeMutationResult = Apollo.MutationResult<IInsertAthleteChallengeMutation>;
export type InsertAthleteChallengeMutationOptions = Apollo.BaseMutationOptions<IInsertAthleteChallengeMutation, IInsertAthleteChallengeMutationVariables>;
export const InsertBiometricDataDocument = /*#__PURE__*/ gql`
    mutation InsertBiometricData($objects: [athlete_biometric_data_insert_input!]!) {
  insert_athlete_biometric_data(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type IInsertBiometricDataMutationFn = Apollo.MutationFunction<IInsertBiometricDataMutation, IInsertBiometricDataMutationVariables>;
export function useInsertBiometricDataMutation(baseOptions?: Apollo.MutationHookOptions<IInsertBiometricDataMutation, IInsertBiometricDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInsertBiometricDataMutation, IInsertBiometricDataMutationVariables>(InsertBiometricDataDocument, options);
      }
export type InsertBiometricDataMutationHookResult = ReturnType<typeof useInsertBiometricDataMutation>;
export type InsertBiometricDataMutationResult = Apollo.MutationResult<IInsertBiometricDataMutation>;
export type InsertBiometricDataMutationOptions = Apollo.BaseMutationOptions<IInsertBiometricDataMutation, IInsertBiometricDataMutationVariables>;
export const RecoverPasswordDocument = /*#__PURE__*/ gql`
    mutation RecoverPassword($email: String!) {
  recover_password(email: $email, type: ["user"])
}
    `;
export type IRecoverPasswordMutationFn = Apollo.MutationFunction<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>;
export function useRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>(RecoverPasswordDocument, options);
      }
export type RecoverPasswordMutationHookResult = ReturnType<typeof useRecoverPasswordMutation>;
export type RecoverPasswordMutationResult = Apollo.MutationResult<IRecoverPasswordMutation>;
export type RecoverPasswordMutationOptions = Apollo.BaseMutationOptions<IRecoverPasswordMutation, IRecoverPasswordMutationVariables>;
export const RegisterDocument = /*#__PURE__*/ gql`
    mutation Register($inputs: RegisterInput!) {
  user_register(inputs: $inputs) {
    success
  }
}
    `;
export type IRegisterMutationFn = Apollo.MutationFunction<IRegisterMutation, IRegisterMutationVariables>;
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<IRegisterMutation, IRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRegisterMutation, IRegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<IRegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<IRegisterMutation, IRegisterMutationVariables>;
export const RegisterCoachDocument = /*#__PURE__*/ gql`
    mutation RegisterCoach($inputs: RegisterCoachInput!) {
  coach_register(inputs: $inputs) {
    success
  }
}
    `;
export type IRegisterCoachMutationFn = Apollo.MutationFunction<IRegisterCoachMutation, IRegisterCoachMutationVariables>;
export function useRegisterCoachMutation(baseOptions?: Apollo.MutationHookOptions<IRegisterCoachMutation, IRegisterCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRegisterCoachMutation, IRegisterCoachMutationVariables>(RegisterCoachDocument, options);
      }
export type RegisterCoachMutationHookResult = ReturnType<typeof useRegisterCoachMutation>;
export type RegisterCoachMutationResult = Apollo.MutationResult<IRegisterCoachMutation>;
export type RegisterCoachMutationOptions = Apollo.BaseMutationOptions<IRegisterCoachMutation, IRegisterCoachMutationVariables>;
export const SetNewUserPasswordDocument = /*#__PURE__*/ gql`
    mutation SetNewUserPassword($password: String!, $token: String!) {
  set_new_user_password(password: $password, token: $token)
}
    `;
export type ISetNewUserPasswordMutationFn = Apollo.MutationFunction<ISetNewUserPasswordMutation, ISetNewUserPasswordMutationVariables>;
export function useSetNewUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ISetNewUserPasswordMutation, ISetNewUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISetNewUserPasswordMutation, ISetNewUserPasswordMutationVariables>(SetNewUserPasswordDocument, options);
      }
export type SetNewUserPasswordMutationHookResult = ReturnType<typeof useSetNewUserPasswordMutation>;
export type SetNewUserPasswordMutationResult = Apollo.MutationResult<ISetNewUserPasswordMutation>;
export type SetNewUserPasswordMutationOptions = Apollo.BaseMutationOptions<ISetNewUserPasswordMutation, ISetNewUserPasswordMutationVariables>;
export const UpdateAthleteDocument = /*#__PURE__*/ gql`
    mutation UpdateAthlete($id: Int!, $_set: athlete_set_input!) {
  update_athlete_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateAthleteMutationFn = Apollo.MutationFunction<IUpdateAthleteMutation, IUpdateAthleteMutationVariables>;
export function useUpdateAthleteMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteMutation, IUpdateAthleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteMutation, IUpdateAthleteMutationVariables>(UpdateAthleteDocument, options);
      }
export type UpdateAthleteMutationHookResult = ReturnType<typeof useUpdateAthleteMutation>;
export type UpdateAthleteMutationResult = Apollo.MutationResult<IUpdateAthleteMutation>;
export type UpdateAthleteMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteMutation, IUpdateAthleteMutationVariables>;
export const UpdateAthleteChallengeDocument = /*#__PURE__*/ gql`
    mutation UpdateAthleteChallenge($_set: athlete_challenge_set_input!, $id: Int!) {
  update_athlete_challenge_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type IUpdateAthleteChallengeMutationFn = Apollo.MutationFunction<IUpdateAthleteChallengeMutation, IUpdateAthleteChallengeMutationVariables>;
export function useUpdateAthleteChallengeMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateAthleteChallengeMutation, IUpdateAthleteChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateAthleteChallengeMutation, IUpdateAthleteChallengeMutationVariables>(UpdateAthleteChallengeDocument, options);
      }
export type UpdateAthleteChallengeMutationHookResult = ReturnType<typeof useUpdateAthleteChallengeMutation>;
export type UpdateAthleteChallengeMutationResult = Apollo.MutationResult<IUpdateAthleteChallengeMutation>;
export type UpdateAthleteChallengeMutationOptions = Apollo.BaseMutationOptions<IUpdateAthleteChallengeMutation, IUpdateAthleteChallengeMutationVariables>;
export const UpdateUserStravaAccessTokenDocument = /*#__PURE__*/ gql`
    mutation UpdateUserStravaAccessToken($id: Int!, $strava_access_token: String!) {
  update_user_by_pk(
    pk_columns: {id: $id}
    _set: {strava_access_token: $strava_access_token}
  ) {
    id
  }
}
    `;
export type IUpdateUserStravaAccessTokenMutationFn = Apollo.MutationFunction<IUpdateUserStravaAccessTokenMutation, IUpdateUserStravaAccessTokenMutationVariables>;
export function useUpdateUserStravaAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateUserStravaAccessTokenMutation, IUpdateUserStravaAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserStravaAccessTokenMutation, IUpdateUserStravaAccessTokenMutationVariables>(UpdateUserStravaAccessTokenDocument, options);
      }
export type UpdateUserStravaAccessTokenMutationHookResult = ReturnType<typeof useUpdateUserStravaAccessTokenMutation>;
export type UpdateUserStravaAccessTokenMutationResult = Apollo.MutationResult<IUpdateUserStravaAccessTokenMutation>;
export type UpdateUserStravaAccessTokenMutationOptions = Apollo.BaseMutationOptions<IUpdateUserStravaAccessTokenMutation, IUpdateUserStravaAccessTokenMutationVariables>;
export const UpsertAthleteWorkoutSectionsDocument = /*#__PURE__*/ gql`
    mutation UpsertAthleteWorkoutSections($athlete_workout_section_objects: [athlete_workout_section_insert_input!]!, $athlete_workout_id: Int!, $athlete_workout_object: athlete_workout_set_input!) {
  delete_athlete_workout_section(
    where: {athlete_workout_id: {_eq: $athlete_workout_id}}
  ) {
    affected_rows
  }
  insert_athlete_workout_section(
    objects: $athlete_workout_section_objects
    on_conflict: {constraint: athlete_workout_section_pkey, update_columns: [measured_speed, measured_max_heart_rate, measured_duration, measured_average_heart_rate]}
  ) {
    returning {
      id
    }
  }
  update_athlete_workout_by_pk(
    pk_columns: {id: $athlete_workout_id}
    _set: $athlete_workout_object
  ) {
    id
  }
}
    `;
export type IUpsertAthleteWorkoutSectionsMutationFn = Apollo.MutationFunction<IUpsertAthleteWorkoutSectionsMutation, IUpsertAthleteWorkoutSectionsMutationVariables>;
export function useUpsertAthleteWorkoutSectionsMutation(baseOptions?: Apollo.MutationHookOptions<IUpsertAthleteWorkoutSectionsMutation, IUpsertAthleteWorkoutSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpsertAthleteWorkoutSectionsMutation, IUpsertAthleteWorkoutSectionsMutationVariables>(UpsertAthleteWorkoutSectionsDocument, options);
      }
export type UpsertAthleteWorkoutSectionsMutationHookResult = ReturnType<typeof useUpsertAthleteWorkoutSectionsMutation>;
export type UpsertAthleteWorkoutSectionsMutationResult = Apollo.MutationResult<IUpsertAthleteWorkoutSectionsMutation>;
export type UpsertAthleteWorkoutSectionsMutationOptions = Apollo.BaseMutationOptions<IUpsertAthleteWorkoutSectionsMutation, IUpsertAthleteWorkoutSectionsMutationVariables>;
export const AthleteBaseInfoDocument = /*#__PURE__*/ gql`
    query AthleteBaseInfo {
  user {
    ...athleteBaseInfo
  }
}
    ${AthleteBaseInfoFragmentDoc}`;
export function useAthleteBaseInfoQuery(baseOptions?: Apollo.QueryHookOptions<IAthleteBaseInfoQuery, IAthleteBaseInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBaseInfoQuery, IAthleteBaseInfoQueryVariables>(AthleteBaseInfoDocument, options);
      }
export function useAthleteBaseInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBaseInfoQuery, IAthleteBaseInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBaseInfoQuery, IAthleteBaseInfoQueryVariables>(AthleteBaseInfoDocument, options);
        }
export type AthleteBaseInfoQueryHookResult = ReturnType<typeof useAthleteBaseInfoQuery>;
export type AthleteBaseInfoLazyQueryHookResult = ReturnType<typeof useAthleteBaseInfoLazyQuery>;
export type AthleteBaseInfoQueryResult = Apollo.QueryResult<IAthleteBaseInfoQuery, IAthleteBaseInfoQueryVariables>;
export const AthleteBioDataAndEvolutionDocument = /*#__PURE__*/ gql`
    query AthleteBioDataAndEvolution($id: Int!) {
  athlete_by_pk(id: $id) {
    ...athlete_bio_data_details
  }
}
    ${Athlete_Bio_Data_DetailsFragmentDoc}`;
export function useAthleteBioDataAndEvolutionQuery(baseOptions: Apollo.QueryHookOptions<IAthleteBioDataAndEvolutionQuery, IAthleteBioDataAndEvolutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteBioDataAndEvolutionQuery, IAthleteBioDataAndEvolutionQueryVariables>(AthleteBioDataAndEvolutionDocument, options);
      }
export function useAthleteBioDataAndEvolutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteBioDataAndEvolutionQuery, IAthleteBioDataAndEvolutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteBioDataAndEvolutionQuery, IAthleteBioDataAndEvolutionQueryVariables>(AthleteBioDataAndEvolutionDocument, options);
        }
export type AthleteBioDataAndEvolutionQueryHookResult = ReturnType<typeof useAthleteBioDataAndEvolutionQuery>;
export type AthleteBioDataAndEvolutionLazyQueryHookResult = ReturnType<typeof useAthleteBioDataAndEvolutionLazyQuery>;
export type AthleteBioDataAndEvolutionQueryResult = Apollo.QueryResult<IAthleteBioDataAndEvolutionQuery, IAthleteBioDataAndEvolutionQueryVariables>;
export const AthleteChallengesDocument = /*#__PURE__*/ gql`
    query AthleteChallenges($id: Int!) {
  athlete_by_pk(id: $id) {
    id
    athlete_challenges(order_by: {created_at: desc}) {
      ...athlete_challenge
      sport_id
      athlete_id
      notes
    }
  }
}
    ${Athlete_ChallengeFragmentDoc}`;
export function useAthleteChallengesQuery(baseOptions: Apollo.QueryHookOptions<IAthleteChallengesQuery, IAthleteChallengesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteChallengesQuery, IAthleteChallengesQueryVariables>(AthleteChallengesDocument, options);
      }
export function useAthleteChallengesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteChallengesQuery, IAthleteChallengesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteChallengesQuery, IAthleteChallengesQueryVariables>(AthleteChallengesDocument, options);
        }
export type AthleteChallengesQueryHookResult = ReturnType<typeof useAthleteChallengesQuery>;
export type AthleteChallengesLazyQueryHookResult = ReturnType<typeof useAthleteChallengesLazyQuery>;
export type AthleteChallengesQueryResult = Apollo.QueryResult<IAthleteChallengesQuery, IAthleteChallengesQueryVariables>;
export const AthleteChallengesDataDocument = /*#__PURE__*/ gql`
    query AthleteChallengesData($athlete_id: Int!) {
  athlete_by_pk(id: $athlete_id) {
    athlete_challenges(
      where: {is_main: {_eq: true}, completed_at: {_is_null: true}}
      order_by: {date: desc}
    ) {
      description
      date
      time_goal_hours
      time_goal_minutes
      positive_univeness
      negative_univeness
      cumulated_univeness
      distance
    }
  }
}
    `;
export function useAthleteChallengesDataQuery(baseOptions: Apollo.QueryHookOptions<IAthleteChallengesDataQuery, IAthleteChallengesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteChallengesDataQuery, IAthleteChallengesDataQueryVariables>(AthleteChallengesDataDocument, options);
      }
export function useAthleteChallengesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteChallengesDataQuery, IAthleteChallengesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteChallengesDataQuery, IAthleteChallengesDataQueryVariables>(AthleteChallengesDataDocument, options);
        }
export type AthleteChallengesDataQueryHookResult = ReturnType<typeof useAthleteChallengesDataQuery>;
export type AthleteChallengesDataLazyQueryHookResult = ReturnType<typeof useAthleteChallengesDataLazyQuery>;
export type AthleteChallengesDataQueryResult = Apollo.QueryResult<IAthleteChallengesDataQuery, IAthleteChallengesDataQueryVariables>;
export const AthleteHasAccessDocument = /*#__PURE__*/ gql`
    query AthleteHasAccess($athlete_id: Int!) {
  check_if_athlete_has_access(athlete_id: $athlete_id) {
    success
    message
  }
}
    `;
export function useAthleteHasAccessQuery(baseOptions: Apollo.QueryHookOptions<IAthleteHasAccessQuery, IAthleteHasAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteHasAccessQuery, IAthleteHasAccessQueryVariables>(AthleteHasAccessDocument, options);
      }
export function useAthleteHasAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteHasAccessQuery, IAthleteHasAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteHasAccessQuery, IAthleteHasAccessQueryVariables>(AthleteHasAccessDocument, options);
        }
export type AthleteHasAccessQueryHookResult = ReturnType<typeof useAthleteHasAccessQuery>;
export type AthleteHasAccessLazyQueryHookResult = ReturnType<typeof useAthleteHasAccessLazyQuery>;
export type AthleteHasAccessQueryResult = Apollo.QueryResult<IAthleteHasAccessQuery, IAthleteHasAccessQueryVariables>;
export const AthleteWorkoutSectionsDocument = /*#__PURE__*/ gql`
    query AthleteWorkoutSections($workouts_ids: [Int!], $athlete_id: Int!) {
  current_weight: athlete_biometric_data(
    where: {athlete_id: {_eq: $athlete_id}, biometric_parameter_id: {_eq: "WEIGHT"}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    value
  }
  athlete_workout(where: {id: {_in: $workouts_ids}}) {
    ...athlete_workout_sections_only
  }
}
    ${Athlete_Workout_Sections_OnlyFragmentDoc}`;
export function useAthleteWorkoutSectionsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteWorkoutSectionsQuery, IAthleteWorkoutSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteWorkoutSectionsQuery, IAthleteWorkoutSectionsQueryVariables>(AthleteWorkoutSectionsDocument, options);
      }
export function useAthleteWorkoutSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteWorkoutSectionsQuery, IAthleteWorkoutSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteWorkoutSectionsQuery, IAthleteWorkoutSectionsQueryVariables>(AthleteWorkoutSectionsDocument, options);
        }
export type AthleteWorkoutSectionsQueryHookResult = ReturnType<typeof useAthleteWorkoutSectionsQuery>;
export type AthleteWorkoutSectionsLazyQueryHookResult = ReturnType<typeof useAthleteWorkoutSectionsLazyQuery>;
export type AthleteWorkoutSectionsQueryResult = Apollo.QueryResult<IAthleteWorkoutSectionsQuery, IAthleteWorkoutSectionsQueryVariables>;
export const AthleteWorkoutsDocument = /*#__PURE__*/ gql`
    query AthleteWorkouts($athlete_id: Int!, $start_date: date!, $end_date: date!) {
  athlete_week(
    where: {athlete_block: {athlete_id: {_eq: $athlete_id}}, start_date: {_gte: $start_date, _lte: $end_date}}
    order_by: {start_date: asc}
  ) {
    ...full_athlete_week
  }
}
    ${Full_Athlete_WeekFragmentDoc}`;
export function useAthleteWorkoutsQuery(baseOptions: Apollo.QueryHookOptions<IAthleteWorkoutsQuery, IAthleteWorkoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IAthleteWorkoutsQuery, IAthleteWorkoutsQueryVariables>(AthleteWorkoutsDocument, options);
      }
export function useAthleteWorkoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IAthleteWorkoutsQuery, IAthleteWorkoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IAthleteWorkoutsQuery, IAthleteWorkoutsQueryVariables>(AthleteWorkoutsDocument, options);
        }
export type AthleteWorkoutsQueryHookResult = ReturnType<typeof useAthleteWorkoutsQuery>;
export type AthleteWorkoutsLazyQueryHookResult = ReturnType<typeof useAthleteWorkoutsLazyQuery>;
export type AthleteWorkoutsQueryResult = Apollo.QueryResult<IAthleteWorkoutsQuery, IAthleteWorkoutsQueryVariables>;
export const CalendarWorkoutDatesDocument = /*#__PURE__*/ gql`
    query CalendarWorkoutDates($athlete_id: Int!, $start_date: date!, $end_date: date!) {
  athlete_by_pk(id: $athlete_id) {
    athlete_blocks(
      where: {athlete_weeks: {athlete_workouts: {date: {_gte: $start_date, _lte: $end_date}}}}
    ) {
      athlete_weeks(
        where: {athlete_workouts: {date: {_gte: $start_date, _lte: $end_date}}}
      ) {
        start_date
        athlete_workouts(where: {date: {_gte: $start_date, _lte: $end_date}}) {
          date
        }
      }
    }
  }
}
    `;
export function useCalendarWorkoutDatesQuery(baseOptions: Apollo.QueryHookOptions<ICalendarWorkoutDatesQuery, ICalendarWorkoutDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICalendarWorkoutDatesQuery, ICalendarWorkoutDatesQueryVariables>(CalendarWorkoutDatesDocument, options);
      }
export function useCalendarWorkoutDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICalendarWorkoutDatesQuery, ICalendarWorkoutDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICalendarWorkoutDatesQuery, ICalendarWorkoutDatesQueryVariables>(CalendarWorkoutDatesDocument, options);
        }
export type CalendarWorkoutDatesQueryHookResult = ReturnType<typeof useCalendarWorkoutDatesQuery>;
export type CalendarWorkoutDatesLazyQueryHookResult = ReturnType<typeof useCalendarWorkoutDatesLazyQuery>;
export type CalendarWorkoutDatesQueryResult = Apollo.QueryResult<ICalendarWorkoutDatesQuery, ICalendarWorkoutDatesQueryVariables>;
export const CoachPageDocument = /*#__PURE__*/ gql`
    query CoachPage($id: Int!) {
  coach_by_pk(id: $id) {
    ...coach
  }
}
    ${CoachFragmentDoc}`;
export function useCoachPageQuery(baseOptions: Apollo.QueryHookOptions<ICoachPageQuery, ICoachPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoachPageQuery, ICoachPageQueryVariables>(CoachPageDocument, options);
      }
export function useCoachPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoachPageQuery, ICoachPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoachPageQuery, ICoachPageQueryVariables>(CoachPageDocument, options);
        }
export type CoachPageQueryHookResult = ReturnType<typeof useCoachPageQuery>;
export type CoachPageLazyQueryHookResult = ReturnType<typeof useCoachPageLazyQuery>;
export type CoachPageQueryResult = Apollo.QueryResult<ICoachPageQuery, ICoachPageQueryVariables>;
export const CoachesListDocument = /*#__PURE__*/ gql`
    query CoachesList {
  coach(where: {is_verified: {_eq: true}}) {
    ...coach
  }
}
    ${CoachFragmentDoc}`;
export function useCoachesListQuery(baseOptions?: Apollo.QueryHookOptions<ICoachesListQuery, ICoachesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICoachesListQuery, ICoachesListQueryVariables>(CoachesListDocument, options);
      }
export function useCoachesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICoachesListQuery, ICoachesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICoachesListQuery, ICoachesListQueryVariables>(CoachesListDocument, options);
        }
export type CoachesListQueryHookResult = ReturnType<typeof useCoachesListQuery>;
export type CoachesListLazyQueryHookResult = ReturnType<typeof useCoachesListLazyQuery>;
export type CoachesListQueryResult = Apollo.QueryResult<ICoachesListQuery, ICoachesListQueryVariables>;
export const CreateStripeCheckoutUrlDocument = /*#__PURE__*/ gql`
    query CreateStripeCheckoutUrl($stripe_price_id: String!, $email: String, $customer: String, $email_language: String) {
  create_stripe_checkout_url(
    stripe_price_id: $stripe_price_id
    email: $email
    customer: $customer
    email_language: $email_language
  )
}
    `;
export function useCreateStripeCheckoutUrlQuery(baseOptions: Apollo.QueryHookOptions<ICreateStripeCheckoutUrlQuery, ICreateStripeCheckoutUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ICreateStripeCheckoutUrlQuery, ICreateStripeCheckoutUrlQueryVariables>(CreateStripeCheckoutUrlDocument, options);
      }
export function useCreateStripeCheckoutUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ICreateStripeCheckoutUrlQuery, ICreateStripeCheckoutUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ICreateStripeCheckoutUrlQuery, ICreateStripeCheckoutUrlQueryVariables>(CreateStripeCheckoutUrlDocument, options);
        }
export type CreateStripeCheckoutUrlQueryHookResult = ReturnType<typeof useCreateStripeCheckoutUrlQuery>;
export type CreateStripeCheckoutUrlLazyQueryHookResult = ReturnType<typeof useCreateStripeCheckoutUrlLazyQuery>;
export type CreateStripeCheckoutUrlQueryResult = Apollo.QueryResult<ICreateStripeCheckoutUrlQuery, ICreateStripeCheckoutUrlQueryVariables>;
export const HomePageDocument = /*#__PURE__*/ gql`
    query HomePage {
  sport {
    ...sport
    subscription_plans {
      ...subscription_plan
    }
  }
  review {
    ...review
  }
}
    ${SportFragmentDoc}
${Subscription_PlanFragmentDoc}
${ReviewFragmentDoc}`;
export function useHomePageQuery(baseOptions?: Apollo.QueryHookOptions<IHomePageQuery, IHomePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IHomePageQuery, IHomePageQueryVariables>(HomePageDocument, options);
      }
export function useHomePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IHomePageQuery, IHomePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IHomePageQuery, IHomePageQueryVariables>(HomePageDocument, options);
        }
export type HomePageQueryHookResult = ReturnType<typeof useHomePageQuery>;
export type HomePageLazyQueryHookResult = ReturnType<typeof useHomePageLazyQuery>;
export type HomePageQueryResult = Apollo.QueryResult<IHomePageQuery, IHomePageQueryVariables>;
export const IsEmailAvailableDocument = /*#__PURE__*/ gql`
    query IsEmailAvailable($email: String!) {
  is_email_available(email: $email)
}
    `;
export function useIsEmailAvailableQuery(baseOptions: Apollo.QueryHookOptions<IIsEmailAvailableQuery, IIsEmailAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IIsEmailAvailableQuery, IIsEmailAvailableQueryVariables>(IsEmailAvailableDocument, options);
      }
export function useIsEmailAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IIsEmailAvailableQuery, IIsEmailAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IIsEmailAvailableQuery, IIsEmailAvailableQueryVariables>(IsEmailAvailableDocument, options);
        }
export type IsEmailAvailableQueryHookResult = ReturnType<typeof useIsEmailAvailableQuery>;
export type IsEmailAvailableLazyQueryHookResult = ReturnType<typeof useIsEmailAvailableLazyQuery>;
export type IsEmailAvailableQueryResult = Apollo.QueryResult<IIsEmailAvailableQuery, IIsEmailAvailableQueryVariables>;
export const LocalesListDocument = /*#__PURE__*/ gql`
    query LocalesList {
  locale {
    id
    code
    language
  }
}
    `;
export function useLocalesListQuery(baseOptions?: Apollo.QueryHookOptions<ILocalesListQuery, ILocalesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILocalesListQuery, ILocalesListQueryVariables>(LocalesListDocument, options);
      }
export function useLocalesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILocalesListQuery, ILocalesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILocalesListQuery, ILocalesListQueryVariables>(LocalesListDocument, options);
        }
export type LocalesListQueryHookResult = ReturnType<typeof useLocalesListQuery>;
export type LocalesListLazyQueryHookResult = ReturnType<typeof useLocalesListLazyQuery>;
export type LocalesListQueryResult = Apollo.QueryResult<ILocalesListQuery, ILocalesListQueryVariables>;
export const ProfileDocument = /*#__PURE__*/ gql`
    query Profile($id: Int!) {
  athlete_by_pk(id: $id) {
    ...athlete_details
    subscriptions(order_by: {status: asc, date_end: desc}) {
      ...subscription
    }
  }
}
    ${Athlete_DetailsFragmentDoc}
${SubscriptionFragmentDoc}`;
export function useProfileQuery(baseOptions: Apollo.QueryHookOptions<IProfileQuery, IProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IProfileQuery, IProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IProfileQuery, IProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IProfileQuery, IProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<IProfileQuery, IProfileQueryVariables>;
export const SportByPkDocument = /*#__PURE__*/ gql`
    query SportByPk($id: name!) {
  sport_by_pk(id: $id) {
    id
    name
    avatar
    image
    sport_translations {
      id
      title
      description
      locale {
        id
        code
        language
      }
    }
    coaches {
      coach {
        ...sportCoach
      }
    }
  }
}
    ${SportCoachFragmentDoc}`;
export function useSportByPkQuery(baseOptions: Apollo.QueryHookOptions<ISportByPkQuery, ISportByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISportByPkQuery, ISportByPkQueryVariables>(SportByPkDocument, options);
      }
export function useSportByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISportByPkQuery, ISportByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISportByPkQuery, ISportByPkQueryVariables>(SportByPkDocument, options);
        }
export type SportByPkQueryHookResult = ReturnType<typeof useSportByPkQuery>;
export type SportByPkLazyQueryHookResult = ReturnType<typeof useSportByPkLazyQuery>;
export type SportByPkQueryResult = Apollo.QueryResult<ISportByPkQuery, ISportByPkQueryVariables>;
export const SportsListDocument = /*#__PURE__*/ gql`
    query SportsList {
  sport {
    id
    name
    avatar
    sport_translations {
      id
      title
      description
      locale {
        id
        code
        language
      }
    }
  }
}
    `;
export function useSportsListQuery(baseOptions?: Apollo.QueryHookOptions<ISportsListQuery, ISportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISportsListQuery, ISportsListQueryVariables>(SportsListDocument, options);
      }
export function useSportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISportsListQuery, ISportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISportsListQuery, ISportsListQueryVariables>(SportsListDocument, options);
        }
export type SportsListQueryHookResult = ReturnType<typeof useSportsListQuery>;
export type SportsListLazyQueryHookResult = ReturnType<typeof useSportsListLazyQuery>;
export type SportsListQueryResult = Apollo.QueryResult<ISportsListQuery, ISportsListQueryVariables>;
export const StatsWorkoutDataDocument = /*#__PURE__*/ gql`
    query StatsWorkoutData($athlete_id: Int!, $start_date: date!, $end_date: date!) {
  workout_type {
    id
    avatar
    workout_type_translations {
      name
      locale {
        code
      }
    }
  }
  athlete_by_pk(id: $athlete_id) {
    athlete_profile {
      ...stats_athlete_profile
    }
    athlete_blocks(
      where: {athlete_weeks: {athlete_workouts: {date: {_gte: $start_date, _lte: $end_date}}}}
    ) {
      athlete_weeks(
        where: {athlete_workouts: {date: {_gte: $start_date, _lte: $end_date}}}
      ) {
        start_date
        end_date
        athlete_workouts(where: {date: {_gte: $start_date, _lte: $end_date}}) {
          ...stats_athlete_workout
        }
      }
    }
  }
}
    ${Stats_Athlete_ProfileFragmentDoc}
${Stats_Athlete_WorkoutFragmentDoc}`;
export function useStatsWorkoutDataQuery(baseOptions: Apollo.QueryHookOptions<IStatsWorkoutDataQuery, IStatsWorkoutDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStatsWorkoutDataQuery, IStatsWorkoutDataQueryVariables>(StatsWorkoutDataDocument, options);
      }
export function useStatsWorkoutDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStatsWorkoutDataQuery, IStatsWorkoutDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStatsWorkoutDataQuery, IStatsWorkoutDataQueryVariables>(StatsWorkoutDataDocument, options);
        }
export type StatsWorkoutDataQueryHookResult = ReturnType<typeof useStatsWorkoutDataQuery>;
export type StatsWorkoutDataLazyQueryHookResult = ReturnType<typeof useStatsWorkoutDataLazyQuery>;
export type StatsWorkoutDataQueryResult = Apollo.QueryResult<IStatsWorkoutDataQuery, IStatsWorkoutDataQueryVariables>;
export const SubscriptionPlanByPkDocument = /*#__PURE__*/ gql`
    query SubscriptionPlanByPk($id: Int!) {
  subscription_plan_by_pk(id: $id) {
    id
    level
    image
    min_duration
    recomended_duration
    weekly_price
    quarterly_discount
    biannualy_discount
    yearly_discount
    created_at
    stripe_product_id
    sport {
      id
      sport_translations {
        id
        title
        locale {
          id
          code
          language
        }
      }
    }
    coach {
      id
      name
    }
    subscription_plan_prices {
      interval_count
      unit_amount
      id
      subscription_plan_id
      stripe_price_id
      stripe_lookup_key
    }
    subscription_plan_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
  }
}
    `;
export function useSubscriptionPlanByPkQuery(baseOptions: Apollo.QueryHookOptions<ISubscriptionPlanByPkQuery, ISubscriptionPlanByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPlanByPkQuery, ISubscriptionPlanByPkQueryVariables>(SubscriptionPlanByPkDocument, options);
      }
export function useSubscriptionPlanByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPlanByPkQuery, ISubscriptionPlanByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPlanByPkQuery, ISubscriptionPlanByPkQueryVariables>(SubscriptionPlanByPkDocument, options);
        }
export type SubscriptionPlanByPkQueryHookResult = ReturnType<typeof useSubscriptionPlanByPkQuery>;
export type SubscriptionPlanByPkLazyQueryHookResult = ReturnType<typeof useSubscriptionPlanByPkLazyQuery>;
export type SubscriptionPlanByPkQueryResult = Apollo.QueryResult<ISubscriptionPlanByPkQuery, ISubscriptionPlanByPkQueryVariables>;
export const SubscriptionPlansListDocument = /*#__PURE__*/ gql`
    query SubscriptionPlansList($where: subscription_plan_bool_exp) {
  subscription_plan(where: $where, order_by: {level: asc}) {
    id
    level
    coach {
      id
      name
    }
    sport {
      id
      name
      sport_translations {
        id
        title
        locale {
          id
          code
          language
        }
      }
    }
    is_verified
    image
    recomended_duration
    weekly_price
    created_at
    stripe_product_id
    subscription_plan_prices {
      interval_count
      unit_amount
      id
      subscription_plan_id
      stripe_price_id
    }
    subscription_plan_translations {
      id
      description
      locale {
        id
        code
        language
      }
    }
  }
}
    `;
export function useSubscriptionPlansListQuery(baseOptions?: Apollo.QueryHookOptions<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>(SubscriptionPlansListDocument, options);
      }
export function useSubscriptionPlansListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>(SubscriptionPlansListDocument, options);
        }
export type SubscriptionPlansListQueryHookResult = ReturnType<typeof useSubscriptionPlansListQuery>;
export type SubscriptionPlansListLazyQueryHookResult = ReturnType<typeof useSubscriptionPlansListLazyQuery>;
export type SubscriptionPlansListQueryResult = Apollo.QueryResult<ISubscriptionPlansListQuery, ISubscriptionPlansListQueryVariables>;
export const UserStravaAccessTokenDocument = /*#__PURE__*/ gql`
    query UserStravaAccessToken($id: Int!) {
  user_by_pk(id: $id) {
    strava_access_token
  }
}
    `;
export function useUserStravaAccessTokenQuery(baseOptions: Apollo.QueryHookOptions<IUserStravaAccessTokenQuery, IUserStravaAccessTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserStravaAccessTokenQuery, IUserStravaAccessTokenQueryVariables>(UserStravaAccessTokenDocument, options);
      }
export function useUserStravaAccessTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserStravaAccessTokenQuery, IUserStravaAccessTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserStravaAccessTokenQuery, IUserStravaAccessTokenQueryVariables>(UserStravaAccessTokenDocument, options);
        }
export type UserStravaAccessTokenQueryHookResult = ReturnType<typeof useUserStravaAccessTokenQuery>;
export type UserStravaAccessTokenLazyQueryHookResult = ReturnType<typeof useUserStravaAccessTokenLazyQuery>;
export type UserStravaAccessTokenQueryResult = Apollo.QueryResult<IUserStravaAccessTokenQuery, IUserStravaAccessTokenQueryVariables>;
export const WorkoutCircuitsDocument = /*#__PURE__*/ gql`
    query WorkoutCircuits($workout_id: Int!) {
  athlete_workout_by_pk(id: $workout_id) {
    id
    stretching_circuit {
      id
      type
      circuit_exercises {
        ...circuit_exercise
      }
    }
    weight_circuit {
      id
      type
      circuit_exercises {
        ...circuit_exercise
      }
    }
  }
}
    ${Circuit_ExerciseFragmentDoc}`;
export function useWorkoutCircuitsQuery(baseOptions: Apollo.QueryHookOptions<IWorkoutCircuitsQuery, IWorkoutCircuitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutCircuitsQuery, IWorkoutCircuitsQueryVariables>(WorkoutCircuitsDocument, options);
      }
export function useWorkoutCircuitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutCircuitsQuery, IWorkoutCircuitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutCircuitsQuery, IWorkoutCircuitsQueryVariables>(WorkoutCircuitsDocument, options);
        }
export type WorkoutCircuitsQueryHookResult = ReturnType<typeof useWorkoutCircuitsQuery>;
export type WorkoutCircuitsLazyQueryHookResult = ReturnType<typeof useWorkoutCircuitsLazyQuery>;
export type WorkoutCircuitsQueryResult = Apollo.QueryResult<IWorkoutCircuitsQuery, IWorkoutCircuitsQueryVariables>;
export const WorkoutDetailsForDateDocument = /*#__PURE__*/ gql`
    query WorkoutDetailsForDate($athlete_id: Int!, $date: date!) {
  athlete_by_pk(id: $athlete_id) {
    max_heart_rate: athlete_biometric_data(
      where: {biometric_parameter_id: {_eq: "MAX_HEART_RATE"}}
      order_by: {created_at: desc}
      limit: 1
    ) {
      value
    }
    athlete_profile {
      ...stats_athlete_profile
    }
  }
  athlete_workouts: athlete_workout(
    where: {_and: [{athlete_week: {athlete_block: {athlete_id: {_eq: $athlete_id}}}}, {date: {_eq: $date}}]}
    order_by: {date: asc}
  ) {
    ...client_athlete_workout
  }
}
    ${Stats_Athlete_ProfileFragmentDoc}
${Client_Athlete_WorkoutFragmentDoc}`;
export function useWorkoutDetailsForDateQuery(baseOptions: Apollo.QueryHookOptions<IWorkoutDetailsForDateQuery, IWorkoutDetailsForDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutDetailsForDateQuery, IWorkoutDetailsForDateQueryVariables>(WorkoutDetailsForDateDocument, options);
      }
export function useWorkoutDetailsForDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutDetailsForDateQuery, IWorkoutDetailsForDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutDetailsForDateQuery, IWorkoutDetailsForDateQueryVariables>(WorkoutDetailsForDateDocument, options);
        }
export type WorkoutDetailsForDateQueryHookResult = ReturnType<typeof useWorkoutDetailsForDateQuery>;
export type WorkoutDetailsForDateLazyQueryHookResult = ReturnType<typeof useWorkoutDetailsForDateLazyQuery>;
export type WorkoutDetailsForDateQueryResult = Apollo.QueryResult<IWorkoutDetailsForDateQuery, IWorkoutDetailsForDateQueryVariables>;
export const WorkoutZoneListDocument = /*#__PURE__*/ gql`
    query WorkoutZoneList {
  workout_zone {
    id
    name
  }
}
    `;
export function useWorkoutZoneListQuery(baseOptions?: Apollo.QueryHookOptions<IWorkoutZoneListQuery, IWorkoutZoneListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IWorkoutZoneListQuery, IWorkoutZoneListQueryVariables>(WorkoutZoneListDocument, options);
      }
export function useWorkoutZoneListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IWorkoutZoneListQuery, IWorkoutZoneListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IWorkoutZoneListQuery, IWorkoutZoneListQueryVariables>(WorkoutZoneListDocument, options);
        }
export type WorkoutZoneListQueryHookResult = ReturnType<typeof useWorkoutZoneListQuery>;
export type WorkoutZoneListLazyQueryHookResult = ReturnType<typeof useWorkoutZoneListLazyQuery>;
export type WorkoutZoneListQueryResult = Apollo.QueryResult<IWorkoutZoneListQuery, IWorkoutZoneListQueryVariables>;
export const GetAthleteStressDataDocument = /*#__PURE__*/ gql`
    query GetAthleteStressData($athleteId: Int!, $startDate: date!, $endDate: date!) {
  athlete_workout(
    where: {date: {_gte: $startDate, _lte: $endDate}, athlete_week: {athlete_block: {athlete_id: {_eq: $athleteId}}}}
    order_by: {date: asc}
  ) {
    id
    date
    athlete_week_id
    athlete_workout_sections {
      id
      executed_stress_score
    }
  }
}
    `;
export function useGetAthleteStressDataQuery(baseOptions: Apollo.QueryHookOptions<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>(GetAthleteStressDataDocument, options);
      }
export function useGetAthleteStressDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>(GetAthleteStressDataDocument, options);
        }
export type GetAthleteStressDataQueryHookResult = ReturnType<typeof useGetAthleteStressDataQuery>;
export type GetAthleteStressDataLazyQueryHookResult = ReturnType<typeof useGetAthleteStressDataLazyQuery>;
export type GetAthleteStressDataQueryResult = Apollo.QueryResult<IGetAthleteStressDataQuery, IGetAthleteStressDataQueryVariables>;
export const StatsAthleteDashboardDocument = /*#__PURE__*/ gql`
    query StatsAthleteDashboard($athleteId: Int!) {
  athlete_by_pk(id: $athleteId) {
    athlete_profile {
      ...stats_athlete_profile
    }
    athlete_biometric_data(order_by: {created_at: asc}) {
      ...stats_biometric_data
    }
    athlete_blocks(order_by: {start_date: desc}) {
      athlete_weeks {
        ...stats_athlete_week
      }
    }
  }
}
    ${Stats_Athlete_ProfileFragmentDoc}
${Stats_Biometric_DataFragmentDoc}
${Stats_Athlete_WeekFragmentDoc}`;
export function useStatsAthleteDashboardQuery(baseOptions: Apollo.QueryHookOptions<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>(StatsAthleteDashboardDocument, options);
      }
export function useStatsAthleteDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>(StatsAthleteDashboardDocument, options);
        }
export type StatsAthleteDashboardQueryHookResult = ReturnType<typeof useStatsAthleteDashboardQuery>;
export type StatsAthleteDashboardLazyQueryHookResult = ReturnType<typeof useStatsAthleteDashboardLazyQuery>;
export type StatsAthleteDashboardQueryResult = Apollo.QueryResult<IStatsAthleteDashboardQuery, IStatsAthleteDashboardQueryVariables>;